export const casinoTypes = {
  // This below key is used as type "casino"
  casino: {
    // This below key is used as provider "evolution"
    evolution: {
      // This below keys are used as category "baccarattab"
      hotGames: [
        {
          href: "/casino/aggapevolutiongaming-super-sic-bo-u9412",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "sicbo",
          imgUrl: "/images/casino/evolution/sicbo/SuperSicBo.webp",
          alt: "Super Sic Bo",
          name: "Super Sic Bo",
        },
        {
          href: "/casino/aggapevolutiongaming-speed-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/SpeedRoulette.webp",
          alt: "Speed Roulette",
          name: "Speed Roulette",
        },
        {
          href: "/casino/ezgevo-immersive-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/ImmersiveRoulette.webp",
          alt: "Immersive Roulette",
          name: "Immersive Roulette",
        },
        {
          href: "/casino/ezgevo-speed-auto-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/SpeedAutoRoulette.webp",
          alt: "Speed Auto Roulette",
          name: "Speed Auto Roulette",
        },
        {
          href: "/casino/aggapevolutiongaming-2-hand-casino-holdem-u4167",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/2HandCasinoHoldem.webp",
          alt: "2 Hand Casino Holdem",
          name: "2 Hand Casino Holdem",
        },
        {
          href: "/casino/aggapevolutiongaming-casino-holdem-u1637",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/CasinoHoldem.webp",
          alt: "Casino Hold'em-EVO",
          name: "Casino Hold'em-EVO",
        },
        {
          href: "/casino/ezgevo-american-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/AmericanRoulette.webp",
          alt: "American Roulette",
          name: "American Roulette",
        },
        {
          href: "/casino/ezgevo-speed-auto-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/SpeedAutoRoulette.webp",
          alt: "Speed Auto Roulette",
          name: "Speed Auto Roulette",
        },
      ],
      baccarattab: [
        {
          href: "/casino/aggapevolutiongaming-speed-baccarat-a-u5232",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/BaccaratA.webp",
          alt: "Baccarat A",
          name: "Baccarat A",
        },
        {
          href: "/casino/aggapevolutiongaming-speed-baccarat-b-u2623",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/BaccaratB.webp",
          alt: "Baccarat B",
          name: "Baccarat B",
        },
        {
          href: "/casino/aggapevolutiongaming-speed-baccarat-c-u9120",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/BaccaratC.webp",
          alt: "Baccarat C",
          name: "Baccarat C",
        },
        {
          href: "/casino/aggapevolutiongaming-baccarat-control-squeeze-u4539",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/BaccaratControlSqueeze.webp",
          alt: "Baccarat Control Squeeze",
          name: "Baccarat Control Squeeze",
        },
        {
          href: "/casino/aggapevolutiongaming-baccarat-squeeze",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/BaccaratSqueeze.webp",
          alt: "Baccarat Squeeze",
          name: "Baccarat Squeeze",
        },
        {
          href: "/casino/aggapevolutiongaming-first-person-baccarat-u3705",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/FirstPersonBaccarat.webp",
          alt: "First Person Baccarat",
          name: "First Person Baccarat",
        },
        {
          href: "/casino/aggapevolutiongaming-first-person-golden-wealth-baccarat-u3550",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl:
            "/images/casino/evolution/baccarat/FirstPersonGoldenWealthBaccarat.webp",
          alt: "First Person Golden Wealth Baccarat",
          name: "First Person Golden Wealth Baccarat",
        },
        {
          href: "/casino/aggapevolutiongaming-first-person-lightning-baccarat-u7174",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl:
            "/images/casino/evolution/baccarat/FirstPersonLightningBaccarat.webp",
          alt: "First Person Lightning Baccarat",
          name: "First Person Lightning Baccarat",
        },
        {
          href: "/casino/aggapevolutiongaming-golden-wealth-baccarat-u3543",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/GoldenWealthBaccarat.webp",
          alt: "Golden Wealth Baccarat",
          name: "Golden Wealth Baccarat",
        },
        {
          href: "/casino/aggapevolutiongaming-lightning-baccarat",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/LightningBaccarat.webp",
          alt: "Lightning Baccarat",
          name: "Lightning Baccarat",
        },
        {
          href: "/casino/aggapevolutiongaming-no-commission-baccarat-u1208",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/evolution/baccarat/NoCommissionBaccarat.webp",
          alt: "No Commission Baccarat",
          name: "No Commission Baccarat",
        },
      ],
      TeenPattitab: [
        {
          href: "/casino/aggapevolutiongaming-2-hand-casino-holdem-u4167",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/2HandCasinoHoldem.webp",
          alt: "2 Hand Casino Holdem",
          name: "2 Hand Casino Holdem",
        },
        {
          href: "/casino/aggapevolutiongaming-casino-holdem-u1637",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/CasinoHoldem.webp",
          alt: "Casino Hold'em-EVO",
          name: "Casino Hold'em-EVO",
        },
        {
          href: "/casino/aggapevolutiongaming-football-studio",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/FootballStudio.webp",
          alt: "Football studio",
          name: "Football studio",
        },
        {
          href: "/casino/aggapevolutiongaming-texas-holdem-bonus-poker",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/TexasHoldemBonusPoker.webp",
          alt: "Texas Hold'em Bonus Poker",
          name: "Texas Hold'em Bonus Poker",
        },
        {
          href: "/casino/aggapevolutiongaming-three-card-poker",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/ThreeCardPoker.webp",
          alt: "Three Card Pokerr",
          name: "Three Card Pokerr",
        },
        {
          href: "/casino/aggapevolutiongaming-ultimate-texas-holdem",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "poker",
          imgUrl: "/images/casino/evolution/poker/UltimateTexasHoldem.webp",
          alt: "Ultimate Texas Holdem",
          name: "Ultimate Texas Holdem",
        },
      ],
      Blackjacktab: [
        {
          href: "/casino/aggapevolutiongaming-blackjack-silver-a-u7464",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverA.webp",
          alt: "Blackjack Silver A",
          name: "Blackjack Silver A",
        },
        {
          href: "/casino/aggapevolutiongaming-blackjack-silver-d-u3386",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverD.webp",
          alt: "Blackjack Silver D",
          name: "Blackjack Silver D",
        },
        {
          href: "/casino/aggapevolutiongaming-blackjack-silver-f",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverF.webp",
          alt: "Blackjack Silver F",
          name: "Blackjack Silver F",
        },
        {
          href: "/casino/aggapevolutiongaming-blackjack-silver-g-u1601",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverG.webp",
          alt: "Blackjack Silver G",
          name: "Blackjack Silver G",
        },
        {
          href: "/casino/aggapevolutiongaming-blackjack-vip-1-u8410",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP1.webp",
          alt: "Blackjack VIP 1",
          name: "Blackjack VIP 1",
        },
        {
          href: "/casino/aggapevolutiongaming-blackjack-vip-2-u5609",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP2.webp",
          alt: "Blackjack VIP 2",
          name: "Blackjack VIP 2",
        },
        {
          href: "/casino/aggapevolutiongaming-blackjack-vip-3-u2580",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP3.webp",
          alt: "Blackjack VIP 3",
          name: "Blackjack VIP 3",
        },
        
        {
          href: "/casino/aggapevolutiongaming-first-person-blackjack",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/FirstPersonBlackjack.webp",
          alt: "First Person Blackjack",
          name: "First Person Blackjack",
        },
        {
          href: "/casino/aggapevolutiongaming-first-person-lightning-blackjack",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl:
            "/images/casino/evolution/blackjack/FirstPersonLightningBlackjack.webp",
          alt: "First Person Lightning Blackjack",
          name: "First Person Lightning Blackjack",
        },
        {
          href: "/casino/aggapevolutiongaming-infinite-blackjack",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/evolution/blackjack/InfiniteBlackjack.webp",
          alt: "Infinite Blackjack",
          name: "Infinite Blackjack",
        },
      ],
      roulettetab: [
        {
          href: "/casino/ezgevo-vip-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/VIPRoulette.webp",
          alt: "VIP Roulette",
          name: "VIP Roulette",
        },
        {
          href: "/casino/aggapevolutiongaming-speed-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/SpeedRoulette.webp",
          alt: "Speed Roulette",
          name: "Speed Roulette",
        },
        {
          href: "/casino/ezgevo-first-person-lightning-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl:
            "/images/casino/evolution/roulette/FirstPersonLightningRoulette.webp",
          alt: "First Person lightning Roulette",
          name: "First Person lightning Roulette",
        },
        {
          href: "/casino/ezgevo-immersive-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/ImmersiveRoulette.webp",
          alt: "Immersive Roulette",
          name: "Immersive Roulette",
        },
        {
          href: "/casino/ezgevo-american-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/AmericanRoulette.webp",
          alt: "American Roulette",
          name: "American Roulette",
        },
        {
          href: "/casino/ezgevo-speed-auto-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/SpeedAutoRoulette.webp",
          alt: "Speed Auto Roulette",
          name: "Speed Auto Roulette",
        },
        {
          href: "/casino/aggapevolutiongaming-double-ball-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/DoubleBallRoulette.webp",
          alt: "Double Ball Roulette",
          name: "Double Ball Roulette",
        },
        {
          href: "/casino/aggapevolutiongaming-first-person-american-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl:
            "/images/casino/evolution/roulette/FirstPersonAmericanRoulette.webp",
          alt: "First Person American Roulette",
          name: "First Person American Roulette",
        },
        
        {
          href: "/casino/ezgevo-first-person-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/FirstPersonRoulette.webp",
          alt: "First Person Roulette",
          name: "First Person Roulette",
        },
        
        {
          href: "/casino/aggapevolutiongaming-instant-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/InstantRoulette.webp",
          alt: "Instant Roulette",
          name: "Instant Roulette",
        },
        {
          href: "/casino/ezgevo-lightning-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/LightningRoulette.webp",
          alt: "Lightning Roulette",
          name: "Lightning Roulette",
        },
        {
          href: "/casino/ezgevo-salon-prive-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/SalonPrivatRoulette.webp",
          alt: "Salon Privé Roulette",
          name: "Salon Privé Roulette",
        },
        
        {
          href: "/casino/aggapevolutiongaming-speed-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/SpeedRoulette.webp",
          alt: "Speed Roulette",
          name: "Speed Roulette",
        },
        {
          href: "/casino/ezgevo-turkish-lightning-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          providerName: "evolution",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/evolution/roulette/TurkishLightningRoulette.webp",
          alt: "Turkish Lightning Roulette",
          name: "Turkish Lightning Roulette",
        },
        
      ],
      crapstab: [
        {
          href: "/casino/aggapevolutiongaming-craps",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "craps",
          imgUrl: "/images/casino/evolution/craps/Craps.webp",
          alt: "Craps",
          name: "Craps",
        },
      
        {
          href: "/casino/aggapevolutiongaming-double-ball-roulette",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "craps",
          imgUrl: "/images/casino/evolution/craps/DoubleBallRoulette.webp",
          alt: "Double Ball Roulette",
          name: "Double Ball Roulette",
        },
      ],
      sicbo: [
        {
          href: "/casino/aggapevolutiongaming-dragon-tiger",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "sicbo",
          imgUrl: "/images/casino/evolution/sicbo/DragonTiger.webp",
          alt: "Dragon Tiger",
          name: "Dragon Tiger",
        },
        {
          href: "/casino/aggapevolutiongaming-first-person-dragon-tiger-u2880",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "sicbo",
          imgUrl: "/images/casino/evolution/sicbo/FirstPersonDragonTiger.webp",
          alt: "First Person Dragon Tiger",
          name: "First Person Dragon Tiger",
        },
        {
          href: "/casino/aggapevolutiongaming-super-sic-bo-u9412",
          code: "",
          casino: "ezugi",
          provider: "evolution",
          category: "sicbo",
          imgUrl: "/images/casino/evolution/sicbo/SuperSicBo.webp",
          alt: "Super Sic Bo",
          name: "Super Sic Bo",
        },
      ],
      gameshow: [
      
      ],
    },
    ezugi: {
      indianGames: [
        {
          href: "/casino/ezugi/IndianNamasteRoulette",
          code: "221005",
          casino: "ezugi",
          provider: "",
          homeUrl: "",
          cover: { src: "./images/indian/01.jpg", alt: "" },
          name: "IndianNamasteRoulette",
        },
        {
          href: "/casino/ezugi/IndianTeenPatti",
          code: "227100",
          casino: "ezugi",
          provider: "",
          homeUrl: "",
          cover: { src: "./images/indian/02.jpg", alt: "" },
          name: "IndianTeenPatti",
        },
      ],
      popularGames: [
        {
          href: "/casino/ezugi/lucky7",
          code: "228001",
          casino: "ezugi",
          provider: "",
          homeUrl: "",
          cover: { src: "./images/popular/01.jpg", alt: "" },
          name: "lucky7",
        },
        {
          href: "/casino/evolution/Monopoly",
          code: "228001",
          casino: "ezugi",
          provider: "EVO_LOBBY",
          homeUrl: "",
          cover: { src: "./images/popular/02.jpg", alt: "" },
          name: "Monopoly",
        },
      ],
      hotGames: [
        {
          href: "/casino/aggapezugi-andar-bahar",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "andarbahar",
          imgUrl: "/images/casino/ezugi/andarbahar/AndarBahar.webp",
          alt: "Andar Bahar",
          name: "Andar Bahar",
        },
        {
          href: "/casino/ezg-auto-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/AutoRoulette.webp",
          alt: "Auto Roulette",
          name: "Auto Roulette",
        },
        {
          href: "/casino/ezg-oracle-roulette-2",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/OracleRoulette360.webp",
          alt: "Oracle Roulette 360",
          name: "Oracle Roulette 360",
        },
        {
          href: "/casino/ezg-namaste-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/NamasteRoulette.webp",
          alt: "Namaste Roulette",
          name: "Namaste Roulette",
        },
        {
          href: "/casino/ezg-casino-marina-roulette-1",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/CasinoMarinaRoulette.webp",
          alt: "Casino Marina Roulette",
          name: "Casino Marina Roulette",
        },
        {
          href: "/casino/ezg-italian-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/ItalianRoulette.webp",
          alt: "italian roulette",
          name: "Italian Roulette",
        },
      ],
      roulettetab: [
        {
          href: "/casino/ezg-auto-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/AutoRoulette.webp",
          alt: "Auto Roulette",
          name: "Auto Roulette",
        },
        {
          href: "/casino/ezg-oracle-roulette-2",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/OracleRoulette360.webp",
          alt: "Oracle Roulette 360",
          name: "Oracle Roulette 360",
        },
        {
          href: "/casino/ezg-namaste-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/NamasteRoulette.webp",
          alt: "Namaste Roulette",
          name: "Namaste Roulette",
        },
        {
          href: "/casino/ezg-casino-marina-roulette-1",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/CasinoMarinaRoulette.webp",
          alt: "Casino Marina Roulette",
          name: "Casino Marina Roulette",
        },
        {
          href: "/casino/ezg-italian-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/ItalianRoulette.webp",
          alt: "italian roulette",
          name: "Italian Roulette",
        },
        
        
        
        {
          href: "/casino/ezg-portomaso-roulette-2",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/PortomasoRealCasinoRoulette2.webp",
          alt: "Portomaso Real Casino Roulette 2",
          name: "Portomaso Real Casino Roulette 2",
        },
        
        {
          href: "/casino/ezg-ruleta-del-sol",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/RuletadelSol.webp",
          alt: "Ruleta del Sol",
          name: "Ruleta del Sol",
        },
        {
          href: "/casino/ezg-ruleta-del-sol",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/SpeedAutoRoulette.webp",
          alt: "Speed Auto Roulette",
          name: "Speed Auto Roulette",
        },
        {
          href: "/casino/ezg-turkish-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/TürkçeRulet.webp",
          alt: "Türkçe Rulet",
          name: "Türkçe Rulet",
        },
        
        
        {
          href: "/casino/ezg-casino-marina-roulette-2",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/CasinoMarinaRoulette2.webp",
          alt: "Casino Marina Roulette 2",
          name: "Casino Marina Roulette 2",
        },
        {
          href: "/casino/ezg-diamond-roulette",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          providerName: "ezugi",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/ezugi/roulette/DiamondRoulette.webp",
          alt: "Diamond Roulette",
          name: "Diamond Roulette",
        },
      ],
      Blackjacktab: [
        {
          href: "/casino/aggapezugi-rumba-blackjack-2",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/ezugi/blackjack/Blackjack2.webp",
          alt: "Blackjack 2",
          name: "Blackjack 2",
        },
        {
          href: "/casino/aggapezugi-blackjack-gold-1",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold1.webp",
          alt: "Blackjack Gold 1",
          name: "Blackjack Gold 1",
        },
        {
          href: "/casino/aggapezugi-blackjack-gold-3",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold3.webp",
          alt: "Blackjack Gold 3",
          name: "Blackjack Gold 3",
        },
        {
          href: "/casino/aggapezugi-blackjack-gold-5",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold5.webp",
          alt: "Blackjack Gold 5",
          name: "Blackjack Gold 5",
        },
        {
          href: "/casino/aggapezugi-salon-prive-blackjack",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/ezugi/blackjack/BlackjackSalonPrivé.webp",
          alt: "Blackjack Salon Privé",
          name: "Blackjack Salon Privé",
        },
        {
          href: "/casino/aggapezugi-vip-blackjack",
          code: "",
          casino: "evolution",
          provider: "ezugi",
          category: "blackjack",
          imgUrl: "/images/casino/ezugi/blackjack/DiamondVIPBlackjack.webp",
          alt: "Diamond VIP Blackjack",
          name: "Diamond VIP Blackjack",
        },
        {
            href: "/casino/aggapezugi-rumba-blackjack-1",
            code: "",
            casino: "evolution",
            provider: "ezugi",
            category: "blackjack",

            imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack1.webp",
            alt: "Rumba Blackjack 1",
            name: "Rumba Blackjack 1",
        },
        {
            href: "/casino/aggapezugi-rumba-blackjack-2",
            code: "",
            casino: "evolution",
            provider: "ezugi",
            category: "blackjack",

            imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack2.webp",
            alt: "Rumba Blackjack 2",
            name: "Rumba Blackjack 2",
        },
        {
            href: "/casino/aggapezugi-rumba-blackjack-3",
            code: "",
            casino: "evolution",
            provider: "ezugi",
            category: "blackjack",

            imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack3.webp",
            alt: "Rumba Blackjack 3",
            name: "Rumba Blackjack 3",
        },
        {
            href: "/casino/aggapezugi-rumba-blackjack-4",
            code: "",
            casino: "evolution",
            provider: "ezugi",
            category: "blackjack",

            imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack4.webp",
            alt: "Rumba Blackjack 4",
            name: "Rumba Blackjack 4",
        },
        {
            href: "/casino/aggapezugi-unlimited-blackjack",
            code: "",
            casino: "evolution",
            provider: "ezugi",
            category: "blackjack",

            imgUrl: "/images/casino/ezugi/blackjack/UnlimitedBlackjack.webp",
            alt: "Unlimited Blackjack",
            name: "Unlimited Blackjack",
        },
      ],
      baccarattab: [
        {
          href: "/casino/aggapezugi-ez-baccarat",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/Baccarat.webp",
          alt: "Baccarat",
          name: "Baccarat",
        },
        {
          href: "/casino/aggapezugi-marina-casino-baccarat-1",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat1.webp",
          alt: "Casino Marina Baccarat 1",
          name: "Casino Marina Baccarat 1",
        },
        {
          href: "/casino/aggapezugi-marina-casino-baccarat-2",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat2.webp",
          alt: "Casino Marina Baccarat 2",
          name: "Casino Marina Baccarat 2",
        },
        {
          href: "/casino/aggapezugi-marina-casino-baccarat-3",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat3.webp",
          alt: "Casino Marina Baccarat 3",
          name: "Casino Marina Baccarat 3",
        },
        {
          href: "/casino/aggapezugi-cricket-war",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/CricketWar.webp",
          alt: "Cricket War",
          name: "Cricket War",
        },
        {
          href: "/casino/aggapezugi-dragon-tiger",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/DragonTiger.webp",
          alt: "Dragon Tiger",
          name: "Dragon Tiger",
        },
        {
          href: "/casino/aggapezugi-fortune-baccarat",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "baccarat",
          imgUrl: "/images/casino/ezugi/baccarat/FortuneBaccarat.webp",
          alt: "Fortune Baccarat",
          name: "Fortune Baccarat",
        },
      ],
      andarbahar: [
        {
          href: "/casino/aggapezugi-andar-bahar",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "andarbahar",
          imgUrl: "/images/casino/ezugi/andarbahar/AndarBahar.webp",
          alt: "Andar Bahar",
          name: "Andar Bahar",
        },
        {
           href: "/casino/aggapezugi-ott-andar-bahar",
           code: "",
           casino: "ezugi",
           provider: "ezugi",
           category: "andarbahar",
           imgUrl: "/images/casino/ezugi/andarbahar/OttAndarBahar.webp",
           alt: "OTT Andar Bahar",
           name: "OTT Andar Bahar",
        },
      ],
      lucky7: [
        {
          href: "/casino/aggapezugi-lucky-7",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "lucky7",
          imgUrl: "/images/casino/ezugi/lucky7/lucky7.webp",
          alt: "Lucky 7",
          name: "Lucky 7",
        },
      ],
      TeenPattitab: [
        {
          href: "/casino/aggapezugi-bet-on-teen-patti",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "poker",
          imgUrl: "/images/casino/ezugi/poker/BetonTeenPatti.webp",
          alt: "Bet on Teen Patti",
          name: "Bet on Teen Patti",
        },
        {
          href: "/casino/aggapezugi-casino-holdem",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "poker",
          imgUrl: "/images/casino/ezugi/poker/CasinoHoldem.webp",
          alt: "Casino Holdem",
          name: "Casino Holdem",
        },
        {
          href: "/casino/aggapezugi-one-day-teen-patti-classic",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "poker",
          imgUrl: "/images/casino/ezugi/poker/OneDayTeenPatti.webp",
          alt: "One Day Teen Patti",
          name: "One Day Teen Patti",
        },
        {
          href: "/casino/aggapezugi-teen-patti",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "poker",
          imgUrl: "/images/casino/ezugi/poker/TeenPatti3Card.webp",
          alt: "Teen Patti 3 Card",
          name: "Teen Patti 3 Card",
        },
      ],
      crapstab: [
        {
          href: "/casino/aggapezugi-fortune-baccarat",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "craps",
          imgUrl: "/images/casino/ezugi/craps/FortuneBaccarat.webp",
          alt: "Fortune Baccarat",
          name: "Fortune Baccarat",
        },
        {
          href: "/casino/aggapezugi-one-day-teen-patti-classic",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "craps",
          imgUrl: "/images/casino/ezugi/craps/OneDayTeenPatti.webp",
          alt: "One Day Teen Patti",
          name: "One Day Teen Patti",
        },
        {
          href: "/casino/aggapezugi-sic-bo",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "craps",
          imgUrl: "/images/casino/ezugi/craps/SicBo.webp",
          alt: "Sic Bo",
          name: "Sic Bo",
        },
        {
          href: "/casino/aggapezugi-ultimate-sic-bo",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "craps",
          imgUrl: "/images/casino/ezugi/craps/UltimateSicBo.webp",
          alt: "Ultimate Sic Bo",
          name: "Ultimate Sic Bo",
        },
      ],
      sicbo: [
        {
          href: "/casino/aggapezugi-sic-bo",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "sicbo",
          imgUrl: "/images/casino/ezugi/sicbo/Sicbo.webp",
          alt: "Sicbo",
          name: "Sicbo",
        },
        {
          href: "/casino/aggapezugi-ultimate-sic-bo",
          code: "",
          casino: "ezugi",
          provider: "ezugi",
          category: "sicbo",
          imgUrl: "/images/casino/ezugi/sicbo/UltimateSicBo.webp",
          alt: "Ultimate Sic Bo",
          name: "Ultimate Sic Bo",
        },
      ],
    },

    supernowa: {
      andarbahar: [
        
        {
          href: "/casino/sn-andar-bahar",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "andarbahar", 
          imgUrl: "/images/casino/supernowa/andar-bahar/AndarBahar.webp",
          alt: "Andar Bahar",
          name: "Andar Bahar",
        },
        {
          href: "/casino/sn-goas-andar-bahar",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "andarbahar", 
          imgUrl: "/images/casino/supernowa/andar-bahar/GoasAndarBahar.webp",
          alt: "Goa's Andar Bahar",
          name: "Goa's Andar Bahar",
        },
      ],
      // baccarattab: [
       
      // ],
      // lucky7: [
        
      // ],
      cards32: [
        {
          href: "/casino/sn-32-cards",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "cards32",  
          imgUrl: "/images/casino/supernowa/cards32/32Cards.webp",
          alt: "32 Cards",
          name: "32 Cards",
        },
      ],
      TeenPattitab: [
       
        {
          href: "/casino/sn-teen-patti-face-off",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "poker",  
          imgUrl: "/images/casino/supernowa/poker/TeenPattiFaceOff.webp",
          alt: "Teen Patti Face Off",
          name: "Teen Patti Face Off",
        },
      ],
      rngames: [
        {
          href: "/casino/sn-rng-dragon-tiger",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGDragonTiger.webp",
          alt: "RNG Dragon Tiger",
          name: "RNG Dragon Tiger",
        },
        {
          href: "/casino/sn-rng-dragon-tiger-2020",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGDragonTiger2020.webp",
          alt: "RNG Dragon Tiger 2020",
          name: "RNG Dragon Tiger 2020",
        },
        {
          href: "/casino/sn-rng-king-race",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGKingRace.webp",
          alt: "RNG King Race",
          name: "RNG King Race",
        },
        {
          href: "/casino/sn-rng-lucky-7",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGLucky7.webp",
          alt: "RNG Lucky 7",
          name: "RNG Lucky 7",
        },
        {
          href: "/casino/sn-rng-teen-patti",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGTeenPatti.webp",
          alt: "RNG Teen Patti",
          name: "RNG Teen Patti",
        },
        {
          href: "/casino/sn-rng-worli-matka",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGWorliMatka.webp",
          alt: "RNG Worli Matka",
          name: "RNG Worli Matka",
        },
        {
          href: "/casino/sn-rng-3-player-teen-patti",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNG3PlayerTeenPatti.webp",
          alt: "RNG 3 Player Teen Patti",
          name: "RNG 3 Player Teen Patti",
        },
        {
          href: "/casino/sn-rng-32-cards",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNG32Cards.webp",
          alt: "RNG 32 Cards",
          name: "RNG 32 Cards",
        },
        {
          href: "/casino/sn-rng-akbar-romeo-walter",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGAkbarRomeoWalter.webp",
          alt: "RNG Akbar Romeo Walter",
          name: "RNG Akbar Romeo Walter",
        },
        {
          href: "/casino/sn-rng-baccarat",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGBaccarat.webp",
          alt: "RNG Baccarat",
          name: "RNG Baccarat",
        },
        {
          href: "/casino/sn-rng-casino-queen",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGCasinoQueen.webp",
          alt: "RNG Casino Queen",
          name: "RNG Casino Queen",
        },
        {
          href: "/casino/sn-rng-casino-queen-2020",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "rngames",  
          imgUrl: "/images/casino/supernowa/rng-games/RNGCasinoQueen2020.webp",
          alt: "RNG Casino Queen 2020",
          name: "RNG Casino Queen 2020",
        },
      ],
      others: [
        {
          href: "/casino/sn-akbar-romeo-walter",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "others", 
          imgUrl: "/images/casino/supernowa/others/AkbarRomeoWalter.webp",
          alt: "Akbar Romeo Walter",
          name: "Akbar Romeo Walter",
        },
        {
          href: "/casino/sn-dragon-tiger",
          code: "",
          casino: "ezugi",
          provider: "supernowa",
          category: "others", 
          imgUrl: "/images/casino/supernowa/others/DragonTiger.webp",
          alt: "Dragon Tiger",
          name: "Dragon Tiger",
        },
      ],
    },

    auragames: {
      improvedExperience: [
        {
          code: "98567",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Dream Catcher",
          name: "Dream Catcher",
          category: "improvedExperience",
          providerName: "aura",
          imgUrl: "/images/aura/DreamCatcher.webp",
          href: "/casino/aura-dream-catcher",
        },
        {
          code: "56768",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti T20",
          name: "Teenpatti T20",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiT20.webp",
          href: "/casino/aura-teenpatti-t20",
        },
        {
          code: "98790",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Dragon Tiger",
          name: "Dragon Tiger",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/DragonTiger.webp",
          href: "/casino/aura-dragon-tiger",
        },
        {
          code: "98789",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "7 Up Down",
          name: "7 Up Down",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/7UpDown.webp",
          href: "/casino/aura-7-up-down",
        },
        {
          code: "56968\n",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Hi Low",
          name: "Hi Low",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/HiLow.webp",
          href: "/casino/aura-hi-low",
        },
        {
          code: "67660",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "2 Card Teenpatti",
          name: "2 Card Teenpatti",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/2CardsTeenpatti.webp",
          href: "/casino/aura-2-card-teenpatti",
        },
        {
          code: "67580",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Casino War",
          name: "Casino War",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/CasinoWar.webp",
          href: "/casino/aura-casino-war",
        },
        {
          code: "67600",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Muflis Teenpatti",
          name: "Muflis Teenpatti",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/MuflisTeenpatti.webp",
          href: "/casino/aura-muflis-teenpatti",
        },
        {
          code: "87564",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Andar Bahar",
          name: "Andar Bahar",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/AndarBahar.webp",
          href: "/casino/aura-andar-bahar",
        },
        {
          code: "67620",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Queen Race",
          name: "Queen Race",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/QueenRace.webp",
          href: "/casino/aura-queen-race",
        },
        {
          code: "67567",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Poker 20-20",
          name: "Poker 20-20",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/Poker20-20.webp",
          href: "/casino/aura-poker-20-20",
        },
        {
          code: "67570",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Bollywood Casino",
          name: "Bollywood Casino",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/BollywoodCasino.webp",
          href: "/casino/aura-bollywood-casino",
        },
        {
          code: "56767",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti 1 Day",
          name: "Teenpatti 1 Day",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiOneDay.webp",
          href: "/casino/aura-teenpatti-1-Day",
        },
        {
          code: "98788",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Roulette",
          name: "Roulette",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/Roulette.webp",
          href: "/casino/aura-roulette",
        },
        {
          code: "98791",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Amar Akbar Anthony",
          name: "Amar Akbar Anthony",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/AmarAkbarAnthony.webp",
          href: "/casino/aura-amar-akbar-anthony",
        },
        {
          code: "67630",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti Test",
          name: "Teenpatti Test",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiTest.webp",
          href: "/casino/aura-teenpatti-test",
        },
        {
          code: "98566",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Sicbo",
          name: "Sicbo",
          category: "improvedExperience",

          providerName: "aura",
          imgUrl: "/images/aura/Sicbo.webp",
          href: "/casino/aura-sicbo",
        },
      ],
      cardGames: [
        {
          code: "67564",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Poker",
          name: "Poker",
          providerName: "aura",
          imgUrl: "/images/aura/Poker.webp",
          href: "/casino/aura-poker",
          category: "cardGames",
        },
        {
          code: "67720",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Super Over",
          name: "Super Over",
          providerName: "aura",
          imgUrl: "/images/aura/SuperOver.webp",
          href: "/casino/aura-sper-over",
          category: "cardGames",
        },
        {
          code: "92037",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Matka",
          name: "Matka",
          providerName: "aura",
          imgUrl: "/images/aura/Matka(Virtual).webp",
          href: "/casino/aura-matka",
          category: "cardGames",
        },
        {
          code: "92038",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Baccarat",
          name: "Baccarat",
          providerName: "aura",
          imgUrl: "/images/aura/Baccarat.webp",
          href: "/casino/aura-baccarat",
          category: "cardGames",
        },
        {
          code: "67610",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Trio",
          name: "Trio",
          providerName: "aura",
          imgUrl: "/images/aura/Trio.webp",
          href: "/casino/aura-trio",
          category: "cardGames",
        },
        {
          code: "67670",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "3 Cards Judgement",
          name: "3 Cards Judgement",
          providerName: "aura",
          imgUrl: "/images/aura/3CardsJudgement.webp",
          href: "/casino/aura-3-cards-judgement",
          category: "cardGames",
        },
        {
          code: "90100",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Race 20-20",
          name: "Race 20-20",
          providerName: "aura",
          imgUrl: "/images/aura/Race20-20.webp",
          href: "/casino/aura-race-20-20",
          category: "cardGames",
        },
        {
          code: "67690",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "29 Card Baccarat",
          name: "29 Card Baccarat",
          providerName: "aura",
          imgUrl: "/images/aura/29CardBaccarat.webp",
          href: "/casino/aura-29-card-baccarat",
          category: "cardGames",
        },
        {
          code: "67640",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti Open",
          name: "Teenpatti Open",
          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiOpen.webp",
          href: "/casino/aura-teenpatti-open",
          category: "cardGames",
        },
        {
          code: "67710",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Race to 17",
          name: "Race to 17",
          providerName: "aura",
          imgUrl: "/images/aura/Raceto17.webp",
          href: "/casino/aura-race-to-17",
          category: "cardGames",
        },
        {
          code: "67565",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Six player poker",
          name: "Six player poker",
          providerName: "aura",
          imgUrl: "/images/aura/Sixplayerpoker.webp",
          href: "/casino/aura-six-player-poker",
          category: "cardGames",
        },
        {
          code: "67575",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Casino Meter",
          name: "Casino Meter",
          providerName: "aura",
          imgUrl: "/images/aura/CasinoMeter.webp",
          href: "/casino/aura-casino-meter",
          category: "cardGames",
        },
        {
          code: "67680",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "The Trap",
          name: "The Trap",
          providerName: "aura",
          imgUrl: "/images/aura/TheTrap.webp",
          href: "/casino/aura-the-trap",
          category: "cardGames",
        },
      ],
      virtualCardGames: [
        {
          code: "98793",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "7 up & Down (Virtual)",
          name: "7 up & Down (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/7up&Down(Virtual).webp",
          href: "/casino/aura-7-up-&-down-virtual",
          category: "virtualCardGames",
        },
        {
          code: "98794",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Dragon Tiger (Virtual)",
          name: "Dragon Tiger (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/DragonTiger(Virtual).webp",
          href: "/casino/aura-dragon-tiger-virtual",
          category: "virtualCardGames",
        },
        {
          code: "56769",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti T20 (Virtual)",
          name: "Teenpatti T20 (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiT20(Virtual).webp",
          href: "/casino/aura-teenpatti-t20-virtual",
          category: "virtualCardGames",
        },
        {
          code: "56969",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Hi Low (Virtual)",
          name: "Hi Low (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/HiLow(Virtual).webp",
          href: "/casino/aura-hi-low-virtual",
          category: "virtualCardGames",
        },
        {
          code: "98795",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Amar Akbar Anthony (Virtual)",
          name: "Amar Akbar Anthony (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/AmarAkbarAnthony(Virtual).webp",
          href: "/casino/aura-amar-akbar-anthony-virtual",
          category: "virtualCardGames",
        },
        {
          code: "98792",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Roulette (Virtual)",
          name: "Roulette (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Roulette(Virtual).webp",
          href: "/casino/aura-roulette-virtual",
          category: "virtualCardGames",
        },
        {
          code: "87565",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Andar Bahar (Virtual)",
          name: "Andar Bahar (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/AndarBahar(Virtual).webp",
          href: "/casino/aura-andar-bahar-virtual",
          category: "virtualCardGames",
        },
        {
          code: "56966",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "32 cards casino (Virtual)",
          name: "32 cards casino (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/32cardscasino(Virtual).webp",
          href: "/casino/aura-32-cards-casino-virtual",
          category: "virtualCardGames",
        },
        {
          code: "92036",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Matka (Virtual)",
          name: "Matka (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Matka(Virtual).webp",
          href: "/casino/aura-matka-virtual",
          category: "virtualCardGames",
        },
        {
          code: "56766",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti One-Day (Virtual)",
          name: "Teenpatti One-Day (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiOneDay(Virtual).webp",
          href: "/casino/aura-teenpatti-one-day-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67563",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Poker  (Virtual)",
          name: "Poker  (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Poker(Virtual).webp",
          href: "/casino/aura-poker-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67566",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Six player poker (Virtual)",
          name: "Six player poker (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Sixplayerpoker(Virtual).webp",
          href: "/casino/aura-six-player-poker-virtual",
          category: "virtualCardGames",
        },
        {
          code: "90101",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Race 20-20 (Virtual)",
          name: "Race 20-20 (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Race20-20(Virtual).webp",
          href: "/casino/aura-Race-20-20-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67601",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Muflis Teenpatti (virtual)",
          name: "Muflis Teenpatti (virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/MuflisTeenpatti(virtual).webp",
          href: "/casino/aura-muflis-teenpatti-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67568",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Poker 20-20 (Virtual)",
          name: "Poker 20-20 (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Poker20-20(Virtual).webp",
          href: "/casino/aura-poker-20-20-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67611",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Trio (virtual)",
          name: "Trio (virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Trio(virtual).webp",
          href: "/casino/aura-trio-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67576",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Casino Meter (Virtual)",
          name: "Casino Meter (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/CasinoMeter(Virtual).webp",
          href: "/casino/aura-casino-meter-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67631",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti Test (virtual)",
          name: "Teenpatti Test (virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiTest(virtual).webp",
          href: "/casino/aura-teenpatti-test-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67641",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Teenpatti Open (virtual)",
          name: "Teenpatti Open (virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/TeenpattiOpen(virtual).webp",
          href: "/casino/aura-teenpatti-open-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67581",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Casino War (Virtual)",
          name: "Casino War (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/CasinoWar(Virtual).webp",
          href: "/casino/aura-casino-war-virtual",
          category: "virtualCardGames",
        },
        {
          code: "92039",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Baccarat (Virtual)",
          name: "Baccarat (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/Baccarat(Virtual).webp",
          href: "/casino/aura-baccarat-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67571",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Bollywood Casino (Virtual)",
          name: "Bollywood Casino (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/BollywoodCasino(Virtual).webp",
          href: "/casino/aura-bollywood-casino-virtual",
          category: "virtualCardGames",
        },
        {
          code: "67621",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Queen Race (Virtual)",
          name: "Queen Race (Virtual)",
          providerName: "aura",
          imgUrl: "/images/aura/QueenRace.webp",
          href: "/casino/aura-queen-race-virtual",
          category: "virtualCardGames",
        },
      ],
      instantGames: [
        {
          category: "instantGames",
          code: "67722",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Blastoff",
          name: "Blastoff",
          providerName: "aura",
          imgUrl: "/images/aura/Blastoff.webp",
          href: "/casino/aura-blastoff",
        },
        {
          category: "instantGames",
          code: "70001",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Fortune Wheel",
          name: "Fortune Wheel",
          providerName: "aura",
          imgUrl: "/images/aura/FortuneWheel.webp",
          href: "/casino/aura-fortune-wheel",
        },
        {
          category: "instantGames",
          code: "70003",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Coin Toss",
          name: "Coin Toss",
          providerName: "aura",
          imgUrl: "/images/aura/CoinToss.webp",
          href: "/casino/aura-coin-toss",
        },
        {
          category: "instantGames",
          code: "70004",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Limbo",
          name: "Limbo",
          providerName: "aura",
          imgUrl: "/images/aura/Limbo.webp",
          href: "/casino/aura-limbo",
        },
        {
          category: "instantGames",
          code: "70005",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Slot Game",
          name: "Slot Game",
          providerName: "aura",
          imgUrl: "/images/aura/SlotGame.webp",
          href: "/casino/aura-slot-game",
        },
        {
          category: "instantGames",
          code: "70006",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Rock Paper Scissors",
          name: "Rock Paper Scissors",
          providerName: "aura",
          imgUrl: "/images/aura/RockPaperScissors.webp",
          href: "/casino/aura-rock-paper-scissors",
        },
        {
          category: "instantGames",
          code: "70008",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Cricket",
          name: "Cricket",
          providerName: "aura",
          imgUrl: "/images/aura/Cricket.webp",
          href: "/casino/aura-cricket",
        },
        {
          category: "instantGames",
          code: "70009",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Classic Dice",
          name: "Classic Dice",
          providerName: "aura",
          imgUrl: "/images/aura/ClassicDice.webp",
          href: "/casino/aura-classic-dice",
        },
        {
          category: "instantGames",
          code: "67722",
          casino: "aura",
          provider: "aura",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Aviator",
          name: "Aviator",
          providerName: "aura",
          imgUrl: "/images/aura/Aviator.webp",
          href: "/casino/aura-aviator",
        },
      ],
      mines: [
        {
          category: "instantGames",
          code: "70011",
          casino: "aura",
          provider: "aura",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          alt: "Mines",
          name: "Mines",
          providerName: "aura",
          imgUrl: "/images/aura/Mines.webp",
          href: "/casino/aura-mines",
        },
      ],
    },

    kingmaker: {
      kingmaker: [
        {
          href: "/casino/km-5-card-poker",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/5-card-poker.jpg",
          name: "Card Poker",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-7-up-7-down",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/7-up-7-down.jpg",
          name: "7 up 7 down",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-andar-bahar",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/andar-bahar.jpg",
          name: "Andar Bahar",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-baccarat",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/baccarat.jpg",
          name: "Baccarat",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-bai-buu",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/bai-buu.jpg",
          name: "Bai Buu",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-bai-cao",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/bai-cao.jpg",
          name: "Bai Cao",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-belangkai-2",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/belangkai-2.jpg",
          name: "Belangkai 2",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-blackjack",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/blackjack.jpg",
          name: "Blackjack",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-bola-golek",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/bola-golek.jpg",
          name: "Bola Golek",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-bola-tangkas",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/bola-tangkas.jpg",
          name: "Bola Tangkas",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-bonus-dice",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/bonus-dice.jpg",
          name: "Bonus Dice",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-card-hi-lo",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/card-hi-lo.jpg",
          name: "Card Hi Lo",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-cash-rocket",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/cash-rocket.jpg",
          name: "Cash Rocket",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-cleopatras-treasure",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/cleopatras-treasure.jpg",
          name: "Cleopatras Treasure",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-cockfighting-arena",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/cockfighting-arena.jpg",
          name: "Cockfighting Arena",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-coin-pusher",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/coin-pusher.jpg",
          name: "Coin Pusher",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-coin-toss",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/coin-toss.jpg",
          name: "Coin Toss",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-color-game",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/color-game.jpg",
          name: "Color Game",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-dota-hi-lo",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/dota-hi-lo.jpg",
          name: "Dota Hi Lo",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-dragon-tiger-2",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/dragon-tiger-2.jpg",
          name: "Dragon Tiger 2",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-elite-aviator-club",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/elite-aviator-club.jpg",
          name: "Elite Aviator Club",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-european-roulette",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/european-roulette.jpg",
          name: "European Roulette",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-fan-tvan-classic",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/fan-tvan-classic.jpg",
          name: "Fan Tan Classic",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-fish-prawn-crab-2",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/fish-prawn-crab-2.jpg",
          name: "Fish Prawn Crab 2",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-fruit-roulette",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/fruit-roulette.jpg",
          name: "FruitRoulette",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-gems-of-valhalla",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/gems-of-valhalla.jpg",
          name: "Gems Of Valhalla",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-heist",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/heist.jpg",
          name: "heist",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-interstellar-run",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/interstellar-run.jpg",
          name: "InterstellarRun",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-jhandi-munda",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/jhandi-munda.jpg",
          name: "Jhandi Munda",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-km-pok-deng",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/km-pok-deng.jpg",
          name: "KM Pok Deng",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-km-power-ball",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/km-power-ball.jpg",
          name: "KM Power Ball",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-km-virtual-horse-racing",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/km-virtual-horse-racing.jpg",
          name: "KM Virtual Horse Racing",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-marble-racing",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/marble-racing.jpg",
          name: "Marble Racing",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-max-keno",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/max-keno.jpg",
          name: "Max Keno",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-monkey-king-roulette",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/monkey-king-roulette.jpg",
          name: "Monkey King Roulette",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-olympus-glory",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/olympus-glory.jpg",
          name: "Olympus Glory",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-pai-kang",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/pai-kang.jpg",
          name: "Pai Kang",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-plinko",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/plinko.jpg",
          name: "Plinko",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-poker-roulette",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/poker-roulette.jpg",
          name: "Poker Roulette",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-pusoy",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/pusoy.jpg",
          name: "Pusoy",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-rooster-blitz",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/rooster-blitz.jpg",
          name: "Rooster Blitz",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-sicbo",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/sicbo.jpg",
          name: "Rooster Blitz",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-sugar-blast",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/sugar-blast.jpg",
          name: "Sugar Blast",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-sugar-blast-frenzy",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/sugar-blast-frenzy.jpg",
          name: "Sugar Blast Frenzy",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-tai-xiu",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/tai-xiu.jpg",
          name: "Tai Xiu",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-teen-patti",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/teen-patti.jpg",
          name: "Teen Patti",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-thai-fish-prawn-crab",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/thai-fish-prawn-crab.jpg",
          name: "Thai Fish Prawn Crab",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-thai-hi-lo-2",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/thai-hi-lo-2.jpg",
          name: "Thai Hi Lo 2",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-tongits",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/tongits.jpg",
          name: "Tongits",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-triple-chance",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/triple-chance.jpg",
          name: "Triple Chance",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-video-poker",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/video-poker.jpg",
          name: "Video Poker",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-viet-fish-prawn-crab",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/viet-fish-prawn-crab.jpg",
          name: "Viet Fish Prawn Crab",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-virtual-animal-race",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/virtual-animal-race.jpg",
          name: "Virtual Animal Race",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-virtual-greyhound-racing",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/virtual-greyhound-racing.jpg",
          name: "Virtual Greyhound Racing",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-virtual-treadmill-racing",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/virtual-treadmill-racing.jpg",
          name: "Virtual Treadmill Racing",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-xoc-lightning",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "kingmaker",
          imgUrl: "/images/kingmaker/xoc-lightning.jpg",
          name: "Xoc Lightning",
          providerName: "Kingmaker",
        },
      ],
      mines: [
        {
          href: "/casino/km-gold-mines",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "mines",
          imgUrl: "/images/kingmaker/gold-mines.jpg",
          name: "Gold Mines",
          providerName: "Kingmaker",
        },
        {
          href: "/casino/km-minesweeper",
          code: "",
          casino: "Kingmaker",
          provider: "Kingmaker",
          category: "mines",
          imgUrl: "/images/kingmaker/minesweeper.jpg",
          name: "Minesweeper",
          providerName: "Kingmaker",
        },
      ],
    },
  },
  miniGames: {
    spribe: {
      spribe: [
        {
          redirectUrl: "/casino/aggapspribe-aviator",
          code: "aviator",
          casino: "spribe",
          provider: "aviator",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Aviator-new.webp",
          alt: "",
          name: "Aviator",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-goal",
          code: "goal",
          casino: "spribe",
          provider: "goal",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Goal-new.webp",
          alt: "",
          name: "Goal",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-dice",
          code: "dice",
          casino: "spribe",
          provider: "dice",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Dice-new.webp",
          alt: "",
          name: "Dice",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-plinko",
          code: "plinko",
          casino: "spribe",
          provider: "plinko",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Plinko-new.webp",
          alt: "",
          name: "Plinko",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-hilo",
          code: "hi-lo",
          casino: "spribe",
          provider: "hi-lo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Hilo-new.webp",
          alt: "",
          name: "Hilo",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-keno",
          code: "keno",
          casino: "spribe",
          provider: "keno",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Keno-new.webp",
          alt: "keno",
          name: "Keno",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-mini-roulette",
          code: "mini-roulette",
          casino: "spribe",
          provider: "mini-roulette",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/MiniRoulette-new.webp",
          alt: "",
          name: "Mini Roulette",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-mines",
          code: "mines",
          casino: "spribe",
          provider: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/Mines.webp",
          alt: "",
          name: "Mines",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-hotline",
          code: "hotline",
          casino: "spribe",
          provider: "hotline",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/HotlineNew.jpg",
          alt: "hotline",
          name: "Hotline",
          providerName: "Spribe",
        },
        {
          redirectUrl: "/casino/aggapspribe-pilot-chicken",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/pilotchicken.webp",
          alt: "Pilot Chicken",
          name: "Pilot Chicken",
        },
        {
          redirectUrl: "/casino/aggapspribe-gates-of-egypt",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/gatesofegypt.webp",
          alt: "Gates of Egypt",
          name: "Gates of Egypt",
        },
        {
          redirectUrl: "/casino/aggapspribe-neo-vegas",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/neovegas.webp",
          alt: "Neo Vegas",
          name: "Neo Vegas",
        },
        {
          redirectUrl: "/casino/aggapspribe-crystal-fall",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/crystalfall.webp",
          alt: "Crystal Fall",
          name: "Crystal Fall",
        },
        {
          redirectUrl: "/casino/aggapspribe-trader",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/trader.webp",
          alt: "Trader",
          name: "Trader",
        },
        {
          redirectUrl: "/casino/aggapspribe-keno-80",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/multikeno.webp",
          alt: "Keno 80",
          name: "Keno 80",
        },
        {
          redirectUrl: "/casino/aggapspribe-balloon",
          code: "",
          casino: "spribe",
          provider: "alt-gaming",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/spribe/balloon.webp",
          alt: "Balloon",
          name: "Balloon",
        },
      ],
    },
    
    jiligames: {
      jiligames: [
        {
          redirectUrl: "/casino/aggapjiligaming-rummy-u7364",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/Rummy.webp",
          alt: "Rummy",
          name: "Rummy",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-3-coin-treasures",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/3-coin-treasures.webp",
          alt: "3 coin treasures",
          name: "3 coin treasures",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/3-lucky-piggy.webp",
          alt: "3 lucky piggy",
          name: "3 lucky piggy",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/3-pot-dragons.webp",
          alt: "3 pot dragons",
          name: "3 pot dragons",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-agent-ace",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/agent-ace.webp",
          alt: "agent ace",
          name: "agent ace",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-ali-baba",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/ali-baba.webp",
          alt: "ali baba",
          name: "ali baba",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-arena-fighter",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/arena-fighter.webp",
          alt: "arena fighter",
          name: "arena fighter",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-aztec-priestess",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/aztec-priestess.webp",
          alt: "aztec priestess",
          name: "aztec priestess",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-bangla-beauty",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/bangla-beauty.webp",
          alt: "bangla beauty",
          name: "bangla beauty",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-bao-boon-chin",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/bao-boon-chin.webp",
          alt: "bao boon chin",
          name: "bao boon chin",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-bone-fortune",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/bone-fortune.webp",
          alt: "bone fortune",
          name: "bone fortune",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/bonus-hunter.webp",
          alt: "bonus h1unter",
          name: "bonus hunter",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-book-of-gold",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/book-of-gold.webp",
          alt: "book of gold",
          name: "book of gold",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-boxing-king",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/boxing-king.webp",
          alt: "boxing king",
          name: "boxing king",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-bubble-beauty",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/bubble-beauty.webp",
          alt: "bubble beauty",
          name: "bubble beauty",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-charge-buffalo",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/charge-buffalo.webp",
          alt: "charge buffalo",
          name: "charge buffalo",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-charge-buffalo-ascent",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/charge-buffalo-ascent.webp",
          alt: "charge buffalo ascent",
          name: "charge buffalo ascent",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-chin-shi-huang",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/chin-shi-huang.webp",
          alt: "",
          name: "Chin Shi Huang",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-crazy-fafafa",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/crazy-fafafa.webp",
          alt: "crazy fafafa",
          name: "crazy fafafa",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-crazy-hunter",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/crazy-hunter.webp",
          alt: "crazy hunter",
          name: "crazy hunter",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-crazy777",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/crazy777.webp",
          alt: "",
          name: "Crazy777",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-cricket-king-18",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/cricket-king-18.webp",
          alt: "cricket king 18",
          name: "cricket king 18",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-cricket-sah-75",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/cricket-sah-75.webp",
          alt: "cricket sah 75",
          name: "cricket sah 75",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-dabanggg",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/dabanggg.webp",
          alt: "dabanggg",
          name: "dabanggg",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-devil-fire-2",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/devil-fire-2.webp",
          alt: "devil fire 2",
          name: "devil fire 2",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-diamondparty",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/diamond-party.webp",
          alt: "diamond party",
          name: "diamond party",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-dragon-treasure",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/dragon-treasure.webp",
          alt: "dragon treasure",
          name: "dragon treasure",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-egypts-glow",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/egypts-glow.webp",
          alt: "egypt's glow",
          name: "egypt's glow",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fa-fa-fa",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fa-fa-fa.webp",
          alt: "fa fa fa",
          name: "fa fa fa",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fengshen",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fengshen.webp",
          alt: "fengshen",
          name: "fengshen",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fortune-gems",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fortune-gems.webp",
          alt: "fortune gems",
          name: "fortune gems",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fortune-gems-2",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fortune-gems-2.webp",
          alt: "fortune gems 2",
          name: "fortune gems 2",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fortune-gems-3",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fortune-gems-3.webp",
          alt: "fortune gems 3",
          name: "fortune gems 3",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fortune-monkey",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fortune-monkey.webp",
          alt: "fortune monkey",
          name: "fortune monkey",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-fortune-tree",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/fortune-tree.webp",
          alt: "",
          name: "Fortune Tree",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-gem-party",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/gem-party.webp",
          alt: "",
          name: "Gem Party",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-god-of-martial",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/god-of-martial.webp",
          alt: "",
          name: "God Of Martial",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-gold-rush",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/gold-rush.webp",
          alt: "gold rush",
          name: "gold rush",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-crazy-golden-bank",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/golden-bank.webp",
          alt: "golden bank",
          name: "golden bank",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-golden-empire",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/golden-empire.webp",
          alt: "golden empire",
          name: "golden empire",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-golden-joker",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/golden-joker.webp",
          alt: "golden joker",
          name: "golden joker",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-golden-queen",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/golden-queen.webp",
          alt: "golden queen",
          name: "golden queen",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-golden-temple",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/golden-temple.webp",
          alt: "golden temple",
          name: "golden temple",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-happy-taxi",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/happy-taxi.webp",
          alt: "happy taxi",
          name: "happy taxi",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-hawaii-beauty",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/hawaii-beauty.webp",
          alt: "hawaii beauty",
          name: "hawaii beauty",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-hot-chilli",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/hot-chilli.webp",
          alt: "Hot Chilli",
          name: "Hot Chilli",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-hyper-burst",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/hyper-burst.webp",
          alt: "Hyper Burst",
          name: "Hyper Burst",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-jili-caishen",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/jili-caishen.webp",
          alt: "jili caishen",
          name: "jili caishen",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-jungle-king",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/jungle-king.webp",
          alt: "jungle king",
          name: "jungle king",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-king-arthur",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/king-arthur.webp",
          alt: "king arthur",
          name: "king arthur",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/legacy-of-egypt.webp",
          alt: "legacy of egypt",
          name: "legacy of egypt",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-lucky-ball",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/lucky-ball.webp",
          alt: "lucky ball",
          name: "lucky ball",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-lucky-coming",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/lucky-coming.webp",
          alt: "lucky coming",
          name: "lucky coming",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-magic-lamp",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/magic-lamp.webp",
          alt: "magic lamp",
          name: "magic lamp",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-master-tiger",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/master-tiger.webp",
          alt: "master tiger",
          name: "master tiger",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-mayan-empire",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/mayan-empire.webp",
          alt: "mayan empire",
          name: "mayan empire",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-medusa",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/medusa.webp",
          alt: "medusa",
          name: "medusa",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-mega-ace",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/mega-ace.webp",
          alt: "mega ace",
          name: "mega ace",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-money-coming",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/money-coming.webp",
          alt: "money coming",
          name: "money coming",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/money-coming-expanded-bets.webp",
          alt: "money coming expanded bets",
          name: "money coming expanded bets",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-monkey-party",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/monkey-party.webp",
          alt: "monkey party",
          name: "monkey party",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-neko-fortune",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/neko-fortune.webp",
          alt: "neko fortune",
          name: "neko fortune",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-night-city",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/night-city.webp",
          alt: "night city",
          name: "night city",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-party-night",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/party-night.webp",
          alt: "party night",
          name: "party night",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-party-star",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/party-star.webp",
          alt: "party star",
          name: "party star",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-pharaoh-treasure",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/pharaoh-treasure.webp",
          alt: "pharaoh treasure",
          name: "pharaoh treasure",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-pirate-queen",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/pirate-queen.webp",
          alt: "pirate queen",
          name: "pirate queen",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-poseidon",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/poseidon.webp",
          alt: "poseidon",
          name: "poseidon",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-potion-wizard",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/potion-wizard.webp",
          alt: "potion wizard",
          name: "potion wizard",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-romax",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/roma-x.webp",
          alt: "romax",
          name: "romax",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-samba",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/samba.webp",
          alt: "samba",
          name: "samba",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-secret-treasure",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/secret-treasure.webp",
          alt: "secret treasure",
          name: "secret treasure",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-shanghai-beauty",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/shanghai-beauty.webp",
          alt: "Shanghai Beauty",
          name: "Shanghai Beauty",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-sin-city",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/sin-city.webp",
          alt: "sin city",
          name: "sin city",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-super-ace",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/super-ace.webp",
          alt: "super ace",
          name: "super ace",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/super-ace-deluxe.webp",
          alt: "super ace deluxe",
          name: "super ace deluxe",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-super-rich",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/super-rich.webp",
          alt: "super rich",
          name: "super rich",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-sweet-land",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/sweet-land.webp",
          alt: "sweet land",
          name: "sweet land",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-thor-x",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/thor-x.webp",
          alt: "thor x",
          name: "thor x",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-trial-of-phoenix",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/trial-of-phoenix.webp",
          alt: "trial of phoenix",
          name: "trial of phoenix",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-twin-wins",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/twin-wins.webp",
          alt: "twin wins",
          name: "twin wins",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-war-of-dragons",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/war-of-dragons.webp",
          alt: "war of dragons",
          name: "war of dragons",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-wild-ace",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/wild-ace.webp",
          alt: "wild ace",
          name: "wild ace",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-wild-racer",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/wild-racer.webp",
          alt: "wild racer",
          name: "wild racer",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-witches-night",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/witches-night.webp",
          alt: "witches night",
          name: "witches night",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-world-cup",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/world-cup.webp",
          alt: "world cup",
          name: "world cup",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-xiyangyang",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/xiyangyang.webp",
          alt: "xiyangyang",
          name: "xiyangyang",
        },
        {
          redirectUrl: "/casino/aggapjiligaming-zeus",
          code: "",
          casino: "Slots",
          provider: "Jili",
          category: "jili",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/jili-games/zeus.webp",
          alt: "zeus",
          name: "zeus",
        },
      ],
    },

    turbogames: {
      turbo: [
        {
          redirectUrl: "/casino/aggapturbogames-ball-and-ball",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Ball&Ball.webp",
          alt: "Ball & Ball",
          name: "Ball & Ball",
        },
 
        {
          redirectUrl: "/casino/aggapturbogames-bubbles",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Bubbles.webp",
          alt: "Bubbles",
          name: "Bubbles",
        },
        {
          redirectUrl: "/casino/aggapturbogames-dice-twice",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/DiceTwice.webp",
          alt: "Dice Twice",
          name: "Dice Twice",
        },
        {
          redirectUrl: "/casino/aggapturbogames-double-roll",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/DoubleRoll.webp",
          alt: "Double Roll",
          name: "Double Roll",
        },
        {
          redirectUrl: "/casino/aggapturbogames-fast-fielder",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/FastFielder.webp",
          alt: "Fast Fielder",
          name: "Fast Fielder",
        },
        {
          redirectUrl: "/casino/aggapturbogames-fruit-towers",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/FruitTowers.webp",
          alt: "Fruit Towers",
          name: "Fruit Towers",
        },
        {
          redirectUrl: "/casino/aggapturbogames-hamsta",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Hamsta.webp",
          alt: "Hamsta",
          name: "Hamsta",
        },
         
        {
          redirectUrl: "/casino/aggapturbogames-limbo-rider",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/LimboRider.webp",
          alt: "Limbo Rider",
          name: "Limbo Rider",
        },
    
        {
          redirectUrl: "/casino/aggapturbogames-spin-strike",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/SpinStrike.webp",
          alt: "Spin Strike",
          name: "Spin Strike",
        },
        {
          redirectUrl: "/casino/aggapturbogames-fury-stairs",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Stairs.webp",
          alt: "Stairs",
          name: "Stairs",
        },
      
        {
          redirectUrl: "/casino/aggapturbogames-towers",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Towers.webp",
          alt: "Towers",
          name: "Towers",
        },
        {
          redirectUrl: "/casino/aggapturbogames-turbo-plinko",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/TurboPlinko.webp",
          alt: "Turbo Plinko",
          name: "Turbo Plinko",
        },
        {
          redirectUrl: "/casino/aggapturbogames-wicket-blast",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/WicketBlast.webp",
          alt: "Wicket Blast",
          name: "Wicket Blast",
        },
        {
          redirectUrl: "/casino/aggapturbogames-vortex",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Vortex.webp",
          alt: "Vortex",
          name: "Vortex",
        },
       
        {
          redirectUrl: "/casino/aggapturbogames-pumpedx",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/PumpedX.webp",
          alt: "PumpedX",
          name: "PumpedX",
        },
        {
          redirectUrl: "/casino/aggapturbogames-donny-king",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/DonnyKing.webp",
          alt: "Donny King",
          name: "Donny King",
        },
        {
          redirectUrl: "/casino/aggapturbogames-crystal-poker",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/CrystalPoker.webp",
          alt: "Crystal Poker",
          name: "Crystal Poker",
        },
        {
          redirectUrl: "/casino/aggapturbogames-jewel-clicker",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "turbo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/JewelClicker.webp",
          alt: "Jewel Clicker",
          name: "Jewel Clicker",
        },
      ],
      crash: [
        {
          href: "/casino/aggapturbogames-aero",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "crash",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Aero.webp",
          alt: "Aero",
          name: "Aero",
        },
      ],
      mines: [
        {
          href: "/casino/aggapturbogames-mines",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Mines.webp",
          alt: "Mines",
          name: "Mines",
        },
        {
          href: "/casino/aggapturbogames-turbo-mines",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/TurboMines.webp",
          alt: "Turbo Mines",
          name: "Turbo Mines",
        },
        {
          href: "/casino/aggapturbogames-1tap-mines",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/1TapMines(InstantWin).webp",
          alt: "1Tap Mines",
          name: "1Tap Mines",
        },
        {
          href: "/casino/qt-1tap-mines",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/1TapMines.webp",
          alt: "1Tap Mines (Instant Win)",
          name: "1Tap Mines (Instant Win)",
        },
      
        {
          href: "/casino/aggapturbogames-book-of-mines",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/BookOfMines.webp",
          alt: "Book of Mines",
          name: "Book of Mines",
        },
      ],
      hiLo: [
        {
          href: "/casino/aggapturbogames-hi-lo",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "hiLo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/Hi-Lo.webp",
          alt: "Hi-Lo",
          name: "Hi-Lo",
        },
      ],
      crashx: [
        {
          href: "/casino/aggapturbogames-crash-x",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/CrashX.webp",
          alt: "Crash X",
          name: "Crash X",
        },
        {
          href: "/casino/aggapturbogames-crash-x-football-edition",
          code: "",
          casino: "Slots",
          provider: "TurboGames",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/turbo/CrashXFootballEdition.webp",
          alt: "Crash X Football Edition",
          name: "Crash X Football Edition",
        },
      ],
    },

    playngo: {
      playngo: [
        {
          redirectUrl: "/casino/aggapplayngo-super-wheel",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/SuperWheel.webp",
          alt: "Super Wheel",
          name: "Super Wheel",
        },
        {
          redirectUrl: "/casino/aggapplayngo-money-wheel",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/MoneyWheel.webp",
          alt: "Money Wheel",
          name: "Money Wheel",
        },
        {
          redirectUrl: "/casino/aggapplayngo-rainforest-magic-bingo",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/RainforestMagicBingo.webp",
          alt: "Rainforest Magic Bingo",
          name: "Rainforest Magic Bingo",
        },
        {
          redirectUrl: "/casino/aggapplayngo-sweet-alchemy-bingo",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/SweetAlchemyBingo.webp",
          alt: "Sweet Alchemy Bingo",
          name: "Sweet Alchemy Bingo",
        },
        {
          redirectUrl: "/casino/aggapplayngo-viking-runecraft-bingo",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/VikingRunecraftBingo.webp",
          alt: "Viking Runecraft Bingo",
          name: "Viking Runecraft Bingo",
        },
        {
          redirectUrl: "/casino/aggapplayngo-3-clown-monty-ii",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/3ClownMontyII.webp",
          alt: "3 Clown Monty II",
          name: "3 Clown Monty II",
        },
        {
          redirectUrl: "/casino/aggapplayngo-pandastic-adventure",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/PandasticAdventure.webp",
          alt: "Pandastic Adventure",
          name: "Pandastic Adventure",
        },
        {
          redirectUrl: "/casino/aggapplayngo-tales-of-mithrune-syns-fortune",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/TalesofMithruneSynsFortune.webp",
          alt: "Tales of Mithrune Syn's Fortune",
          name: "Tales of Mithrune Syn's Fortune",
        },
        {
          redirectUrl: "/casino/aggapplayngo-viking-runecraft-100",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/VikingRunecraft100.webp",
          alt: "Viking Runecraft 100",
          name: "Viking Runecraft 100",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gargantoonz",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Gargantoonz.webp",
          alt: "Gargantoonz",
          name: "Gargantoonz",
        },
        {
          redirectUrl: "/casino/aggapplayngo-mega-don-feeding-frenzy",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/MegaDonFeedingFrenzy.webp",
          alt: "Mega Don: Feeding Frenzy",
          name: "Mega Don: Feeding Frenzy",
        },
        {
          redirectUrl: "/casino/aggapplayngo-invading-vegas-las-christmas",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/InvadingVegasLasChristmas.webp",
          alt: "Invading Vegas: Las Christmas",
          name: "Invading Vegas: Las Christmas",
        },
        {
          redirectUrl: "/casino/aggapplayngo-legacy-of-dynasties",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LegacyofDynasties.webp",
          alt: "Legacy of Dynasties",
          name: "Legacy of Dynasties",
        },
        {
          redirectUrl: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/MonkeyBattlefortheScrolls.webp",
          alt: "Monkey: Battle for the Scrolls",
          name: "Monkey: Battle for the Scrolls",
        },
        {
          redirectUrl: "/casino/aggapplayngo-sherwood-gold",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/SherwoodGold.webp",
          alt: "Sherwood Gold",
          name: "Sherwood Gold",
        },
        {
          redirectUrl: "/casino/aggapplayngo-3-clown-monty",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/3ClownMonty.webp",
          alt: "3 clown monty",
          name: "3 Clown Monty",
        },
        {
          redirectUrl: "/casino/aggapplayngo-5x-magic",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/5xMagic.webp",
          alt: "5x magic",
          name: "5x Magic",
        },
        {
          redirectUrl: "/casino/aggapplayngo-7-sins",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/7Sins.webp",
          alt: "7 sins",
          name: "7 Sins",
        },
        {
          redirectUrl: "/casino/aggapplayngo-ace-of-spades",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AceofSpades.webp",
          alt: "ace of spades",
          name: "Ace of Spades",
        },
        {
          redirectUrl: "/casino/aggapplayngo-agent-destiny",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AgentDestiny.webp",
          alt: "agent destiny",
          name: "Agent Destiny",
        },
        {
          redirectUrl: "/casino/aggapplayngo-agent-of-hearts",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AgentofHearts.webp",
          alt: "agent of hearts",
          name: "Agent of Hearts",
        },
        {
          redirectUrl: "/casino/aggapplayngo-animal-madness",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AnimalMadness.webp",
          alt: "animal madness",
          name: "Animal Madness",
        },
        {
          redirectUrl: "/casino/aggapplayngo-ankh-of-anubis",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AnkhofAnubis.webp",
          alt: "ankh of anubis",
          name: "Ankh of Anubis",
        },
        {
          redirectUrl: "/casino/aggapplayngo-annihilator",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Annihilator.webp",
          alt: "annihilator",
          name: "Annihilator",
        },
        {
          redirectUrl: "/casino/aggapplayngo-athena-ascending",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AthenaAscending.webp",
          alt: "athena ascending",
          name: "Athena Ascending",
        },
        {
          redirectUrl: "/casino/aggapplayngo-aztec-idols",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AztecIdols.webp",
          alt: "aztec idols",
          name: "Aztec Idols",
        },
        {
          redirectUrl: "/casino/aggapplayngo-aztec-warrior-princess",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/AztecWarriorPrincess.webp",
          alt: "aztec warrior princess",
          name: "Aztec Warrior Princess",
        },
        {
          redirectUrl: "/casino/aggapplayngo-bakers-treat",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BakersTreat.webp",
          alt: "bakers treat",
          name: "Baker's Treat",
        },
        {
          redirectUrl: "/casino/aggapplayngo-banana-rock",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BananaRock.webp",
          alt: "banana rock",
          name: "Banana Rock",
        },
        {
          redirectUrl: "/casino/aggapplayngo-battle-royal",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BattleRoyal.webp",
          alt: "battle royal",
          name: "Battle Royal",
        },
        {
          redirectUrl: "/casino/aggapplayngo-beasts-of-fire",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BeastsOfFire.webp",
          alt: "beasts of fire",
          name: "Beasts Of Fire",
        },
        {
          redirectUrl: "/casino/aggapplayngo-big-win-777",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BigWin777.webp",
          alt: "big win 777",
          name: "Big Win 777",
        },
        {
          redirectUrl: "/casino/aggapplayngo-big-win-cat",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BigWinCat.webp",
          alt: "big win cat",
          name: "Big Win Cat",
        },
        {
          redirectUrl: "/casino/aggapplayngo-black-mamba",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BlackMamba.webp",
          alt: "black mamba",
          name: "Black Mamba",
        },
        {
          redirectUrl: "/casino/aggapplayngo-blazin-bullfrog",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BlazinBullfrog.webp",
          alt: "blazin bullfrog",
          name: "Blazin' Bullfrog",
        },
        {
          redirectUrl: "/casino/aggapplayngo-blinged",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Blinged.webp",
          alt: "blinged",
          name: "Blinged",
        },
        {
          redirectUrl: "/casino/aggapplayngo-boat-bonanza",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BoatBonanza.webp",
          alt: "boat bonanza",
          name: "Boat Bonanza",
        },
        {
          redirectUrl: "/casino/aggapplayngo-book-of-dead",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BookofDead.webp",
          alt: "book of dead",
          name: "Book of Dead",
        },
        {
          redirectUrl: "/casino/aggapplayngo-bull-in-a-china-shop",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BullinaChinaShop.webp",
          alt: "bull in a china shop",
          name: "Bull in a China Shop",
        },
        {
          redirectUrl: "/casino/aggapplayngo-bull-in-a-rodeo",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/BullinaRodeo.webp",
          alt: "bull in a rodeo",
          name: "Bull in a Rodeo",
        },
        {
          redirectUrl: "/casino/aggapplayngo-candy-island-princess",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CandyIslandPrincess.webp",
          alt: "candy island princess",
          name: "Candy Island Princess",
        },
        {
          redirectUrl: "/casino/aggapplayngo-canine-carnage",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CanineCarnage.webp",
          alt: "canine carnage",
          name: "Canine Carnage",
        },
        {
          redirectUrl: "/casino/aggapplayngo-captain-glum-pirate-hunter",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CaptainGlumPirateHunter.webp",
          alt: "captain glum pirate hunter",
          name: "Captain Glum: Pirate Hunter",
        },
        {
          redirectUrl: "/casino/aggapplayngo-captain-xenos-earth-adventure",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CaptainXenosEarthAdventure.webp",
          alt: "captain xenos earth adventure",
          name: "Captain Xeno's Earth Adventure",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cash-a-cabana",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CashaCabana.webp",
          alt: "cash a cabana",
          name: "Cash-a-Cabana",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cash-of-command",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CashofCommand.webp",
          alt: "cash of command",
          name: "Cash of Command",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cash-pump",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CashPump.webp",
          alt: "cash pump",
          name: "Cash Pump",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cash-vandal",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CashVandal.webp",
          alt: "cash vandal",
          name: "Cash Vandal",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-doom-of-dead",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CatWildeandtheDoomofDead.webp",
          alt: "cat wilde and the doom of dead",
          name: "Cat Wilde and the Doom of Dead",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-lost-chapter",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CatWildeandtheLostChapter.webp",
          alt: "cat wilde and the lost chapter",
          name: "Cat Wilde and the Lost Chapter",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-pyramids-of-dead",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CatWildeandthePyramidsofDead.webp",
          alt: "cat wilde and the pyramids of dead",
          name: "Cat Wilde and the Pyramids of Dead",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cat-wilde-in-the-eclipse-of-the-sun-god",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CatWildeintheEclipseoftheSunGod.webp",
          alt: "cat wilde in the eclipse of the sun god",
          name: "Cat Wilde in the Eclipse of the Sun God",
        },
        {
          redirectUrl: "/casino/aggapplayngo-cats-and-cash",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/CatsandCash.webp",
          alt: "cats and cash",
          name: "Cats and Cash",
        },
        {
          redirectUrl: "/casino/aggapplayngo-champions-of-mithrune",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/ChampionsofMithrune.webp",
          alt: "champions of mithrune",
          name: "Champions of Mithrune",
        },
        {
          redirectUrl: "/casino/aggapplayngo-diamonds-of-the-realm",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DiamondsoftheRealm.webp",
          alt: "diamonds of the realm",
          name: "Diamonds of the Realm",
        },
        {
          redirectUrl: "/casino/aggapplayngo-diamond-vortex",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DiamondVortex.webp",
          alt: "diamond-vortex",
          name: "Diamond Vortex",
        },
        {
          redirectUrl: "/casino/aggapplayngo-disco-diamonds",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DiscoDiamonds.webp",
          alt: "disco diamonds",
          name: "Disco Diamonds",
        },
        {
          redirectUrl: "/casino/aggapplayngo-divine-showdown",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DivineShowdown.webp",
          alt: "divine showdown",
          name: "Divine Showdown",
        },
        {
          redirectUrl: "/casino/aggapplayngo-dr-toonz",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DrToonz.webp",
          alt: "dr toonz",
          name: "Dr Toonz",
        },
        {
          redirectUrl: "/casino/aggapplayngo-doom-of-egypt",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DoomofEgypt.webp",
          alt: "doom of egypt",
          name: "Doom of Egypt",
        },
        {
          redirectUrl: "/casino/aggapplayngo-dragon-maiden",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DragonMaiden.webp",
          alt: "Dragon Maiden",
          name: "Dragon Maiden",
        },
        {
          redirectUrl: "/casino/aggapplayngo-dragon-ship",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/DragonShip.webp",
          alt: "Dragon Ship",
          name: "Dragon Ship",
        },
        {
          redirectUrl: "/casino/aggapplayngo-easter-eggs",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/EasterEggs.webp",
          alt: "Easter Eggs",
          name: "Easter Eggs",
        },
        {
          redirectUrl: "/casino/aggapplayngo-enchanted-crystals",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/EnchantedCrystals.webp",
          alt: "Enchanted Crystals",
          name: "Enchanted Crystals",
        },
        {
          redirectUrl: "/casino/aggapplayngo-enchanted-meadow",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/EnchantedMeadow.webp",
          alt: "Enchanted Meadow",
          name: "Enchanted Meadow",
        },
        {
          redirectUrl: "/casino/aggapplayngo-energoonz",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Energoonz.webp",
          alt: "Energoonz",
          name: "Energoonz",
        },
        {
          redirectUrl: "/casino/aggapplayngo-eye-of-atum",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/EyeOfAtum.webp",
          alt: "Eye Of Atum",
          name: "Eye Of Atum",
        },
        {
          redirectUrl: "/casino/aggapplayngo-eye-of-the-kraken",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/EyeOfTheKraken.webp",
          alt: "Eye of the Kraken",
          name: "Eye of the Kraken",
        },
        {
          redirectUrl: "/casino/aggapplayngo-fat-frankies",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FatFrankies.webp",
          alt: "Fat Frankies",
          name: "Fat Frankies",
        },
        {
          redirectUrl: "/casino/aggapplayngo-feline-fury",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FelineFury.webp",
          alt: "Feline Fury",
          name: "Feline Fury",
        },
        {
          redirectUrl: "/casino/aggapplayngo-fire-joker",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FireJoker.webp",
          alt: "Fire Joker",
          name: "Fire Joker",
        },
        {
          redirectUrl: "/casino/aggapplayngo-fire-joker-freeze",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FireJokerFreeze.webp",
          alt: "Fire Joker Freeze",
          name: "Fire Joker Freeze",
        },
        {
          redirectUrl: "/casino/aggapplayngo-firefly-frenzy",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FireflyFrenzy.webp",
          alt: "Firefly Frenzy",
          name: "Firefly Frenzy",
        },
        {
          redirectUrl: "/casino/aggapplayngo-forge-of-fortunes",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/ForgeOfFortunes.webp",
          alt: "Forge of Fortunes",
          name: "Forge of Fortunes",
        },
        {
          redirectUrl: "/casino/aggapplayngo-forge-of-gems",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/ForgeOfGems.webp",
          alt: "Forge Of Gems",
          name: "Forge Of Gems",
        },
        {
          redirectUrl: "/casino/aggapplayngo-fortune-rewind",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FortuneRewind.webp",
          alt: "Fortune Rewind",
          name: "Fortune Rewind",
        },
        {
          redirectUrl: "/casino/aggapplayngo-fortunes-of-ali-baba",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FortunesOfAliBaba.webp",
          alt: "Fortunes of Ali Baba",
          name: "Fortunes of Ali Baba",
        },
        {
          redirectUrl: "/casino/aggapplayngo-free-reelin-joker-1000",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FreeReelinJoker1000.webp",
          alt: "Free Reelin' Joker 1000",
          name: "Free Reelin' Joker 1000",
        },
        {
          redirectUrl: "/casino/aggapplayngo-free-reelin-joker",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FreeReelinJoker.webp",
          alt: "Free Reelin' Joker",
          name: "Free Reelin' Joker",
        },
        {
          redirectUrl: "/casino/aggapplayngo-frozen-gems",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FrozenGems.webp",
          alt: "Frozen Gems",
          name: "Frozen Gems",
        },
        {
          redirectUrl: "/casino/aggapplayngo-fu-er-dai",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/FUERDAI.webp",
          alt: "FU ER DAI",
          name: "FU ER DAI",
        },
        {
          redirectUrl: "/casino/aggapplayngo-game-of-gladiators",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GameOfGladiators.webp",
          alt: "Game of Gladiators",
          name: "Game of Gladiators",
        },
        {
          redirectUrl: "/casino/aggapplayngo-game-of-gladiators",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GameOfGladiatorsUprising.webp",
          alt: "Game of Gladiators: Uprising",
          name: "Game of Gladiators: Uprising",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gates-of-troy",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GatesOfTroy.webp",
          alt: "Gates of Troy",
          name: "Gates of Troy",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gemix",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Gemix.webp",
          alt: "Gemix",
          name: "Gemix",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gemix-2",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Gemix2.webp",
          alt: "Gemix 2",
          name: "Gemix 2",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gerards-gambit",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GerardsGambit.webp",
          alt: "Gerard's Gambit",
          name: "Gerard's Gambit",
        },
        {
          redirectUrl: "/casino/aggapplayngo-ghost-of-dead",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GhostOfDead.webp",
          alt: "Ghost of Dead",
          name: "Ghost of Dead",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gigantoonz",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Gigantoonz.webp",
          alt: "Gigantoonz",
          name: "Gigantoonz",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gold-king",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldKing.webp",
          alt: "Gold King",
          name: "Gold King",
        },
        {
          redirectUrl: "/casino/aggapplayngo-gold-trophy-2",
          code: "",
          casino: "Slots",
          provider: "Play'n GO",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldTrophy2.webp",
          alt: "Gold Trophy 2",
          name: "Gold Trophy 2",
        },
        {
          href: "/casino/aggapplayngo-gold-volcano",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldVolcano.webp",
          alt: "Gold Volcano",
          name: "Gold Volcano",
        },
        {
          href: "/casino/aggapplayngo-golden-caravan",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldenCaravan.webp",
          alt: "Golden Caravan",
          name: "Golden Caravan",
        },
        {
          href: "/casino/aggapplayngo-golden-colts",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldenColts.webp",
          alt: "Golden Colts",
          name: "Golden Colts",
        },
        {
          href: "/casino/aggapplayngo-golden-legend",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldenLegend.webp",
          alt: "Golden Legend",
          name: "Golden Legend",
        },
        {
          href: "/casino/aggapplayngo-golden-osiris",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldenOsiris.webp",
          alt: "Golden Osiris",
          name: "Golden Osiris",
        },
        {
          href: "/casino/aggapplayngo-golden-ticket",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldenTicket.webp",
          alt: "Golden Ticket",
          name: "Golden Ticket",
        },
        {
          href: "/casino/aggapplayngo-golden-ticket-2",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GoldenTicket2.webp",
          alt: "Golden Ticket 2",
          name: "Golden Ticket 2",
        },
        {
          href: "/casino/aggapplayngo-grim-muerto",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/GrimMuerto.webp",
          alt: "Grim Muerto",
          name: "Grim Muerto",
        },
        {
          href: "/casino/aggapplayngo-happy-halloween",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HappyHalloween.webp",
          alt: "Happy Halloween",
          name: "Happy Halloween",
        },
        {
          href: "/casino/aggapplayngo-highway-legends",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HighwayLegends.webp",
          alt: "Highway Legends",
          name: "Highway Legends",
        },
        {
          href: "/casino/aggapplayngo-holiday-season",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HolidaySeason.webp",
          alt: "Holiday Season",
          name: "Holiday Season",
        },
        {
          href: "/casino/aggapplayngo-holiday-spirits",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HolidaySpirits.webp",
          alt: "Holiday Spirits",
          name: "Holiday Spirits",
        },
        {
          href: "/casino/aggapplayngo-honey-rush",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HoneyRush.webp",
          alt: "Honey Rush",
          name: "Honey Rush",
        },
        {
          href: "/casino/aggapplayngo-hooligan-hustle",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HooliganHustle.webp",
          alt: "Hooligan Hustle",
          name: "Hooligan Hustle",
        },
        {
          href: "/casino/aggapplayngo-hotel-yeti-way",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HotelYetiWay.webp",
          alt: "Hotel Yeti-Way",
          name: "Hotel Yeti-Way",
        },
        {
          href: "/casino/aggapplayngo-house-of-doom",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HouseofDoom.webp",
          alt: "House of Doom",
          name: "House of Doom",
        },
        {
          href: "/casino/aggapplayngo-house-of-doom-2-the-crypt",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/HouseofDoom2TheCrypt.webp",
          alt: "House of Doom 2 The Crypt",
          name: "House of Doom 2 The Crypt",
        },
        {
          href: "/casino/aggapplayngo-ice-joker",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/IceJoker.webp",
          alt: "Ice Joker",
          name: "Ice Joker",
        },
        {
          href: "/casino/aggapplayngo-idol-of-fortune",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/IdolofFortune.webp",
          alt: "Idol of Fortune",
          name: "Idol of Fortune",
        },
        {
          href: "/casino/aggapplayngo-immortails-of-egypt",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/ImmorTailsOfEgypt.webp",
          alt: "ImmorTails of Egypt",
          name: "ImmorTails of Egypt",
        },
        {
          href: "/casino/aggapplayngo-inferno-joker",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/InfernoJoker.webp",
          alt: "Inferno Joker",
          name: "Inferno Joker",
        },
        {
          href: "/casino/aggapplayngo-invading-vegas",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/InvadingVegas.webp",
          alt: "Invading Vegas",
          name: "Invading Vegas",
        },
        {
          href: "/casino/aggapplayngo-inferno-star",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/InfernoStar.webp",
          alt: "Inferno Star",
          name: "Inferno Star",
        },
        {
          href: "/casino/aggapplayngo-irish-gold",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/IrishGold.webp",
          alt: "Irish Gold",
          name: "Irish Gold",
        },
        {
          href: "/casino/aggapplayngo-iron-girl",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/IronGirl.webp",
          alt: "Iron Girl",
          name: "Iron Girl",
        },
        {
          href: "/casino/aggapplayngo-jade-magician",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/JadeMagician.webp",
          alt: "Jade Magician",
          name: "Jade Magician",
        },
        {
          href: "/casino/aggapplayngo-jewel-box",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/JewelBox.webp",
          alt: "Jewel Box",
          name: "Jewel Box",
        },
        {
          href: "/casino/aggapplayngo-jolly-roger-2",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/JollyRoger2.webp",
          alt: "Jolly Roger 2",
          name: "Jolly Roger 2",
        },
        {
          href: "/casino/aggapplayngo-kings-mask",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/KingsMask.webp",
          alt: "King's Mask",
          name: "King's Mask",
        },
        {
          href: "/casino/aggapplayngo-lady-of-fortune",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LadyOfFortune.webp",
          alt: "Lady of Fortune",
          name: "Lady of Fortune",
        },
        {
          href: "/casino/aggapplayngo-legacy-of-dead",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LegacyOfDead.webp",
          alt: "Legacy of Dead",
          name: "Legacy of Dead",
        },
        {
          href: "/casino/aggapplayngo-legacy-of-egypt",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LegacyOfEgypt.webp",
          alt: "Legacy of Egypt",
          name: "Legacy of Egypt",
        },
        {
          href: "/casino/aggapplayngo-legacy-of-inca",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LegacyOfInca.webp",
          alt: "Legacy of Inca",
          name: "Legacy of Inca",
        },
        {
          href: "/casino/aggapplayngo-legend-of-the-ice-dragon",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LegendOfTheIceDragon.webp",
          alt: "Legend Of The Ice Dragon",
          name: "Legend Of The Ice Dragon",
        },
        {
          href: "/casino/aggapplayngo-legion-gold",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LegionGold.webp",
          alt: "Legion Gold",
          name: "Legion Gold",
        },
        {
          href: "/casino/aggapplayngo-leprechaun-goes-egypt",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LeprechaunGoesEgypt.webp",
          alt: "Leprechaun goes Egypt",
          name: "Leprechaun goes Egypt",
        },
        {
          href: "/casino/aggapplayngo-leprechaun-goes-wild",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LeprechaunGoesWild.webp",
          alt: "Leprechaun Goes Wild",
          name: "Leprechaun Goes Wild",
        },
        {
          href: "/casino/aggapplayngo-leprechauns-vault",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LeprechaunsVault.webp",
          alt: "Leprechaun's Vault",
          name: "Leprechaun's Vault",
        },
        {
          href: "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
          alt: "Lord Merlin and The Lady of The Lake",
          name: "Lord Merlin and The Lady of The Lake",
        },
        {
          href: "/casino/aggapplayngo-love-joker",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LoveJoker.webp",
          alt: "Love Joker",
          name: "Love Joker",
        },
        {
          href: "/casino/aggapplayngo-luchamigos",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Luchamigos.webp",
          alt: "Luchamigos",
          name: "Luchamigos",
        },
        {
          href: "/casino/aggapplayngo-lucky-diamonds",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/LuckyDiamonds.webp",
          alt: "Lucky Diamonds",
          name: "Lucky Diamonds",
        },
        {
          href: "/casino/aggapplayngo-madame-ink",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/MadameInk.webp",
          alt: "Madame Ink",
          name: "Madame Ink",
        },
        {
          href: "/casino/aggapplayngo-mega-don",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/MegaDon.webp",
          alt: "Mega Don",
          name: "Mega Don",
        },
        {
          href: "/casino/aggapplayngo-mahjong-88",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Mahjong88.webp",
          alt: "Mahjong 88",
          name: "Mahjong 88",
        },
        {
          href: "/casino/aggapplayngo-matsuri",
          code: "",
          casino: "Play'n GO",
          provider: "ALT_GAMING_GAP",
          category: "playNGo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/play-n-go/Matsuri.webp",
          alt: "Matsuri",
          name: "Matsuri",
        },
        {
        href: "/casino/aggapplayngo-merlin-and-ice-queen-morgana",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MerlinAndTheIceQueenMorgana.webp",
        alt: "Merlin and Ice Queen Morgana",
        name: "Merlin and Ice Queen Morgana",
      },
{
        href: "/casino/aggapplayngo-merlins-grimoire",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MerlinsGrimoire.webp",
        alt: "Merlin's Grimoire",
        name: "Merlin's Grimoire",
      },
{
        href: "/casino/aggapplayngo-mermaids-diamond",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MermaidsDiamond.webp",
        alt: "Mermaid's Diamond",
        name: "Mermaid's Diamond",
      },
{
        href: "/casino/aggapplayngo-merry-xmas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MerryXmas.webp",
        alt: "Merry Xmas",
        name: "Merry Xmas",
      },
{
        href: "/casino/aggapplayngo-miner-donkey-trouble",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MinerDonkeyTrouble.webp",
        alt: "Miner Donkey Trouble",
        name: "Miner Donkey Trouble",
      },
{
        href: "/casino/aggapplayngo-mission-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MissionCash.webp",
        alt: "Mission Cash",
        name: "Mission Cash",
      },
{
        href: "/casino/aggapplayngo-moon-princess-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MoonPrincess100.webp",
        alt: "Moon Princess 100",
        name: "Moon Princess 100",
      },
{
        href: "/casino/aggapplayngo-moon-princess",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MoonPrincess.webp",
        alt: "Moon Princess",
        name: "Moon Princess",
      },
{
        href: "/casino/aggapplayngo-moon-princess-christmas-kingdom",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MoonPrincessChristmasKingdom.webp",
        alt: "Moon Princess Christmas Kingdom",
        name: "Moon Princess Christmas Kingdom",
      },
{
        href: "/casino/aggapplayngo-moon-princess-trinity",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MoonPrincessTrinity.webp",
        alt: "Moon Princess Trinity",
        name: "Moon Princess Trinity",
      },
{
        href: "/casino/aggapplayngo-mount-m",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MountM.webp",
        alt: "Mount M",
        name: "Mount M",
      },
{
        href: "/casino/aggapplayngo-muerto-en-mictlan",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MuertoEnMictlán.webp",
        alt: "Muerto en Mictlán",
        name: "Muerto en Mictlán",
      },
      // MultiFruit81: {
      //   href: "/casino/qtechplayngo-multifruit-81",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MultiFruit81.webp",
      //   alt: "MultiFruit 81",
      //   name: "MultiFruit 81",
      // },
{
        href: "/casino/aggapplayngo-mystery-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MysteryJoker.webp",
        alt: "Mystery Joker",
        name: "Mystery Joker",
      },
{
        href: "/casino/aggapplayngo-mystery-joker-6000",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MysteryJoker6000.webp",
        alt: "Mystery Joker 6000",
        name: "Mystery Joker 6000",
      },
{
        href: "/casino/aggapplayngo-myth",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Myth.webp",
        alt: "Myth",
        name: "Myth",
      },
{
        href: "/casino/aggapplayngo-naughty-nicks-book",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/NaughtyNicksBook.webp",
        alt: "Naughty Nick's Book",
        name: "Naughty Nick's Book",
      },
{
        href: "/casino/aggapplayngo-new-year-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/NewYearRiches.webp",
        alt: "New Year Riches",
        name: "New Year Riches",
      },
{
        href: "/casino/aggapplayngo-ninja-fruits",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/NinjaFruits.webp",
        alt: "Ninja Fruits",
        name: "Ninja Fruits",
      },
{
        href: "/casino/aggapplayngo-octopus-treasure",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/OctopusTreasure.webp",
        alt: "Octopus Treasure",
        name: "Octopus Treasure",
      },
{
        href: "/casino/aggapplayngo-odin-protector-of-realms",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/OdinProtectorOfRealms.webp",
        alt: "Odin: Protector of Realms",
        name: "Odin: Protector of Realms",
      },
{
        href: "/casino/aggapplayngo-pack-and-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PackAndCash.webp",
        alt: "Pack & Cash",
        name: "Pack & Cash",
      },
{
        href: "/casino/aggapplayngo-pandoras-box-of-evil",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PandorasBoxOfEvil.webp",
        alt: "Pandora's Box of Evil",
        name: "Pandora's Box of Evil",
      },
{
        href: "/casino/aggapplayngo-pearl-lagoon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PearlLagoon.webp",
        alt: "Pearl Lagoon",
        name: "Pearl Lagoon",
      },
{
        href: "/casino/aggapplayngo-pearls-of-india",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PearlsOfIndia.webp",
        alt: "Pearls of India",
        name: "Pearls of India",
      },
{
        href: "/casino/aggapplayngo-perfect-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PerfectGems.webp",
        alt: "Perfect Gems",
        name: "Perfect Gems",
      },
{
        href: "/casino/aggapplayngo-phoenix-reborn",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PhoenixReborn.webp",
        alt: "Phoenix Reborn",
        name: "Phoenix Reborn",
      },
{
        href: "/casino/aggapplayngo-photo-safari",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PhotoSafari.webp",
        alt: "Photo Safari",
        name: "Photo Safari",
      },
{
        href: "/casino/aggapplayngo-piggy-bank-farm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PiggyBankFarm.webp",
        alt: "Piggy Bank Farm",
        name: "Piggy Bank Farm",
      },
{
        href: "/casino/aggapplayngo-pilgrim-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PilgrimOfDead.webp",
        alt: "Pilgrim of Dead",
        name: "Pilgrim of Dead",
      },
{
        href: "/casino/aggapplayngo-pimped",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Pimped.webp",
        alt: "Pimped",
        name: "Pimped",
      },
{
        href: "/casino/aggapplayngo-planet-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PlanetFortune.webp",
        alt: "Planet Fortune",
        name: "Planet Fortune",
      },
{
        href: "/casino/aggapplayngo-prism-of-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PrismOfGems.webp",
        alt: "Prism of Gems",
        name: "Prism of Gems",
      },
{
        href: "/casino/aggapplayngo-prissy-princess",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PrissyPrincess.webp",
        alt: "Prissy Princess",
        name: "Prissy Princess",
      },
{
        href: "/casino/aggapplayngo-prosperity-palace",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ProsperityPalace.webp",
        alt: "Prosperity Palace",
        name: "Prosperity Palace",
      },
{
        href: "/casino/aggapplayngo-puebla-parade",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PueblaParade.webp",
        alt: "Puebla Parade",
        name: "Puebla Parade",
      },
{
        href: "/casino/aggapplayngo-queens-day-tilt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/QueensDayTilt.webp",
        alt: "Queens Day Tilt",
        name: "Queens Day Tilt",
      },
{
        href: "/casino/aggapplayngo-rabbit-hole-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RabbitHoleRiches.webp",
        alt: "Rabbit Hole Riches",
        name: "Rabbit Hole Riches",
      },
{
        href: "/casino/aggapplayngo-rage-to-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RageToRiches.webp",
        alt: "Rage to Riches",
        name: "Rage to Riches",
      },
{
        href: "/casino/aggapplayngo-raging-rex",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RagingRex.webp",
        alt: "Raging Rex",
        name: "Raging Rex",
      },
{
        href: "/casino/aggapplayngo-raging-rex-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RagingRex2.webp",
        alt: "Raging Rex 2",
        name: "Raging Rex 2",
      },
{
        href: "/casino/aggapplayngo-rainforest-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RainforestMagic.webp",
        alt: "Rainforest Magic",
        name: "Rainforest Magic",
      },
{
        href: "/casino/aggapplayngo-rally-4-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Rally4Riches.webp",
        alt: "Rally 4 Riches",
        name: "Rally 4 Riches",
      },
{
        href: "/casino/aggapplayngo-reactoonz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Reactoonz.webp",
        alt: "Reactoonz",
        name: "Reactoonz",
      },
{
        href: "/casino/aggapplayngo-reactoonz-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Reactoonz2.webp",
        alt: "Reactoonz 2",
        name: "Reactoonz 2",
      },
{
        href: "/casino/aggapplayngo-rich-wilde-and-the-wandering-city",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RichWildeAndTheWanderingCity.webp",
        alt: "Rich Wilde And The Wandering City",
        name: "Rich Wilde And The Wandering City",
      },
{
        href: "/casino/aggapplayngo-rich-wilde-and-the-shield-of-athena",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RichWildeAndTheShieldOfAthena.webp",
        alt: "Rich Wilde and the Shield of Athena",
        name: "Rich Wilde and the Shield of Athena",
      },
{
        href: "/casino/aggapplayngo-riches-of-ra",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RichesOfRA.webp",
        alt: "Riches of RA",
        name: "Riches of RA",
      },
{
        href: "/casino/aggapplayngo-riches-of-robin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RichesOfRobin.webp",
        alt: "Riches of Robin",
        name: "Riches of Robin",
      },
{
        href: "/casino/aggapplayngo-riddle-reels-a-case-of-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiddleReelsACaseOfRiches.webp",
        alt: "Riddle Reels a case of riches",
        name: "Riddle Reels a case of riches",
      },
{
        href: "/casino/aggapplayngo-ring-of-odin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RingOfOdin.webp",
        alt: "Ring of Odin",
        name: "Ring of Odin",
      },
{
        href: "/casino/aggapplayngo-rise-of-athena",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiseOfAthena.webp",
        alt: "Rise of Athena",
        name: "Rise of Athena",
      },
{
        href: "/casino/aggapplayngo-rise-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiseOfDead.webp",
        alt: "Rise of Dead",
        name: "Rise of Dead",
      },
{
        href: "/casino/aggapplayngo-rise-of-gods-reckoning",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiseOfGodsReckoning.webp",
        alt: "Rise of Gods Reckoning",
        name: "Rise of Gods Reckoning",
      },
{
        href: "/casino/aggapplayngo-rise-of-merlin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiseOfMerlin.webp",
        alt: "Rise of Merlin",
        name: "Rise of Merlin",
      },
      // RiseOfOlympus: {
      //   href: "/casino/aggapplayngo-rise-of-olympus",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfOlympus.webp",
      //   alt: "Rise of Olympus",
      //   name: "Rise of Olympus",
      // },
{
        href: "/casino/aggapplayngo-rise-of-olympus-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiseOfOlympus100.webp",
        alt: "Rise of Olympus 100",
        name: "Rise of Olympus 100",
      },
{
        href: "/casino/aggapplayngo-rocco-gallo",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RoccoGallo.webp",
        alt: "Rocco Gallo",
        name: "Rocco Gallo",
      },
{
        href: "/casino/aggapplayngo-ronins-honour",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RoninsHonour.webp",
        alt: "Ronin's Honour",
        name: "Ronin's Honour",
      },
{
        href: "/casino/aggapplayngo-rotiki",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Rotiki.webp",
        alt: "Rotiki",
        name: "Rotiki",
      },
{
        href: "/casino/aggapplayngo-royal-masquerade",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RoyalMasquerade.webp",
        alt: "Royal Masquerade",
        name: "Royal Masquerade",
      },
{
        href: "/casino/aggapplayngo-sabaton",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Sabaton.webp",
        alt: "Sabaton",
        name: "Sabaton",
      },
{
        href: "/casino/aggapplayngo-safari-of-wealth",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SafariOfWealth.webp",
        alt: "Safari Of Wealth",
        name: "Safari Of Wealth",
      },
{
        href: "/casino/aggapplayngo-sails-of-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SailsOfGold.webp",
        alt: "Sails of Gold",
        name: "Sails of Gold",
      },
{
        href: "/casino/aggapplayngo-samba-carnival",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SambaCarnival.webp",
        alt: "Samba Carnival",
        name: "Samba Carnival",
      },
{
        href: "/casino/aggapplayngo-scroll-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ScrollOfDead.webp",
        alt: "Scroll of Dead",
        name: "Scroll of Dead",
      },
{
        href: "/casino/aggapplayngo-sea-hunter",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SeaHunter.webp",
        alt: "Sea Hunter",
        name: "Sea Hunter",
      },
{
        href: "/casino/aggapplayngo-secret-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SecretOfDead.webp",
        alt: "Secret Of Dead",
        name: "Secret Of Dead",
      },
{
        href: "/casino/aggapplayngo-shamrock-miner",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ShamrockMiner.webp",
        alt: "Shamrock Miner",
        name: "Shamrock Miner",
      },
{
        href: "/casino/aggapplayngo-sisters-of-the-sun",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SistersOfTheSun.webp",
        alt: "Sisters of The Sun",
        name: "Sisters of The Sun",
      },
{
        href: "/casino/aggapplayngo-sizzling-spins",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SizzlingSpins.webp",
        alt: "Sizzling Spins",
        name: "Sizzling Spins",
      },
{
        href: "/casino/aggapplayngo-slashimi",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Slashimi.webp",
        alt: "Slashimi",
        name: "Slashimi",
      },
{
        href: "/casino/aggapplayngo-space-race",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SpaceRace.webp",
        alt: "Space Race",
        name: "Space Race",
      },
{
        href: "/casino/aggapplayngo-sparky-and-shortz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SparkyAndShortz.webp",
        alt: "Sparky & Shortz",
        name: "Sparky & Shortz",
      },
{
        href: "/casino/aggapplayngo-spin-party",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SpinParty.webp",
        alt: "Spin Party",
        name: "Spin Party",
      },
{
        href: "/casino/aggapplayngo-star-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/StarJoker.webp",
        alt: "Star Joker",
        name: "Star Joker",
      },
{
        href: "/casino/aggapplayngo-sticky-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/StickyJoker.webp",
        alt: "Sticky Joker",
        name: "Sticky Joker",
      },
{
        href: "/casino/aggapplayngo-street-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/StreetMagic.webp",
        alt: "Street Magic",
        name: "Street Magic",
      },
{
        href: "/casino/aggapplayngo-super-flip",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SuperFlip.webp",
        alt: "Super Flip",
        name: "Super Flip",
      },
{
        href: "/casino/aggapplayngo-sweet-27",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Sweet27.webp",
        alt: "Sweet 27",
        name: "Sweet 27",
      },
{
        href: "/casino/aggapplayngo-sweet-alchemy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SweetAlchemy.webp",
        alt: "Sweet Alchemy",
        name: "Sweet Alchemy",
      },
{
        href: "/casino/aggapplayngo-tale-of-kyubiko",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TaleOfKyubiko.webp",
        alt: "Tale Of Kyubiko",
        name: "Tale Of Kyubiko",
      },
{
        href: "/casino/aggapplayngo-tales-of-asgard-freyas-wedding",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TalesOfAsgardFreyasWedding.webp",
        alt: "Tales of Asgard Freya's Wedding",
        name: "Tales of Asgard Freya's Wedding",
      },
{
        href: "/casino/aggapplayngo-tales-of-asgard-lokis-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TalesOfAsgardLokisFortune.webp",
        alt: "Tales Of Asgard Loki's Fortune",
        name: "Tales Of Asgard Loki's Fortune",
      },
{
        href: "/casino/aggapplayngo-testament",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Testament.webp",
        alt: "Testament",
        name: "Testament",
      },
{
        href: "/casino/aggapplayngo-thats-rich",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ThatsRich.webp",
        alt: "That's Rich",
        name: "That's Rich",
      },
{
        href: "/casino/aggapplayngo-the-faces-of-freya",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheFacesOfFreya.webp",
        alt: "The Faces of Freya",
        name: "The Faces of Freya",
      },
{
        href: "/casino/aggapplayngo-the-green-knight",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheGreenKnight.webp",
        alt: "The Green Knight",
        name: "The Green Knight",
      },
{
        href: "/casino/aggapplayngo-the-last-sundown",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheLastSundown.webp",
        alt: "The Last Sundown",
        name: "The Last Sundown",
      },
{
        href: "/casino/aggapplayngo-the-paying-piano-club",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ThePayingPianoClub.webp",
        alt: "The Paying Piano Club",
        name: "The Paying Piano Club",
      },
{
        href: "/casino/aggapplayngo-shimmering-woods",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheShimmeringWoods.webp",
        alt: "Shimmering Woods",
        name: "Shimmering Woods",
      },
{
        href: "/casino/aggapplayngo-the-sword-and-the-grail",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheSwordAndTheGrail.webp",
        alt: "The Sword and The Grail",
        name: "The Sword and The Grail",
      },
{
        href: "/casino/aggapplayngo-the-wild-class",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheWildClass.webp",
        alt: "The Wild Class",
        name: "The Wild Class",
      },
{
        href: "/casino/aggapplayngo-thunder-screech",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ThunderScreech.webp",
        alt: "Thunder Screech",
        name: "Thunder Screech",
      },
      // TomeOfMadness: {
      //   href: "/casino/qtechplayngo-tome-of-madness",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TomeOfMadness.webp",
      //   alt: "Tome of Madness",
      //   name: "Tome of Madness",
      // },
{
        href: "/casino/aggapplayngo-troll-hunters",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TrollHunters.webp",
        alt: "Troll Hunters",
        name: "Troll Hunters",
      },
{
        href: "/casino/aggapplayngo-troll-hunters-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TrollHunters2.webp",
        alt: "Troll Hunters 2",
        name: "Troll Hunters 2",
      },
{
        href: "/casino/aggapplayngo-usa-flip",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/USAFlip.webp",
        alt: "USA Flip",
        name: "USA Flip",
      },
{
        href: "/casino/aggapplayngo-viking-runecraft",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/VikingRunecraft.webp",
        alt: "Viking Runecraft",
        name: "Viking Runecraft",
      },
{
        href: "/casino/aggapplayngo-wild-bandolier",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildBandolier.webp",
        alt: "Wild Bandolier",
        name: "Wild Bandolier",
      },
{
        href: "/casino/aggapplayngo-wild-blood",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildBlood.webp",
        alt: "Wild Blood",
        name: "Wild Blood",
      },
{
        href: "/casino/aggapplayngo-wild-blood-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildBlood2.webp",
        alt: "Wild Blood 2",
        name: "Wild Blood 2",
      },
{
        href: "/casino/aggapplayngo-wild-falls",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildFalls.webp",
        alt: "Wild Falls",
        name: "Wild Falls",
      },
{
        href: "/casino/aggapplayngo-wild-falls-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildFalls2.webp",
        alt: "Wild Falls 2",
        name: "Wild Falls 2",
      },
{
        href: "/casino/aggapplayngo-wild-frames",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildFrames.webp",
        alt: "Wild Frames",
        name: "Wild Frames",
      },
{
        href: "/casino/aggapplayngo-wild-melon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildMelon.webp",
        alt: "Wild Melon",
        name: "Wild Melon",
      },
{
        href: "/casino/aggapplayngo-wild-north",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildNorth.webp",
        alt: "Wild North",
        name: "Wild North",
      },
{
        href: "/casino/aggapplayngo-wild-rails",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildRails.webp",
        alt: "Wild Rails",
        name: "Wild Rails",
      },
{
        href: "/casino/aggapplayngo-wild-trigger",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildTrigger.webp",
        alt: "Wild Trigger",
        name: "Wild Trigger",
      },
{
        href: "/casino/aggapplayngo-wildhound-derby",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildhoundDerby.webp",
        alt: "Wildhound Derby",
        name: "Wildhound Derby",
      },
{
        href: "/casino/aggapplayngo-win-a-beest",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WinABeest.webp",
        alt: "Win-A-Beest",
        name: "Win-A-Beest",
      },
{
        href: "/casino/aggapplayngo-wizard-of-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WizardOfGems.webp",
        alt: "Wizard of Gems",
        name: "Wizard of Gems",
      },
{
        href: "/casino/aggapplayngo-xmas-joker-3-reel",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/XmasJoker.webp",
        alt: "Xmas Joker",
        name: "Xmas Joker",
      },
{
        href: "/casino/aggapplayngo-xmas-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/XmasMagic.webp",
        alt: "Xmas Magic",
        name: "Xmas Magic",
      },
{
        href: "/casino/aggapplayngo-3-hand-casino-holdem",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/3HandCasinoHoldem.webp",
        alt: "3-Hand Casino Hold'em",
        name: "3-Hand Casino Hold'em",
      },
{
        href: "/casino/aggapplayngo-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BlackJackMH.webp",
        alt: "BlackJack MH",
        name: "BlackJack MH",
      },
{
        href: "/casino/aggapplayngo-deuces-wild-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/DeucesWild.webp",
        alt: "Deuces Wild",
        name: "Deuces Wild",
      },
{
        href: "/casino/aggapplayngo-double-exposure-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/DoubleExposureBlackJackMH.webp",
        alt: "Double Exposure BlackJack MH",
        name: "Double Exposure BlackJack MH",
      },
{
        href: "/casino/aggapplayngo-european-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/EuropeanBlackJackMH.webp",
        alt: "European BlackJack MH",
        name: "European BlackJack MH",
      },
{
        href: "/casino/aggapplayngo-european-roulette",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/EuropeanRoulettePro.webp",
        alt: "European Roulette",
        name: "European Roulette",
      },
{
        href: "/casino/aggapplayngo-jacks-or-better-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/JacksOrBetterMH.webp",
        alt: "Jacks or Better MH",
        name: "Jacks or Better MH",
      },
{
        href: "/casino/aggapplayngo-joker-poker-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/JokerPokerMH.webp",
        alt: "Joker Poker MH",
        name: "Joker Poker MH",
      },
      // Keno: {
      //   href: "/casino/qtechplayngo-keno",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Keno.webp",
      //   alt: "Keno",
      //   name: "Keno",
      // },
      // MiniBaccarat: {
      //   href: "/casino/qtechplayngo-mini-baccarat",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MiniBaccarat.webp",
      //   alt: "Mini Baccarat",
      //   name: "Mini Baccarat",
      // },
{
        href: "/casino/aggapplayngo-single-deck-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SingleDeckBlackJackMH.webp",
        alt: "Single Deck BlackJack MH",
        name: "Single Deck BlackJack MH",
      },
{
        href: "/casino/aggapplayngo-moon-princess-power-of-love",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MoonPrincessPowerOfLove.webp",
        alt: "Moon Princess - Power of Love",
        name: "Moon Princess - Power of Love",
      },
{
        href: "/casino/aggapplayngo-love-is-in-the-fair",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LoveIsInTheFair.webp",
        alt: "Love is in the Fair",
        name: "Love is in the Fair",
      },
{
        href: "/casino/aggapplayngo-cat-wilde-and-the-incan-quest",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/CatWildeAndTheIncanQuest.webp",
        alt: "Cat Wilde and the Incan Quest",
        name: "Cat Wilde and the Incan Quest",
      },
{
        href: "/casino/aggapplayngo-boat-bonanza-down-under",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BoatBonanzaDownUnder.webp",
        alt: "Boat Bonanza Down Under",
        name: "Boat Bonanza Down Under",
      },
{
        href: "/casino/aggapplayngo-hugo-carts",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/HugoCarts.webp",
        alt: "Hugo Carts",
        name: "Hugo Carts",
      },
{
        href: "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
        alt: "Alice Cooper And The Tome Of Madness",
        name: "Alice Cooper And The Tome Of Madness",
      },
{
        href: "/casino/qt-snakebite",
        code: "",
        casino: "Play'n GO",
        provider: "WorldCasino",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Snakebite.webp",
        alt: "Snakebite",
        name: "Snakebite",
      },
{
        href: "/casino/aggapplayngo-kiss-reels-of-rock",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/kissReelsOfRock.webp",
        alt: "kiss Reels Of Rock",
        name: "kiss Reels Of Rock",
      },
{
        href: "/casino/aggapplayngo-def-leppard-hysteria",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/DefleppardHysteria.webp",
        alt: "Def Leppard Hysteria",
        name: "Def Leppard Hysteria",
      },
{
        href: "/casino/aggapplayngo-dio-killing-the-dragon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/DioKillingTheDragon.webp",
        alt: "DIO Killing the Dragon",
        name: "DIO Killing the Dragon",
      },
{
        href: "/casino/aggapplayngo-divine-divas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/DivineDivas.webp",
        alt: "Divine Divas",
        name: "Divine Divas",
      },
{
        href: "/casino/aggapplayngo-gemix-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Gemix100.webp",
        alt: "Gemix 100",
        name: "Gemix 100",
      },
{
        href: "/casino/aggapplayngo-kingdom-below",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/KingdomBelow.webp",
        alt: "Kingdom Below",
        name: "Kingdom Below",
      },
{
        href: "/casino/aggapplayngo-mirror-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MirrorJoker.webp",
        alt: "Mirror Joker",
        name: "Mirror Joker",
      },
{
        href: "/casino/aggapplayngo-buildin-bucks",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BuildinBucks.webp",
        alt: "Buildin' Bucks",
        name: "Buildin' Bucks",
      },
{
        href: "/casino/aggapplayngo-ankh-of-anubis-awakening",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/AnkhOfAnubisAwakening.webp",
        alt: "Ankh of Anubis Awakening",
        name: "Ankh of Anubis Awakening",
      },
{
        href: "/casino/aggapplayngo-scourge-of-rome",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ScourgeOfRome.webp",
        alt: "Scourge of Rome",
        name: "Scourge of Rome",
      },
{
        href: "/casino/aggapplayngo-mafia-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MafiaGold.webp",
        alt: "Mafia Gold",
        name: "Mafia Gold",
      },
{
        href: "/casino/aggapplayngo-rise-of-olympus-origin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RiseOfOlympusOrigins.webp",
        alt: "Rise of Olympus Origin",
        name: "Rise of Olympus Origin",
      },
{
        href: "/casino/aggapplayngo-kings-mask-eclipse-of-gods",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/KingsMaskEclipseOfGods.webp",
        alt: "King’s Mask Eclipse of Gods",
        name: "King’s Mask Eclipse of Gods",
      },
{
        href: "/casino/aggapplayngo-whispering-winds",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WhisperingWinds.webp",
        alt: "Whispering Winds",
        name: "Whispering Winds",
      },
{
        href: "/casino/aggapplayngo-dansband-pa-turne",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/DansbandPaTurne.webp",
        alt: "Dansband Pa Turne",
        name: "Dansband Pa Turne",
      },
{
        href: "/casino/aggapplayngo-oasis-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/OasisOfDead.webp",
        alt: "Oasis of Dead",
        name: "Oasis of Dead",
      },
{
        href: "/casino/aggapplayngo-journey-to-paris",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/JourneyToParis.webp",
        alt: "Journey to Paris",
        name: "Journey to Paris",
      },
{
        href: "/casino/aggapplayngo-temple-of-tollan",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TempleOfTollan.webp",
        alt: "Temple of Tollan",
        name: "Temple of Tollan",
      },
{
        href: "/casino/aggapplayngo-merlin-realm-of-charm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MerlinRealmOfCharm.webp",
        alt: "Merlin Realm of Charm",
        name: "Merlin Realm of Charm",
      },
{
        href: "/casino/aggapplayngo-gold-of-fortune-god",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/GoldOfFortuneGod.webp",
        alt: "Gold of Fortune God",
        name: "Gold of Fortune God",
      },
{
        href: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-insanity",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RichWildeAndTheTomeOfInsanity.webp",
        alt: "Rich Wilde and the Tome of Insanity",
        name: "Rich Wilde and the Tome of Insanity",
      },
{
        href: "/casino/aggapplayngo-colt-lightning-firestorm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ColtLightningFirestorm.webp",
        alt: "Colt Lightning Firestorm",
        name: "Colt Lightning Firestorm",
      },
{
        href: "/casino/aggapplayngo-spark-of-genius",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SparkOfGenius.webp",
        alt: "Spark of Genius",
        name: "Spark of Genius",
      },
{
        href: "/casino/aggapplayngo-wild-survivor",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildSurvivor.webp",
        alt: "Wild Survivor",
        name: "Wild Survivor",
      },
{
        href: "/casino/aggapplayngo-fulong-88",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/Fulong88.webp",
        alt: "Fulong 88",
        name: "Fulong 88",
      },
{
        href: "/casino/aggapplayngo-the-sword-and-the-grail-excalibur",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TheSwordAndTheGrailExcalibur.webp",
        alt: "The Sword and the Grail Excalibur",
        name: "The Sword and the Grail Excalibur",
      },
{
        href: "/casino/aggapplayngo-boat-bonanza-down-under",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BoatBonanzaDownUnder.webp",
        alt: "Boat Bonanza Down Under",
        name: "Boat Bonanza Down Under",
      },
{
        href: "/casino/aggapplayngo-tomb-of-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TombOfGold.webp",
        alt: "Tomb of Gold",
        name: "Tomb of Gold",
      },
{
        href: "/casino/aggapplayngo-mystery-genie-fortunes-of-the-lamp",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MysteryGenieFortunesOfTheLamp.webp",
        alt: "Mystery Genie Fortunes of the Lamp",
        name: "Mystery Genie Fortunes of the Lamp",
      },
{
        href: "/casino/aggapplayngo-easter-eggspedition",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/EasterEggspedition.webp",
        alt: "Easter Eggspedition",
        name: "Easter Eggspedition",
      },
{
        href: "/casino/aggapplayngo-piranha-pays",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PiranhaPays.webp",
        alt: "Piranha Pays",
        name: "Piranha Pays",
      },
{
        href: "/casino/aggapplayngo-chambers-of-ancients",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/ChambersOfAncients.webp",
        alt: "Chambers of Ancients",
        name: "Chambers of Ancients",
      },
{
        href: "/casino/aggapplayngo-banquet-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BanquetOfDead.webp",
        alt: "Banquet of Dead",
        name: "Banquet of Dead",
      },
{
        href: "/casino/aggapplayngo-legion-gold-unleashed",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LegionGoldUnleashed.webp",
        alt: "Legion Gold Unleashed",
        name: "Legion Gold Unleashed",
      },
{
        href: "/casino/aggapplayngo-undefeated-xerxes",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/UndefeatedXerxes.webp",
        alt: "Undefeated Xerxes",
        name: "Undefeated Xerxes",
      },
{
        href: "/casino/aggapplayngo-lady-of-fortune-remastered",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LadyOfFortuneRemastered.webp",
        alt: "Lady of Fortune Remastered",
        name: "Lady of Fortune Remastered",
      },
{
        href: "/casino/aggapplayngo-stepping-diamonds",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/SteppingDiamonds.webp",
        alt: "Stepping Diamonds",
        name: "Stepping Diamonds",
      },
{
        href: "/casino/aggapplayngo-baron-lord-of-saturday",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BaronLordOfSaturday.webp",
        alt: "Baron Lord of Saturday",
        name: "Baron Lord of Saturday",
      },
{
        href: "/casino/aggapplayngo-beasts-of-fire-maximum",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BeastsOfFireMaximum.webp",
        alt: "Beasts of Fire Maximum",
        name: "Beasts of Fire Maximum",
      },
{
        href: "/casino/aggapplayngo-legion-gold-and-the-sphinx-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LegionGoldAndTheSphinxOfDead.webp",
        alt: "Legion Gold and the Sphinx of Dead",
        name: "Legion Gold and the Sphinx of Dead",
      },
{
        href: "/casino/aggapplayngo-piggy-blitz-disco-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PiggyBlitzDiscoGold.webp",
        alt: "Piggy Blitz Disco Gold",
        name: "Piggy Blitz Disco Gold",
      },
{
        href: "/casino/aggapplayngo-rich-wilde-and-the-pearls-of-vishnu",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/RichWildeAndThePearlsOfVishnu.webp",
        alt: "Rich Wilde and the Pearls of Vishnu",
        name: "Rich Wilde and the Pearls of Vishnu",
      },
{
        href: "/casino/aggapplayngo-boat-bonanza-christmas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/BoatBonanzaChristmas.webp",
        alt: "Boat Bonanza Christmas",
        name: "Boat Bonanza Christmas",
      },
{
        href: "/casino/aggapplayngo-wildest-gambit",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/WildestGambit.webp",
        alt: "Wildest Gambit",
        name: "Wildest Gambit",
      },
{
        href: "/casino/aggapplayngo-lion-saga-odyssey",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LionSagaOdyssey.webp",
        alt: "Lion Saga Odyssey",
        name: "Lion Saga Odyssey",
      },
{
        href: "/casino/aggapplayngo-hot-dog-heist",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/HotDogHeist.webp",
        alt: "Hot Dog Heist",
        name: "Hot Dog Heist",
      },
{
        href: "/casino/aggapplayngo-jolly-roger-wild-kraken",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/JollyRogerWildKraken.webp",
        alt: "Jolly Roger Wild Kraken",
        name: "Jolly Roger Wild Kraken",
      },
{
        href: "/casino/aggapplayngo-midnight-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MidnightGold.webp",
        alt: "Midnight Gold",
        name: "Midnight Gold",
      },
{
        href: "/casino/aggapplayngo-treasures-of-kongar",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TreasuresOfKongar.webp",
        alt: "Treasures of Kongar",
        name: "Treasures of Kongar",
      },
{
        href: "/casino/aggapplayngo-tower-quest-legacy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/TowerQuestLegacy.webp",
        alt: "Tower Quest Legacy",
        name: "Tower Quest Legacy",
      },
{
        href: "/casino/aggapplayngo-legacy-of-gems-blitzways",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LegacyOfGemsBlitzways.webp",
        alt: "Legacy of Gems Blitzways",
        name: "Legacy of Gems Blitzways",
      },
{
        href: "/casino/aggapplayngo-potion-of-madness",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/PotionOfMadness.webp",
        alt: "Potion of Madness",
        name: "Potion of Madness",
      },
{
        href: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/InvadingVegasRevengeOnMars.webp",
        alt: "Invading Vegas Revenge on Mars",
        name: "Invading Vegas Revenge on Mars",
      },
{
        href: "/casino/aggapplayngo-crystal-hall",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/CrystalHall.webp",
        alt: "Crystal Hall",
        name: "Crystal Hall",
      },
{
        href: "/casino/aggapplayngo-myth-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/MythOfDead.webp",
        alt: "Myth of Dead",
        name: "Myth of Dead",
      },
      {
        href: "/casino/aggapplayngo-legion-gold-victory",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/play-n-go/LegionGoldVictory.webp",
        alt: "Legion Gold Victory",
        name: "Legion Gold Victory",
      },
      ],
    },
    relaxGaming: {
      relaxGaming: [
        {
        href: "/casino/qt-bill-and-coin",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/BillAndCoin.webp",
        alt: "bill and coin",
        name: "Bill & Coin",
      },
{
        href: "/casino/qt-lure-of-fortune",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/LureOfFortune.webp",
        alt: "lure of fortune",
        name: "Lure Of Fortune",
      },
{
        href: "/casino/qt-titan-strike",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TitanStrike.webp",
        alt: "titan strike",
        name: "Titan Strike",
      },
{
        href: "/casino/qt-money-train-4",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyTrain4.webp",
        alt: "money train 4",
        name: "Money Train 4",
      },
{
        href: "/casino/qt-joker-split",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/JokerSplit.webp",
        alt: "joker split",
        name: "Joker Split",
      },
{
        href: "/casino/qt-torii-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/ToriiTumble.webp",
        alt: "torii tumble",
        name: "Torii Tumble",
      },
{
        href: "/casino/qt-sloth-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SlothTumble.webp",
        alt: "sloth tumble",
        name: "Sloth Tumble",
      },
{
        href: "/casino/qt-shark-wash",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SharkWash.webp",
        alt: "shark wash",
        name: "Shark Wash",
      },
{
        href: "/casino/qt-banana-town",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/BananaTown.webp",
        alt: "banana town",
        name: "Banana Town",
      },
{
        href: "/casino/qt-beast-mode",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/BeastMode.webp",
        alt: "beast mode",
        name: "Beast Mode",
      },
{
        href: "/casino/qt-blender-blitz",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/BlenderBlitz.webp",
        alt: "blender blitz",
        name: "Blender Blitz",
      },
{
        href: "/casino/qt-book-of-99",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/Bookof99.webp",
        alt: "book of 99",
        name: "Book of 99",
      },
{
        href: "/casino/qt-book-of-power",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/BookOfPower.webp",
        alt: "book of power",
        name: "Book Of Power",
      },
{
        href: "/casino/qt-caveman-bob",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/CavemanBob.webp",
        alt: "caveman bob",
        name: "Caveman Bob",
      },
{
        href: "/casino/qt-chip-spin",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/ChipSpin.webp",
        alt: "chip spin",
        name: "Chip Spin",
      },
{
        href: "/casino/qt-cluster-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/ClusterTumble.webp",
        alt: "cluster tumble",
        name: "Cluster Tumble",
      },
{
        href: "/casino/qt-dead-mans-trail",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/DeadMansTrail.webp",
        alt: "dead mans trail",
        name: "Dead Man's Trail",
      },
{
        href: "/casino/qt-dead-riders-trail",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/DeadRidersTrail.webp",
        alt: "dead riders trail",
        name: "Dead Riders Trail",
      },
{
        href: "/casino/qt-deep-descent",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/DeepDescent.webp",
        alt: "deep descent",
        name: "Deep Descent",
      },
{
        href: "/casino/qt-dragons-awakening",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/DragonsAwakening.webp",
        alt: "dragons awakening",
        name: "Dragons Awakening",
      },
{
        href: "/casino/qt-emeralds-infinity-reels",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/EmeraldsInfinityReels.webp",
        alt: "emeralds infinity reels",
        name: "Emerald's Infinity Reels",
      },
{
        href: "/casino/qt-erik-the-red",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/EriktheRed.webp",
        alt: "erik the red",
        name: "Erik the Red",
      },
{
        href: "/casino/qt-epic-joker",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/EpicJoker.webp",
        alt: "epic joker",
        name: "Epic Joker",
      },
{
        href: "/casino/qt-frequent-flyer",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/FrequentFlyer.webp",
        alt: "frequent flyer",
        name: "Frequent Flyer",
      },
{
        href: "/casino/qt-hazakura-ways",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/HazakuraWays.webp",
        alt: "hazakura ways",
        name: "Hazakura Ways",
      },
{
        href: "/casino/qt-helios-fury",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/HeliosFury.webp",
        alt: "helios fury",
        name: "Helios' Fury",
      },
{
        href: "/casino/qt-hellcatraz",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/Hellcatraz.webp",
        alt: "hellcatraz",
        name: "Hellcatraz",
      },
{
        href: "/casino/qt-heroes-gathering",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/HeroesGathering.webp",
        alt: "heroes gathering",
        name: "Heroes Gathering",
      },
{
        href: "/casino/qt-hex",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/Hex.webp",
        alt: "hex",
        name: "Hex",
      },
{
        href: "/casino/qt-horror-hotel",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/HorrorHotel.webp",
        alt: "horror hotel",
        name: "Horror Hotel",
      },
{
        href: "/casino/qt-hot-rod-racers",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/HotRodRacers.webp",
        alt: "hot rod racers",
        name: "Hot Rod Racers",
      },
{
        href: "/casino/qt-ignite-the-night",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/IgniteTheNight.webp",
        alt: "ignite the night",
        name: "Ignite The Night",
      },
{
        href: "/casino/qt-iron-bank",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/IronBank.webp",
        alt: "iron bank",
        name: "Iron Bank",
      },
{
        href: "/casino/qt-its-time",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/ItsTime.webp",
        alt: "its time",
        name: "It's Time",
      },
{
        href: "/casino/qt-jurassic-party",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/JurassicParty.webp",
        alt: "jurassic party",
        name: "Jurassic Party",
      },
{
        href: "/casino/qt-king-of-kings",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/KingofKings.webp",
        alt: "king of kings",
        name: "King of Kings",
      },
{
        href: "/casino/qt-kluster-krystals-megaclusters",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/KlusterKrystalsMegaclusters.webp",
        alt: "kluster krystals megaclusters",
        name: "Kluster Krystals Megaclusters",
      },
{
        href: "/casino/qt-la-fiesta",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/LaFiesta.webp",
        alt: "la fiesta",
        name: "La Fiesta",
      },
{
        href: "/casino/qt-lets-get-ready-to-rumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/LetsgetreadytoRumble.webp",
        alt: "lets get ready to rumble",
        name: "Let's get ready to Rumble",
      },
{
        href: "/casino/qt-marching-legions",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MarchingLegions.webp",
        alt: "marching legions",
        name: "Marching Legions",
      },
{
        href: "/casino/qt-mega-flip",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MegaFlip.webp",
        alt: "mega flip",
        name: "Mega Flip",
      },
{
        href: "/casino/qt-mega-heist",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MegaHeist.webp",
        alt: "mega heist",
        name: "Mega Heist",
      },
{
        href: "/casino/qt-mega-masks",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MegaMasks.webp",
        alt: "mega masks",
        name: "Mega Masks",
      },
{
        href: "/casino/qt-mega-mine",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MegaMine.webp",
        alt: "mega mine",
        name: "Mega Mine",
      },
{
        href: "/casino/qt-midnight-marauder",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MidnightMarauder.webp",
        alt: "midnight marauder",
        name: "Midnight Marauder",
      },
{
        href: "/casino/qt-money-cart",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyCart.webp",
        alt: "money cart",
        name: "Money Cart",
      },
{
        href: "/casino/qt-money-cart-2",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyCart2.webp",
        alt: "money cart 2",
        name: "Money Cart 2",
      },
{
        href: "/casino/qt-money-cart-3",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyCart3.webp",
        alt: "money cart 3",
        name: "Money Cart 3",
      },
{
        href: "/casino/qt-money-train",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyTrain.webp",
        alt: "money train",
        name: "Money Train",
      },
{
        href: "/casino/qt-money-train-2",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyTrain2.webp",
        alt: "money train 2",
        name: "Money Train 2",
      },
{
        href: "/casino/qt-money-train-3",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MoneyTrain3.webp",
        alt: "money train 3",
        name: "Money Train 3",
      },
{
        href: "/casino/qt-multiplier-odyssey",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MultiplierOdyssey.webp",
        alt: "multiplier odyssey",
        name: "Multiplier Odyssey",
      },
{
        href: "/casino/qt-net-gains",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/NetGains.webp",
        alt: "net gains",
        name: "Net Gains",
      },
{
        href: "/casino/qt-plunderland",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/Plunderland.webp",
        alt: "plunderland",
        name: "Plunderland",
      },
{
        href: "/casino/qt-powerspin",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/Powerspin.webp",
        alt: "powerspin",
        name: "Powerspin",
      },
{
        href: "/casino/qt-ramses-revenge",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/RamsesRevenge.webp",
        alt: "ramses revenge",
        name: "Ramses Revenge",
      },
{
        href: "/casino/qt-sails-of-fortune",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SailsOfFortune.webp",
        alt: "sails of fortune",
        name: "Sails Of Fortune",
      },
{
        href: "/casino/qt-santas-stack",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SantasStack.webp",
        alt: "santas stack",
        name: "Santa's Stack",
      },
{
        href: "/casino/qt-space-miners",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SpaceMiners.webp",
        alt: "space miners",
        name: "Space Miners",
      },
{
        href: "/casino/qt-templar-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TemplarTumble.webp",
        alt: "templar tumble",
        name: "Templar Tumble",
      },
{
        href: "/casino/qt-spirit-of-the-beast",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SpiritoftheBeast.webp",
        alt: "spirit of the beast",
        name: "Spirit of the Beast",
      },
{
        href: "/casino/qt-temple-tumble-megaways",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TempleTumbleMegaways.webp",
        alt: "temple tumble",
        name: "Temple Tumble",
      },
{
        href: "/casino/qt-the-great-pigsby",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TheGreatPigsby.webp",
        alt: "the great pigsby",
        name: "The Great Pigsby",
      },
{
        href: "/casino/qt-tiger-kingdom-infinity-reels",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TigerKingdomInfinityReels.webp",
        alt: "tiger kingdom infinity reels",
        name: "Tiger Kingdom Infinity Reels",
      },
{
        href: "/casino/qt-tnt-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TNTTumble.webp",
        alt: "tnt tumble",
        name: "TNT Tumble",
      },
{
        href: "/casino/qt-top-dawgdollar",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TopDawg.webp",
        alt: "top dawg$",
        name: "Top Dawg$",
      },
{
        href: "/casino/qt-tower-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TowerTumble.webp",
        alt: "tower tumble",
        name: "Tower Tumble",
      },
{
        href: "/casino/qt-trolls-gold",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TrollsGold.webp",
        alt: "trolls gold",
        name: "Troll's Gold",
      },
{
        href: "/casino/qt-volatile-vikings",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/VolatileVikings.webp",
        alt: "volatile vikings",
        name: "Volatile Vikings",
      },
{
        href: "/casino/qt-wild-chapo",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/WildChapo.webp",
        alt: "wild chapo",
        name: "Wild Chapo",
      },
{
        href: "/casino/qt-wild-chapo-2",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/WildChapo2.webp",
        alt: "wild chapo-2",
        name: "Wild Chapo 2",
      },
{
        href: "/casino/qt-wildchemy",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/Wildchemy.webp",
        alt: "wildchemy",
        name: "Wildchemy",
      },
{
        href: "/casino/qt-wild-hike",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/WildHike.webp",
        alt: "wild hike",
        name: "Wild Hike",
      },
{
        href: "/casino/qt-wild-yield",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/WildYield.webp",
        alt: "wild yield",
        name: "Wild Yield",
      },
{
        href: "/casino/qt-zombie-circus",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/ZombieCircus.webp",
        alt: "zombie circus",
        name: "Zombie Circus",
      },
{
        href: "/casino/qt-blackjack-neo",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/BlackjackNeo.webp",
        alt: "blackjack neo",
        name: "Blackjack Neo",
      },
{
        href: "/casino/qt-roulette-nouveau",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/RouletteNouveau.webp",
        alt: "roulette nouveau",
        name: "Roulette Nouveau",
      },
{
        href: "/casino/qt-money-cart-4",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/MONEYCART4.webp",
        alt: "money cart 4",
        name: "MONEY CART 4",
      },
{
        href: "/casino/qt-sweetopia-royale",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SWEETOPIAROYALE.webp",
        alt: "sweetopia royale",
        name: "SWEETOPIA ROYALE",
      },
{
        href: "/casino/qt-firewins-factory",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/FIREWINSFACTORY.webp",
        alt: "firewins factory",
        name: "Firewins Factory",
      },
      
{
        href: "/casino/qt-the-great-pigsby-megapays",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/TheGreatPigsbyMegapays.webp",
        alt: "the great pigsby megapays",
        name: "The Great Pigsby Megapays",
      },
{
        href: "/casino/qt-snake-arena-dream-drop",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/SnakeArenaDreamDrop.webp",
        alt: "snake arena dream drop",
        name: "Snake Arena Dream Drop",
      },
      
{
        href: "/casino/qt-atlantis-crush",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/AtlantisCrush.webp",
        alt: "atlantis crush",
        name: "Atlantis Crush",
      },
{
        href: "/casino/qt-ancient-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/relax-gaming/AncientTumble.webp",
        alt: "ancient tumble",
        name: "Ancient Tumble",
      },
      ],
    },
    habanero: {
      habanero: [
        {
        href: "/casino/qt-fruity-mayan",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FruityMayan.webp",
        alt: "Fruity Mayan",
        name: "Fruity Mayan",
      },
{
        href: "/casino/qt-santas-inn",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SantasInn.webp",
        alt: "Santa's Inn",
        name: "Santa's Inn",
      },
      // ZeusDeluxe: {
      //   href: "/casino/qt-zeus-deluxe",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/ZeusDeluxe.webp",
      //   alt: "Zeus Deluxe",
      //   name: "Zeus Deluxe",
      // },
{
        href: "/casino/qt-fruity-halloween",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FruityHalloween.webp",
        alt: "Fruity Halloween",
        name: "Fruity Halloween",
      },
{
        href: "/casino/qt-slime-party",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SlimeParty.webp",
        alt: "Slime Party",
        name: "Slime Party",
      },
{
        href: "/casino/qt-meow-janken",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MeowJanken.webp",
        alt: "Meow Janken",
        name: "Meow Janken",
      },
{
        href: "/casino/qt-bikini-island-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BikiniIslandDeluxe.webp",
        alt: "Bikini Island Deluxe",
        name: "Bikini Island Deluxe",
      },
{
        href: "/casino/qt-atomic-kittens",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/AtomicKittens.webp",
        alt: "Atomic Kittens",
        name: "Atomic Kittens",
      },
{
        href: "/casino/qt-witches-tome",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WitchesTome.webp",
        alt: "Witches Tome",
        name: "Witches Tome",
      },
{
        href: "/casino/qt-legend-of-nezha",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LegendOfNezha.webp",
        alt: "Legend Of Nezha",
        name: "Legend Of Nezha",
      },
{
        href: "/casino/qt-tooty-fruity-fruits",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TootyFruityFruits.webp",
        alt: "Tooty Fruity Fruits",
        name: "Tooty Fruity Fruits",
      },
{
        href: "/casino/qt-sirenaeurotms-spell",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SirensSpell.webp",
        alt: "Siren’s Spell",
        name: "Siren’s Spell",
      },
{
        href: "/casino/qt-crystopia",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Crystopia.webp",
        alt: "Crystopia",
        name: "Crystopia",
      },
{
        href: "/casino/qt-5-mariachis",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/5Mariachis.webp",
        alt: "5 Mariachis",
        name: "5 Mariachis",
      },
{
        href: "/casino/qt-5-lucky-lions",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/5LuckyLions.webp",
        alt: "5 Lucky Lions",
        name: "5 Lucky Lions",
      },
{
        href: "/casino/qt-12-zodiacs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/12Zodiacs.webp",
        alt: "12 Zodiacs",
        name: "12 Zodiacs",
      },
{
        href: "/casino/qt-arcane-elements",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ArcaneElements.webp",
        alt: "Arcane Elements",
        name: "Arcane Elements",
      },
{
        href: "/casino/qt-before-time-runs-out",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BeforeTimeRunsOut.webp",
        alt: "Before Time Runs Out",
        name: "Before Time Runs Out",
      },
{
        href: "/casino/qt-bird-of-thunder",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BirdofThunder.webp",
        alt: "Bird of Thunder",
        name: "Bird of Thunder",
      },
{
        href: "/casino/qt-bomb-runner",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BombRunner.webp",
        alt: "Bomb Runner",
        name: "Bomb Runner",
      },
{
        href: "/casino/qt-bombs-away",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BombsAway.webp",
        alt: "Bombs Away",
        name: "Bombs Away",
      },
{
        href: "/casino/qt-calaveras-explosivas",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CalaverasExplosivas.webp",
        alt: "Calaveras Explosivas",
        name: "Calaveras Explosivas",
      },
{
        href: "/casino/qt-cake-valley",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CakeValley.webp",
        alt: "Cake Valley",
        name: "Cake Valley",
      },
{
        href: "/casino/qt-candy-tower",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CandyTower.webp",
        alt: "Candy Tower",
        name: "Candy Tower",
      },
{
        href: "/casino/qt-christmas-gift-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ChristmasGiftRush.webp",
        alt: "Christmas Gift Rush",
        name: "Christmas Gift Rush",
      },
{
        href: "/casino/qt-colossal-gems",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ColossalGems.webp",
        alt: "Colossal Gems",
        name: "Colossal Gems",
      },
{
        href: "/casino/qt-coyote-crash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CoyoteCrash.webp",
        alt: "Coyote Crash",
        name: "Coyote Crash",
      },
{
        href: "/casino/qt-disco-beats",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DiscoBeats.webp",
        alt: "Disco Beats",
        name: "Disco Beats",
      },
{
        href: "/casino/qt-dragon-castle",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonCastle.webp",
        alt: "Dragon Castle",
        name: "Dragon Castle",
      },
{
        href: "/casino/qt-dragons-realm",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonsRealm.webp",
        alt: "Dragon's Realm",
        name: "Dragon's Realm",
      },
{
        href: "/casino/qt-dragons-throne",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonsThrone.webp",
        alt: "Dragon’s Throne",
        name: "Dragon’s Throne",
      },
{
        href: "/casino/qt-dragon-tiger-gate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonTigerGate.webp",
        alt: "Dragon Tiger Gate",
        name: "Dragon Tiger Gate",
      },
{
        href: "/casino/qt-egyptian-dreams-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/EgyptianDreamsDeluxe.webp",
        alt: "Egyptian Dreams Deluxe",
        name: "Egyptian Dreams Deluxe",
      },
{
        href: "/casino/qt-fa-cai-shen-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FaCaiShenDeluxe.webp",
        alt: "Fa Cai Shen Deluxe",
        name: "Fa Cai Shen Deluxe",
      },
{
        href: "/casino/qt-fenghuang",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Fenghuang.webp",
        alt: "Fenghuang",
        name: "Fenghuang",
      },
{
        href: "/casino/qt-fire-rooster",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FireRooster.webp",
        alt: "Fire Rooster",
        name: "Fire Rooster",
      },
{
        href: "/casino/qt-fortune-dogs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FortuneDogs.webp",
        alt: "Fortune Dogs",
        name: "Fortune Dogs",
      },
{
        href: "/casino/qt-four-divine-beasts",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FourDivineBeasts.webp",
        alt: "Four Divine Beasts",
        name: "Four Divine Beasts",
      },
{
        href: "/casino/qt-gangsters",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Gangsters.webp",
        alt: "Gangsters",
        name: "Gangsters",
      },
{
        href: "/casino/qt-golden-unicorn-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/GoldenUnicornDeluxe.webp",
        alt: "Golden Unicorn Deluxe",
        name: "Golden Unicorn Deluxe",
      },
{
        href: "/casino/qt-gold-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/GoldRush.webp",
        alt: "Gold Rush",
        name: "Gold Rush",
      },
{
        href: "/casino/qt-happiest-christmas-tree",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HappiestChristmasTree.webp",
        alt: "Happiest Christmas Tree",
        name: "Happiest Christmas Tree",
      },
{
        href: "/casino/qt-happy-ape",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HappyApe.webp",
        alt: "Happy Ape",
        name: "Happy Ape",
      },
{
        href: "/casino/qt-hey-sushi",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HeySushi.webp",
        alt: "Hey Sushi",
        name: "Hey Sushi",
      },
{
        href: "/casino/qt-hot-hot-fruit",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HotHotFruit.webp",
        alt: "Hot Hot Fruit",
        name: "Hot Hot Fruit",
      },
{
        href: "/casino/qt-hot-hot-halloween",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HotHotHalloween.webp",
        alt: "Hot Hot Halloween",
        name: "Hot Hot Halloween",
      },
{
        href: "/casino/qt-indian-cash-catcher",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/IndianCashCatcher.webp",
        alt: "Indian Cash Catcher",
        name: "Indian Cash Catcher",
      },
{
        href: "/casino/qt-jellyfish-flow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/JellyfishFlow.webp",
        alt: "Jellyfish Flow",
        name: "Jellyfish Flow",
      },
{
        href: "/casino/qt-jellyfish-flow-ultra",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/JellyFishFlowUltra.webp",
        alt: "JellyFish Flow Ultra",
        name: "JellyFish Flow Ultra",
      },
{
        href: "/casino/qt-jugglenaut",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Jugglenaut.webp",
        alt: "Jugglenaut",
        name: "Jugglenaut",
      },
{
        href: "/casino/qt-jump",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Jump.webp",
        alt: "Jump",
        name: "Jump",
      },
{
        href: "/casino/qt-knockout-football",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KnockoutFootball.webp",
        alt: "Knockout Football",
        name: "Knockout Football",
      },
{
        href: "/casino/qt-knockout-football-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KnockoutFootballRush.webp",
        alt: "Knockout Football Rush",
        name: "Knockout Football Rush",
      },
{
        href: "/casino/qt-koi-gate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KoiGate.webp",
        alt: "Koi Gate",
        name: "Koi Gate",
      },
{
        href: "/casino/qt-lantern-luck",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LanternLuck.webp",
        alt: "Lantern Luck",
        name: "Lantern Luck",
      },
{
        href: "/casino/qt-laughing-buddha",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LaughingBuddha.webp",
        alt: "Laughing Buddha",
        name: "Laughing Buddha",
      },
{
        href: "/casino/qt-legendary-beasts",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LegendaryBeasts.webp",
        alt: "Legendary Beasts",
        name: "Legendary Beasts",
      },
{
        href: "/casino/qt-london-hunter",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LondonHunter.webp",
        alt: "London Hunter",
        name: "London Hunter",
      },
{
        href: "/casino/qt-loony-blox",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LoonyBlox.webp",
        alt: "Loony Blox",
        name: "Loony Blox",
      },
{
        href: "/casino/qt-lucky-durian",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LuckyDurian.webp",
        alt: "Lucky Durian",
        name: "Lucky Durian",
      },
{
        href: "/casino/qt-lucky-fortune-cat",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LuckyFortuneCat.webp",
        alt: "Lucky Fortune Cat",
        name: "Lucky Fortune Cat",
      },
{
        href: "/casino/qt-lucky-lucky",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LuckyLucky.webp",
        alt: "Lucky Lucky",
        name: "Lucky Lucky",
      },
{
        href: "/casino/qt-magic-oak",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MagicOak.webp",
        alt: "Magic Oak",
        name: "Magic Oak",
      },
{
        href: "/casino/qt-marvelous-furlongs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MarvelousFurlongs.webp",
        alt: "Marvelous Furlongs",
        name: "Marvelous Furlongs",
      },
{
        href: "/casino/qt-mighty-medusa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MightyMedusa.webp",
        alt: "Mighty Medusa",
        name: "Mighty Medusa",
      },
{
        href: "/casino/qt-monster-mash-cash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MonsterMashCash.webp",
        alt: "Monster Mash Cash",
        name: "Monster Mash Cash",
      },
{
        href: "/casino/qt-mount-mazuma",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MountMazuma.webp",
        alt: "Mount Mazuma",
        name: "Mount Mazuma",
      },
{
        href: "/casino/qt-mystic-fortune",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MysticFortune.webp",
        alt: "Mystic Fortune",
        name: "Mystic Fortune",
      },
{
        href: "/casino/qt-mystic-fortune-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MysticFortuneDeluxe.webp",
        alt: "Mystic Fortune Deluxe",
        name: "Mystic Fortune Deluxe",
      },
{
        href: "/casino/qt-naughty-santa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NaughtySanta.webp",
        alt: "Naughty Santa",
        name: "Naughty Santa",
      },
{
        href: "/casino/qt-naughty-wukong",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NaughtyWukong.webp",
        alt: "Naughty Wukong",
        name: "Naughty Wukong",
      },
{
        href: "/casino/qt-new-years-bash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NewYearsBash.webp",
        alt: "New Year's Bash",
        name: "New Year's Bash",
      },
{
        href: "/casino/qt-nine-tails",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NineTails.webp",
        alt: "Nine Tails",
        name: "Nine Tails",
      },
{
        href: "/casino/qt-nuwa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Nuwa.webp",
        alt: "Nuwa",
        name: "Nuwa",
      },
{
        href: "/casino/qt-orbs-of-atlantis",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/OrbsOfAtlantis.webp",
        alt: "Orbs Of Atlantis",
        name: "Orbs Of Atlantis",
      },
{
        href: "/casino/qt-oceans-call",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/OceansCall.webp",
        alt: "Ocean's Call",
        name: "Ocean's Call",
      },
{
        href: "/casino/qt-panda-panda",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PandaPanda.webp",
        alt: "Panda Panda",
        name: "Panda Panda",
      },
{
        href: "/casino/qt-pool-shark",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PoolShark.webp",
        alt: "Pool Shark",
        name: "Pool Shark",
      },
{
        href: "/casino/qt-presto",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Presto.webp",
        alt: "Presto",
        name: "Presto",
      },
{
        href: "/casino/qt-prost",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Prost.webp",
        alt: "Prost",
        name: "Prost",
      },
{
        href: "/casino/qt-pucker-up-prince",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PuckerUpPrince.webp",
        alt: "Pucker Up Prince",
        name: "Pucker Up Prince",
      },
{
        href: "/casino/qt-pumpkin-patch",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PumpkinPatch.webp",
        alt: "Pumpkin Patch",
        name: "Pumpkin Patch",
      },
{
        href: "/casino/qt-rainbow-mania",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RainbowMania.webp",
        alt: "Rainbow Mania",
        name: "Rainbow Mania",
      },
{
        href: "/casino/qt-return-to-the-feature",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ReturnToTheFeature.webp",
        alt: "Return To The Feature",
        name: "Return To The Feature",
      },
{
        href: "/casino/qt-rolling-roger",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RollingRoger.webp",
        alt: "Rolling Roger",
        name: "Rolling Roger",
      },
{
        href: "/casino/qt-roman-empire",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RomanEmpire.webp",
        alt: "Roman Empire",
        name: "Roman Empire",
      },
{
        href: "/casino/qt-ruffled-up",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RuffledUp.webp",
        alt: "Ruffled Up",
        name: "Ruffled Up",
      },
{
        href: "/casino/qt-santas-village",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SantasVillage.webp",
        alt: "Santa’s Village",
        name: "Santa’s Village",
      },
{
        href: "/casino/qt-scopa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Scopa.webp",
        alt: "Scopa",
        name: "Scopa",
      },
{
        href: "/casino/qt-scruffy-scallywags",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ScruffyScallywags.webp",
        alt: "Scruffy Scallywags",
        name: "Scruffy Scallywags",
      },
{
        href: "/casino/qt-shaolin-fortunes",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ShaolinFortunes.webp",
        alt: "Shaolin Fortunes",
        name: "Shaolin Fortunes",
      },
{
        href: "/casino/qt-soju-bomb",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SojuBomb.webp",
        alt: "Soju Bomb",
        name: "Soju Bomb",
      },
{
        href: "/casino/qt-sos",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SOS.webp",
        alt: "S.O.S!",
        name: "S.O.S!",
      },
{
        href: "/casino/qt-space-goonz",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SpaceGoonz.webp",
        alt: "Space Goonz",
        name: "Space Goonz",
      },
{
        href: "/casino/qt-sparta",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Sparta.webp",
        alt: "Sparta",
        name: "Sparta",
      },
{
        href: "/casino/qt-super-strike",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SuperStrike.webp",
        alt: "Super Strike",
        name: "Super Strike",
      },
{
        href: "/casino/qt-super-twister",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SuperTwister.webp",
        alt: "Super Twister",
        name: "Super Twister",
      },
{
        href: "/casino/qt-taberna-de-los-muertos",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TabernaDeLosMuertos.webp",
        alt: "Taberna De Los Muertos",
        name: "Taberna De Los Muertos",
      },
{
        href: "/casino/qt-taberna-de-los-muertos-ultra",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TabernaDeLosMuertosUltra.webp",
        alt: "Taberna De Los Muertos Ultra",
        name: "Taberna De Los Muertos Ultra",
      },
{
        href: "/casino/qt-taiko-beats",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TaikoBeats.webp",
        alt: "Taiko Beats",
        name: "Taiko Beats",
      },
{
        href: "/casino/qt-techno-tumble",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TechnoTumble.webp",
        alt: "Techno Tumble",
        name: "Techno Tumble",
      },
{
        href: "/casino/qt-the-big-deal-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TheBigDealDeluxe.webp",
        alt: "The Big Deal Deluxe",
        name: "The Big Deal Deluxe",
      },
{
        href: "/casino/qt-the-dead-escape",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TheDeadEscape.webp",
        alt: "The Dead Escape",
        name: "The Dead Escape",
      },
{
        href: "/casino/qt-totem-towers",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TotemTowers.webp",
        alt: "Totem Towers",
        name: "Totem Towers",
      },
{
        href: "/casino/qt-tuk-tuk-thailand",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TukTukThailand.webp",
        alt: "Tuk Tuk Thailand",
        name: "Tuk Tuk Thailand",
      },
{
        href: "/casino/qt-ways-of-fortune",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WaysOfFortune.webp",
        alt: "Ways Of Fortune",
        name: "Ways Of Fortune",
      },
{
        href: "/casino/qt-wealth-inn",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WealthInn.webp",
        alt: "Wealth Inn",
        name: "Wealth Inn",
      },
{
        href: "/casino/qt-wicked-witch",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WickedWitch.webp",
        alt: "Wicked Witch",
        name: "Wicked Witch",
      },
{
        href: "/casino/qt-wild-trucks",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WildTrucks.webp",
        alt: "Wild Trucks",
        name: "Wild Trucks",
      },
{
        href: "/casino/qt-wizards-want-war",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WizardsWantWar.webp",
        alt: "Wizards Want War",
        name: "Wizards Want War",
      },
{
        href: "/casino/qt-3-hand-blackjack",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/3HandBlackjack.webp",
        alt: "3 Hand Blackjack",
        name: "3 Hand Blackjack",
      },
{
        href: "/casino/qt-3-hand-blackjack-double-exposure",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/3HandBlackjackDoubleExposure.webp",
        alt: "3 Hand Blackjack Double Exposure",
        name: "3 Hand Blackjack Double Exposure",
      },
{
        href: "/casino/qt-american-blackjack",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/AmericanBlackjack.webp",
        alt: "American Blackjack",
        name: "American Blackjack",
      },
{
        href: "/casino/qt-baccarat",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Baccarat.webp",
        alt: "Baccarat",
        name: "Baccarat",
      },
{
        href: "/casino/qt-baccarat-zero-commission",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BaccaratZeroCommission.webp",
        alt: "Baccarat Zero Commission",
        name: "Baccarat Zero Commission",
      },
{
        href: "/casino/qt-caribbean-holdem",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CaribbeanHoldem.webp",
        alt: "Caribbean Holdem",
        name: "Caribbean Holdem",
      },
{
        href: "/casino/qt-caribbean-stud",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CaribbeanStud.webp",
        alt: "Caribbean Stud",
        name: "Caribbean Stud",
      },


{
        href: "/casino/qt-three-card-poker-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ThreeCardPokerDeluxe.webp",
        alt: "Three Card Poker Deluxe",
        name: "Three Card Poker Deluxe",
      },
{
        href: "/casino/qt-war",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/War.webp",
        alt: "War",
        name: "War",
      },
{
        href: "/casino/qt-valentine-monchy",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ValentineMonchy.webp",
        alt: "Valentine Monchy",
        name: "Valentine Monchy",
      },
{
        href: "/casino/qt-hot-hot-summer",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HotHotSummer.webp",
        alt: "Hot Hot Summer",
        name: "Hot Hot Summer",
      },
      // HauntedHarbor: {
      //   href: "/casino/aggaphabanero-haunted-harbor",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/HauntedHarbor.webp",
      //   alt: "Haunted Harbor",
      //   name: "Haunted Harbor",
      // },
      // GloryOfRome: {
      //   href: "/casino/aggaphabanero-glory-of-rome",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/GloryofRome.webp",
      //   alt: "Glory of Rome",
      //   name: "Glory of Rome",
      // },
{
        href: "/casino/qt-koi-koi-treasure",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KoiKoiTreasure.webp",
        alt: "Koi-Koi Treasure",
        name: "Koi-Koi Treasure",
      },
{
        href: "/casino/qt-waltz-beauty",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WaltzBeauty.webp",
        alt: "Waltz Beauty",
        name: "Waltz Beauty",
      },
{
        href: "/casino/qt-totem-warrior",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TotemWarrior.webp",
        alt: "Totem Warrior",
        name: "Totem Warrior",
      },
{
        href: "/casino/qt-arctic-hunt",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ArcticHunt.webp",
        alt: "Arctic Hunt",
        name: "Arctic Hunt",
      },
{
        href: "/casino/qt-moo-moo-cow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MooMooCow.webp",
        alt: "Moo Moo Cow",
        name: "Moo Moo Cow",
      },
{
        href: "/casino/qt-golden-taj-mahal",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/GoldenTajMahal.webp",
        alt: "Golden Taj Mahal",
        name: "Golden Taj Mahal",
      },
{
        href: "/casino/qt-wild-flow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WildFlow.webp",
        alt: "Wild Flow",
        name: "Wild Flow",
      },
{
        href: "/casino/qt-vampires-fate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/VampiresFate.webp",
        alt: "Vampire's Fate",
        name: "Vampire's Fate",
      },

      ],
    },
    dragoonSoft: {
      dragoonSoft: [
        {
          href: "/casino/aggapdrgs-phoenix",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Phoenix1.webp",
          alt: "Phoenix",
          name: "Phoenix",
        },
  {
          href: "/casino/aggapdrgs-get-money",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GetMoney.webp",
          alt: "Get Money",
          name: "Get Money",
        },
  {
          href: "/casino/aggapdrgs-coin-cat",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CoinCat.webp",
          alt: "Coin Cat",
          name: "Coin Cat",
        },
  {
          href: "/casino/aggapdrgs-acey-deucey",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/AceyDeucey.webp",
          alt: "Acey Deucey",
          name: "Acey Deucey",
        },
  {
          href: "/casino/aggapdrgs-dragon-or-crash",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/DragonOrCrash.webp",
          alt: "Dragon or Crash",
          name: "Dragon or Crash",
        },
  {
          href: "/casino/aggapdrgs-flying-phoenix",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/FlyingPhoenix.webp",
          alt: "Flying Phoenix",
          name: "Flying Phoenix",
        },
  {
          href: "/casino/aggapdrgs-jump-and-jump",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/JumpAndJump.webp",
          alt: "Jump & Jump",
          name: "Jump & Jump",
        },
  {
          href: "/casino/aggapdrgs-ladder-game",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/LadderGame.webp",
          alt: "Ladder Game",
          name: "Ladder Game",
        },
  {
          href: "/casino/aggapdrgs-lets-enhance",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/LetsEnhance.webp",
          alt: "Let's Enhance",
          name: "Let's Enhance",
        },


  {
          href: "/casino/aggapdrgs-cat-fishing",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CatFishing.webp",
          alt: "Cat Fishing",
          name: "Cat Fishing",
        },
  {
          href: "/casino/aggapdrgs-overlord-and-concubine",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/OverlordAndConcubine.webp",
          alt: "Overlord & Concubine",
          name: "Overlord & Concubine",
        },
  {
          href: "/casino/aggapdrgs-3-gods-fishing",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/3GodsFishing.webp",
          alt: "3 Gods Fishing",
          name: "3 Gods Fishing",
        },
  {
          href: "/casino/aggapdrgs-big-hammer",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BigHammer.webp",
          alt: "Big Hammer",
          name: "Big Hammer",
        },
  {
          href: "/casino/aggapdrgs-bingo-fishing",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BingoFishing.webp",
          alt: "Bingo Fishing",
          name: "Bingo Fishing",
        },
  {
          href: "/casino/aggapdrgs-crazy-orb",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CrazyOrb.webp",
          alt: "Crazy Orb",
          name: "Crazy Orb",
        },
  {
          href: "/casino/aggapdrgs-demon-conquered",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/DemonConquered.webp",
          alt: "Demon Conquered",
          name: "Demon Conquered",
        },
  {
          href: "/casino/aggapdrgs-dino-hunter",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/DinoHunter.webp",
          alt: "Dino Hunter",
          name: "Dino Hunter",
        },
  {
          href: "/casino/aggapdrgs-gods-slash-fish",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GodsSlashFish.webp",
          alt: "Gods Slash Fish",
          name: "Gods Slash Fish",
        },
  {
          href: "/casino/aggapdrgs-golden-zuma",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GoldenZuma.webp",
          alt: "Golden Zuma",
          name: "Golden Zuma",
        },
  {
          href: "/casino/aggapdrgs-lets-shoot",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/LetsShoot.webp",
          alt: "Let's Shoot",
          name: "Let's Shoot",
        },
  {
          href: "/casino/aggapdrgs-ocean-lord",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/OceanLord.webp",
          alt: "Ocean Lord",
          name: "Ocean Lord",
        },
  {
          href: "/casino/aggapdrgs-plants-vs-dinos",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/PlantsVsDinos.webp",
          alt: "Plants vs. Dinos",
          name: "Plants vs. Dinos",
        },
  {
          href: "/casino/aggapdrgs-5-god-beast",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/5GodBeast.webp",
          alt: "5 God Beast",
          name: "5 God Beast",
        },
  {
          href: "/casino/aggapdrgs-777",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/777.webp",
          alt: "777",
          name: "777",
        },
  
  {
          href: "/casino/aggapdrgs-arab",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Arab.webp",
          alt: "Arab",
          name: "Arab",
        },
  {
          href: "/casino/aggapdrgs-bakufu-shogun",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BakufuShogun.webp",
          alt: "Bakufu Shogun",
          name: "Bakufu Shogun",
        },
  {
          href: "/casino/aggapdrgs-bengal-tiger",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BengalTiger.webp",
          alt: "Bengal Tiger",
          name: "Bengal Tiger",
        },
  {
          href: "/casino/aggapdrgs-big-diamond",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BigDiamond.webp",
          alt: "Big Diamond",
          name: "Big Diamond",
        },
  {
          href: "/casino/aggapdrgs-bonus-cat",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BonusCat.webp",
          alt: "Bonus Cat",
          name: "Bonus Cat",
        },
  {
          href: "/casino/aggapdrgs-booming-gems",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BoomingGems.webp",
          alt: "Booming Gems",
          name: "Booming Gems",
        },
  {
          href: "/casino/aggapdrgs-buffalo-burst",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BuffaloBurst.webp",
          alt: "Buffalo Burst",
          name: "Buffalo Burst",
        },
  {
          href: "/casino/aggapdrgs-bust-treasury",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/BustTreasury.webp",
          alt: "Bust Treasury",
          name: "Bust Treasury",
        },
  {
          href: "/casino/aggapdrgs-caishen-coming",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CaishenComing.webp",
          alt: "Caishen Coming",
          name: "Caishen Coming",
        },
  {
          href: "/casino/aggapdrgs-candy-dynasty",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CandyDynasty.webp",
          alt: "Candy Dynasty",
          name: "Candy Dynasty",
        },
  {
          href: "/casino/aggapdrgs-chef-lady",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/ChefLady.webp",
          alt: "Chef Lady",
          name: "Chef Lady",
        },
  {
          href: "/casino/aggapdrgs-coin-rat",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CoinRat.webp",
          alt: "Coin Rat",
          name: "Coin Rat",
        },
  {
          href: "/casino/aggapdrgs-crystal-fruits",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/CrystalFruits.webp",
          alt: "Crystal Fruits",
          name: "Crystal Fruits",
        },
  {
          href: "/casino/aggapdrgs-diamond-7",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Diamond7.webp",
          alt: "Diamond 7",
          name: "Diamond 7",
        },
  {
          href: "/casino/aggapdrgs-diamond-mogul",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/DiamondMogul.webp",
          alt: "Diamond Mogul",
          name: "Diamond Mogul",
        },
  {
          href: "/casino/aggapdrgs-doggy-wealth",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/DoggyWealth.webp",
          alt: "Doggy Wealth",
          name: "Doggy Wealth",
        },
  {
          href: "/casino/aggapdrgs-dracula",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Dracula.webp",
          alt: "Dracula",
          name: "Dracula",
        },
  {
          href: "/casino/aggapdrgs-dragonburst",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Dragonburst.webp",
          alt: "Dragonburst",
          name: "Dragonburst",
        },
  {
          href: "/casino/aggapdrgs-dragons-treasure",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/DragonsTreasure.webp",
          alt: "Dragon's Treasure",
          name: "Dragon's Treasure",
        },
  {
          href: "/casino/aggapdrgs-egypt-dynasty",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/EgyptDynasty.webp",
          alt: "Egypt Dynasty",
          name: "Egypt Dynasty",
        },
  {
          href: "/casino/aggapdrgs-egypt-oracle",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/EgyptOracle.webp",
          alt: "Egypt Oracle",
          name: "Egypt Oracle",
        },

  {
          href: "/casino/aggapdrgs-fushen-coming",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/FushenComing.webp",
          alt: "Fushen Coming",
          name: "Fushen Coming",
        },
  {
          href: "/casino/aggapdrgs-get-high",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GetHigh.webp",
          alt: "Get High",
          name: "Get High",
        },
  
  {
          href: "/casino/aggapdrgs-golf",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Golf.webp",
          alt: "Golf",
          name: "Golf",
        },
  {
          href: "/casino/aggapdrgs-grand-sheriff",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GrandSheriff.webp",
          alt: "Grand Sheriff",
          name: "Grand Sheriff",
        },
  {
          href: "/casino/aggapdrgs-great-lion",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GreatLion.webp",
          alt: "Great Lion",
          name: "Great Lion",
        },
  {
          href: "/casino/aggapdrgs-greatest-circus",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/GreatestCircus.webp",
          alt: "Greatest Circus",
          name: "Greatest Circus",
        },
  {
          href: "/casino/aggapdrgs-icy-bar",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/IcyBar.webp",
          alt: "Icy Bar",
          name: "Icy Bar",
        },
  {
          href: "/casino/aggapdrgs-immortal-heroes",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/ImmortalHeroes.webp",
          alt: "Immortal Heroes",
          name: "Immortal Heroes",
        },
  {
          href: "/casino/aggapdrgs-jin-hou-ye",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/JinHouYe.webp",
          alt: "Jin Hou Ye",
          name: "Jin Hou Ye",
        },
  {
          href: "/casino/aggapdrgs-lu-ling-qi",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/LuLingQi.webp",
          alt: "Lu Ling Qi",
          name: "Lu Ling Qi",
        },
  {
          href: "/casino/aggapdrgs-many-beauties",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/ManyBeauties.webp",
          alt: "Many Beauties",
          name: "Many Beauties",
        },
  {
          href: "/casino/aggapdrgs-maya-king",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/MayaKing.webp",
          alt: "Maya King",
          name: "Maya King",
        },
  {
          href: "/casino/aggapdrgs-midas-touch",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/MidasTouch.webp",
          alt: "Midas Touch",
          name: "Midas Touch",
        },
  {
          href: "/casino/aggapdrgs-monkey-king",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/MonkeyKing.webp",
          alt: "Monkey King",
          name: "Monkey King",
        },
  {
          href: "/casino/aggapdrgs-ore-power",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/OrePower.webp",
          alt: "Ore Power",
          name: "Ore Power",
        },
  {
          href: "/casino/aggapdrgs-over-dragons-gate",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/OverDragonsGate.webp",
          alt: "Over Dragon's Gate",
          name: "Over Dragon's Gate",
        },
  {
          href: "/casino/aggapdrgs-pandaria",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Pandaria.webp",
          alt: "Pandaria",
          name: "Pandaria",
        },
  {
          href: "/casino/aggapdrgs-pirate-king",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/PirateKing.webp",
          alt: "Pirate King",
          name: "Pirate King",
        },
  {
          href: "/casino/aggapdrgs-rich-dragon",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/RichDragon.webp",
          alt: "Rich Dragon",
          name: "Rich Dragon",
        },
  {
          href: "/casino/aggapdrgs-rich-lion",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/RichLion.webp",
          alt: "Rich Lion",
          name: "Rich Lion",
        },
  {
          href: "/casino/aggapdrgs-rich-now",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/RichNow.webp",
          alt: "Rich Now",
          name: "Rich Now",
        },
  {
          href: "/casino/aggapdrgs-roll-in-money",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/RollInMoney.webp",
          alt: "Roll in Money",
          name: "Roll in Money",
        },
  {
          href: "/casino/aggapdrgs-roman",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Roman.webp",
          alt: "Roman",
          name: "Roman",
        },
  {
          href: "/casino/aggapdrgs-stone-hominid",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/StoneHominid.webp",
          alt: "Stone Hominid",
          name: "Stone Hominid",
        },
  {
          href: "/casino/aggapdrgs-tiger-lord",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/TigerLord.webp",
          alt: "Tiger Lord",
          name: "Tiger Lord",
        },
  {
          href: "/casino/aggapdrgs-triple-monkey",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/TripleMonkey.webp",
          alt: "Triple Monkey",
          name: "Triple Monkey",
        },
  {
          href: "/casino/aggapdrgs-t-rex",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/TRex.webp",
          alt: "T-Rex",
          name: "T-Rex",
        },
  {
          href: "/casino/aggapdrgs-ultra-treasure",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/UltraTreasure.webp",
          alt: "Ultra Treasure",
          name: "Ultra Treasure",
        },
  {
          href: "/casino/aggapdrgs-wolf-legend",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/WolfLegend.webp",
          alt: "Wolf Legend",
          name: "Wolf Legend",
        },
  {
          href: "/casino/aggapdrgs-worldie",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Worldie.webp",
          alt: "Worldie",
          name: "Worldie",
        },
  {
          href: "/casino/aggapdrgs-you-will-win",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/YouWillWin.webp",
          alt: "You Will Win",
          name: "You Will Win",
        },
  {
          href: "/casino/aggapdrgs-zeus",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/Zeus.webp",
          alt: "Zeus",
          name: "Zeus",
        },
  {
          href: "/casino/aggapdrgs-zhao-yun",
          code: "",
          casino: "Slots",
          provider: "ALT_GAMING_GAP",
          category: "dragoonSoft",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/dragoon-soft/ZhaoYun.webp",
          alt: "Zhao Yun",
          name: "Zhao Yun",
        },
      ],
    },

    mac88: {
      dragontiger: [
        {
          href: "/casino/aggapmac88gaming-dragon-tiger",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "dragontiger",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/dragon-tiger.webp",
          alt: "Dragon Tiger",
          name: "Dragon Tiger",
        },
  {
          href: "/casino/aggapmac88gaming-dragon-tiger-2",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "dragontiger",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/dragon-tiger-2.webp",
          alt: "Dragon Tiger 2",
          name: "Dragon Tiger 2",
        },
  {
          href: "/casino/aggapmac88gaming-dtl",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "dragontiger",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/dtl.webp",
          alt: "Dragon Tiger Lion",
          name: "Dragon Tiger Lion",
        },
  {
          href: "/casino/aggapmac88gaming-1-day-dragon-tiger",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "dragontiger",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/1-day-dragon-tiger.webp",
          alt: "1 Day Dragon Tiger",
          name: "1 Day Dragon Tiger",
        },
      ],
      baccarattab: [
        {
          href: "/casino/aggapmac88gaming-29-baccarat",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "baccarat",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/29-baccarat.webp",
          alt: "29 Baccarat",
          name: "29 Baccarat",
        },
        {
          href: "/casino/aggapmac88gaming-baccarat-one-day",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "baccarat",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/baccarat-one-day.webp",
          alt: "Baccarat One Day",
          name: "Baccarat One Day",
        },
      ],
      sicbo: [
        {
          href: "/casino/aggapmac88gaming-sic-bo",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "baccarat",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/sic-bo.webp",
          alt: "Sic Bo",
          name: "Sic Bo",
        },
      ],
      roulettetab: [
        {
          href: "/casino/aggapmac88gaming-roulette",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "roulette",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/roulette.webp",
          alt: "Roulette",
          name: "Roulette",
        },
      ],
      TeenPattitab: [
        {
          href: "/casino/aggapmac88gaming-poker-1-day",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "poker",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/poker-1-day.webp",
          alt: "Poker 1-Day",
          name: "Poker 1-Day",
        },
        {
          href: "/casino/aggapmac88gaming-poker-20-20",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "poker",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/poker-20-20.webp",
          alt: "Poker 20-20",
          name: "Poker 20-20",
        },
        {
          href: "/casino/aggapmac88gaming-6-player-poker",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "poker",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/6-player-poker.webp",
          alt: "6 Player Poker",
          name: "6 Player Poker",
        },
        {
          href: "/casino/aggapmac88gaming-muflis-teenpatti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/muflis-teenpatti.webp",
          alt: "Muflis Teenpatti",
          name: "Muflis Teenpatti",
        },
  {
          href: "/casino/aggapmac88gaming-two-card-teenpatti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/2-card-teenpatti.webp",
          alt: "Two Card Teenpatti",
          name: "Two Card Teenpatti",
        },
  {
          href: "/casino/aggapmac88gaming-open-teen-patti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/open-teen-patti.webp",
          alt: "Open Teen patti",
          name: "Open Teen patti",
        },
  {
          href: "/casino/aggapmac88gaming-teenpatti-one-day",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/teenpatti-one-day.webp",
          alt: "Teenpatti One Day",
          name: "Teenpatti One Day",
        },
  {
          href: "/casino/aggapmac88gaming-test-teenpatti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/test-teenpatti.webp",
          alt: "Test Teenpatti",
          name: "Test Teenpatti",
        },
  {
          href: "/casino/aggapmac88gaming-20-20-teenpatti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/20-20-teenpatti.webp",
          alt: "20-20 Teenpatti",
          name: "20-20 Teenpatti",
        },
  {
          href: "/casino/aggapmac88gaming-20-20-teenpatti-2",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/20-20-teenpatti-2.webp",
          alt: "20 20 Teenpatti 2",
          name: "20 20 Teenpatti 2",
        },
  {
          href: "/casino/aggapmac88gaming-ak47-teenpatti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/ak47-teenpatti.webp",
          alt: "AK47 Teenpatti",
          name: "AK47 Teenpatti",
        },
  {
          href: "/casino/aggapmac88gaming-instant-teen-patti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/instant-teen-patti.webp",
          alt: "Instant Teen Patti",
          name: "Instant Teen Patti",
        },
      ],
      hiLo: [
        {
          href: "/casino/aggapmac88gaming-high-low",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "hiLo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/high-low.webp",
          alt: "High low",
          name: "High low",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-hi-lo",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "hiLo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/hi-lo.webp",
          alt: "Hi Lo",
          name: "Hi Lo",
        },
      ],
      others: [
        {
          href: "/casino/aggapmac88gaming-bollywood-casino-b",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/bollywood-casino-b.webp",
          alt: "Bollywood Casino B",
          name: "Bollywood Casino B",
        },
  {
          href: "/casino/aggapmac88gaming-casino-war",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/casino-war.webp",
          alt: "Casino War",
          name: "Casino War",
        },
  {
          href: "/casino/aggapmac88gaming-center-card",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/center-card.webp",
          alt: "Center card",
          name: "Center card",
        },
  {
          href: "/casino/aggapmac88gaming-instant-worli",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/instant-worli.webp",
          alt: "Instant worli",
          name: "Instant worli",
        },
  {
          href: "/casino/aggapmac88gaming-note-number",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/note-number.webp",
          alt: "Note Number",
          name: "Note Number",
        },
  {
          href: "/casino/aggapmac88gaming-one-card-20-20",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/one-card-20-20.webp",
          alt: "One Card 20 20",
          name: "One Card 20 20",
        },
  {
          href: "/casino/aggapmac88gaming-one-card-one-day",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/one-card-one-day.webp",
          alt: "One Card One Day",
          name: "One Card One Day",
        },
  {
          href: "/casino/aggapmac88gaming-queen-race",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/queen-race.webp",
          alt: "Queen Race",
          name: "Queen Race",
        },
  {
          href: "/casino/aggapmac88gaming-race-20",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/race-20.webp",
          alt: "Race 20",
          name: "Race 20",
        },
  {
          href: "/casino/aggapmac88gaming-race-to-17",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/race-to-17.webp",
          alt: "Race to 17",
          name: "Race to 17",
        },
  {
          href: "/casino/aggapmac88gaming-race-to-2nd",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/race-to-2nd.webp",
          alt: "Race to 2nd",
          name: "Race to 2nd",
        },
  {
          href: "/casino/aggapmac88gaming-center-card-one-day",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/center-card-one-day.webp",
          alt: "Center Card One Day",
          name: "Center Card One Day",
        },
  {
          href: "/casino/aggapmac88gaming-trio",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/trio.webp",
          alt: "Trio",
          name: "Trio",
        },
  {
          href: "/casino/aggapmac88gaming-worli-matka",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/worli-matka.webp",
          alt: "Worli Matka",
          name: "Worli Matka",
        },
  {
          href: "/casino/aggapmac88gaming-3-cards-judgement",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/3-cards-judgement.webp",
          alt: "3 Cards Judgement",
          name: "3 Cards Judgement",
        },
  {
          href: "/casino/aggapmac88gaming-amar-akbar-anthony",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/amar-akbar-anthony.webp",
          alt: "Amar Akbar Anthony",
          name: "Amar Akbar Anthony",
        },
      ],
      lucky7: [
        {
          href: "/casino/aggapmac88gaming-lucky7",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/lucky7.webp",
          alt: "Lucky 7",
          name: "Lucky 7",
        },
         {
          href: "/casino/aggapmac88gaming-lucky-5",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/lucky-5.webp",
          alt: "Lucky 5",
          name: "Lucky 5",
        },
      ],
      andarbahar: [
        {
          href: "/casino/aggapmac88gaming-andar-bahar",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "andarbahar",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/andar-bahar.webp",
          alt: "Andar Bahar",
          name: "Andar Bahar",
        },
        {
          href: "/casino/aggapmac88gaming-andar-bahar-50",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "andarbahar",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/andar-bahar-50.webp",
          alt: "Andar Bahar 50",
          name: "Andar Bahar 50",
        },
      ],
      cards32: [
        {
          href: "/casino/aggapmac88gaming-32-cards",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/32-cards.webp",
          alt: "32 Cards",
          name: "32 Cards",
        },
      ],
      gameshow: [
        {
          href: "/casino/aggapmac88gaming-dream-wheel",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "liveGameShows",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/dream-wheel.webp",
          alt: "Dream Wheel",
          name: "Dream Wheel",
        },
        {
          href: "/casino/aggapmac88gaming-football-studio",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "liveGameShows",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88/football-studio.webp",
          alt: "Football StudIo",
          name: "Football StudIo",
        },
      ],
    },

    mac88VR: {
      wingo: [
        {
          href: "/casino/aggapmac88gamingvirtual-wingo",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "/casinos",
          imgUrl: "/images/casino/mac88-vr/wingo.jpg",
          alt: "WINGO",
          name: "WINGO",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-wingo3",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "/casinos",
          imgUrl: "/images/casino/mac88-vr/wingo1.jpg",
          alt: "WINGO3",
          name: "WINGO3",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-wingo5",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "/casinos",
          imgUrl: "/images/casino/mac88-vr/wingo5.jpg",
          alt: "WINGO5",
          name: "WINGO5",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-wingo10",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "/casinos",
          imgUrl: "/images/casino/mac88-vr/Wing10.jpg",
          alt: "WINGO10",
          name: "WINGO10",
        },
      ],
      lucky7: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-lucky-7",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-lucky-7.webp",
          alt: "VR Lucky 7",
          name: "VR Lucky 7",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-lucky-5",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/lucky-5.webp",
          alt: "Lucky 5",
          name: "Lucky 5",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-lucky-15",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lucky7",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/lucky-15.webp",
          alt: "Lucky 15",
          name: "Lucky 15",
        },
      ],
      others: [
        {
          href: "/casino/aggapmac88gamingvirtual-center-card-vr",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/center-card-vr.webp",
          alt: "Center Card VR",
          name: "Center Card VR",
        },
        {
        href: "/casino/aggapmac88gamingvirtual-vr-amar-akbar-anthony",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-amar-akbar-anthony.webp",
        alt: "VR Amar Akbar Anthony",
        name: "VR Amar Akbar Anthony",
      },
{
        href: "/casino/aggapmac88gamingvirtual-vr-bollywood-casino",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-bollywood-casino.webp",
        alt: "VR Bollywood Casino",
        name: "VR Bollywood Casino",
      },
{
        href: "/casino/aggapmac88gamingvirtual-vr-casino-meter",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-casino-meter.webp",
        alt: "VR Casino Meter",
        name: "VR Casino Meter",
      },
{
        href: "/casino/aggapmac88gamingvirtual-vr-queen-race",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-queen-race.webp",
        alt: "VR Queen Race",
        name: "VR Queen Race",
      },
{
        href: "/casino/aggapmac88gamingvirtual-vr-race-t20",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-race-20.webp",
        alt: "VR Race T20",
        name: "VR Race T20",
      },
{
        href: "/casino/aggapmac88gamingvirtual-vr-trio",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-trio.webp",
        alt: "VR Trio",
        name: "VR Trio",
      },
{
        href: "/casino/aggapmac88gamingvirtual-vr-worli-matka",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vr-worli-matka.webp",
        alt: "VR Worli Matka",
        name: "VR Worli Matka",
      },
{
        href: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/ball-by-ball-vr.webp",
        alt: "Ball by Ball VR",
        name: "Ball by Ball VR",
      },

{
        href: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/rock-paper-scissors.webp",
        alt: "Rock Paper Scissors",
        name: "Rock Paper Scissors",
      },

{
        href: "/casino/aggapmac88gamingvirtual-vortex",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/vortex.webp",
        alt: "Vortex",
        name: "Vortex",
      },
{
        href: "/casino/aggapmac88gamingvirtual-bolly-kiss",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/bollywood-kiss.webp",
        alt: "Bolly Kiss",
        name: "Bolly Kiss",
      },
{
        href: "/casino/aggapmac88gamingvirtual-plinko",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/plinko.webp",
        alt: "Plinko",
        name: "Plinko",
      },
{
        href: "/casino/aggapmac88gamingvirtual-diamonds",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/diamonds.webp",
        alt: "Diamond",
        name: "Diamond",
      },
{
        href: "/casino/aggapmac88gamingvirtual-limbo",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/limbo.webp",
        alt: "Limbo",
        name: "Limbo",
      },
{
        href: "/casino/aggapmac88gamingvirtual-dice",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/mac88-vr/dice.webp",
        alt: "Dice",
        name: "Dice",
      },

      ],
      dragontiger: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-dragon-tiger",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "dragontiger",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-dragon-tiger.webp",
          alt: "VR Dragon Tiger",
          name: "VR Dragon Tiger",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-vr-20-20-dtl",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-20-20-dtl.webp",
          alt: "VR 20-20 DTL",
          name: "VR 20-20 DTL",
        },
      ],
      TeenPattitab: [
        {
          href: "/casino/aggapmac88gamingvirtual-ak47-vr",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/ak47-vr.webp",
          alt: "AK47 VR",
          name: "AK47 VR",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-vr-20-20-teenpatti",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-20-20-teenpatti.webp",
          alt: "VR 20-20 Teenpatti",
          name: "VR 20-20 Teenpatti",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-vr-2-card-tp",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "teenpatti",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-2-card-tp.webp",
          alt: "VR 2 Card TP",
          name: "VR 2 Card TP",
        },
      ],
      cards32: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-32-cards",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "cards32",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-32-cards.webp",
          alt: "VR 32 Cards",
          name: "VR 32 Cards",
        },
      ],
      andarbahar: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-andar-bahar",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "andarbahar",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-andar-bahar.webp",
          alt: "VR Andar Bahar",
          name: "VR Andar Bahar",
        },
      ],
      hiLo: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-high-low",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "hiLo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/high-low-vr.webp",
          alt: "VR High low",
          name: "VR High low",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "hiLo",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/hi-lo.webp",
          alt: "Hi Lo VR",
          name: "Hi Lo VR",
        },
      ],
      baccarattab: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-29-card-bacarrat",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "baccarat",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/29-baccarat-vr.webp",
          alt: "VR 29 card bacarrat",
          name: "VR 29 card bacarrat",
        },
      ],
      TeenPattitab: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-poker",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "poker",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-poker.webp",
          alt: "VR Poker",
          name: "VR Poker",
        },
      ],
      roulettetab: [
        {
          href: "/casino/aggapmac88gamingvirtual-vr-auto-roulette",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "roulette",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/vr-auto-roulette.webp",
          alt: "VR Auto Roulette",
          name: "VR Auto Roulette",
        },
      ],
      mines: [
        {
          href: "/casino/aggapmac88gamingvirtual-mines",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "mines",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/mines.webp",
          alt: "Mines",
          name: "Mines",
        },
      ],
      crashx: [
        {
          href: "/casino/aggapmac88gamingvirtual-jet-xt",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/jet-xt.webp",
          alt: "Jet XT",
          name: "Jet XT",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-kitex",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/kitex.webp",
          alt: "Kitex",
          name: "Kitex",
        },
        {
          href: "/casino/aggapmac88gamingvirtual-crash-x",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/crash-x.webp",
          alt: "Crash X",
          name: "Crash X",
        },
      ],
      crash: [
        {
          href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "crash",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/mac88-vr/pushpa-rani.webp",
          alt: "Pushpa Rani",
          name: "Pushpa Rani",
        },
      ],
    },

    smartSoft: {
      crashx: [
        {
          href: "/casino/aggapsmartsoftgaming-jetx",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/JetX.webp",
          alt: "JetX",
          name: "JetX",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-jetx3",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/JetX3.webp",
          alt: "JetX3",
          name: "JetX3",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-cricketx",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/CricketX.webp",
          alt: "CricketX",
          name: "CricketX",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-footballx",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/FootballX.webp",
          alt: "FootballX",
          name: "FootballX",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-towerx",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "crashX",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/TowerX.webp",
          alt: "TowerX",
          name: "TowerX",
          providerName: "SmartSoft",
        },
      ],
      others: [
        {
          href: "/casino/aggapsmartsoftgaming-foxy-hot-20",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/FoxyHot20New.webp",
          alt: "Foxy Hot 20",
          name: "Foxy Hot 20",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-plinkox",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/PlinkoX.webp",
          alt: "PlinkoX",
          name: "PlinkoX",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-hunter-x",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/CrazyHuntX.webp",
          alt: "Hunter X",
          name: "Hunter X",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/Jokers4Bonuses.webp",
          alt: "Joker's 4 Bonuses",
          name: "Joker's 4 Bonuses",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-samurai",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/Samurai.webp",
          alt: "Samurai",
          name: "Samurai",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-burning-ice",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/BurningIce.webp",
          alt: "Burning Ice",
          name: "Burning Ice",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-burning-ice-10",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/BurningIce10.webp",
          alt: "Burning Ice 10",
          name: "Burning Ice 10",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-burning-ice-40",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/BurningIce40.webp",
          alt: "Burning Ice 40",
          name: "Burning Ice 40",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-vampires",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/Vampires.webp",
          alt: "Vampires",
          name: "Vampires",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-multi-hot-5",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/MultiHot5.webp",
          alt: "Multi Hot 5",
          name: "Multi Hot 5",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-genies-bonanza",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/GeniesBonanza.webp",
          alt: "Genie's Bonanza",
          name: "Genie's Bonanza",
          providerName: "SmartSoft",
        },
        {
          href: "/casino/aggapsmartsoftgaming-multi-hot-ways",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "others",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/MultiHotWays.webp",
          alt: "Multi Hot Ways",
          name: "Multi Hot Ways",
          providerName: "SmartSoft",
        },
      ],
      crash: [
        {
          href: "/casino/aggapsmartsoftgaming-baloon",
          code: "",
          casino: "SmartSoft",
          provider: "ALT_GAMING_GAP",
          category: "crash",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/smartsoft/Balloon.webp",
          alt: "Balloon",
          name: "Balloon",
          providerName: "SmartSoft",
        },
      ],
    },
  },
  lotterygames: {
    lottery: {
      lottery: [
        {
          href: "/casino/aggaproyalgaming-lottery",
          code: "",
          casino: "royal gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Lottery-Table-Royal.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggaproyalgamingvirtual-vr-lottery",
          code: "",
          casino: "royal gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/VRLottery-Royal.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gaming-lottery",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Lottery-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapevolutiongaming-mega-ball-u6021",
          code: "",
          casino: "Evolution",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/MegaBall-Evo.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggaptvbet-keno",
          code: "",
          casino: "TVBet",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Keno-TVBet.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggaptvbet-fast-keno",
          code: "",
          casino: "TVBet",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/FastKeno-TVBet.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
 
  {
          href: "/casino/aggaphacksawgaming-wheel-92",
          code: "",
          casino: "Hacksaw Gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Wheel94-Hacksaw.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggaphacksawgaming-wheel-94",
          code: "",
          casino: "Hacksaw Gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Wheel92-Hacksaw.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapturbogames-spin-strike",
          code: "",
          casino: "Turbo Games",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/SpinStrike-Turbo.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapcaletagaming-halloween-lotto",
          code: "",
          casino: "Caleta",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/HalloweenLotto-Caleta.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapcaletagaming-bingo-billion-llama",
          code: "",
          casino: "Caleta",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/BingoBillionLlama-Caleta.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapcaletagaming-football-lotto",
          code: "",
          casino: "Caleta",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/FootballLotto-Caleta.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggappopokinstant-magic-idol",
          code: "",
          casino: "Popok Instant",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/MagicIdol-Popok.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggappopokinstant-red-hot-line",
          code: "",
          casino: "Popok Instant",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/RedHotLine-Popok.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
 
  {
          href: "/casino/aggapjiligaming-keno",
          code: "",
          casino: "JiLi Gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Keno-Jili.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapspribe-keno-u1430",
          code: "",
          casino: "Spribe",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Keno-Spribe.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggaproyalgaming-lottery-u8365",
          code: "",
          casino: "royal gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/Lottery-LD-Royal.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-5d-lottery-1",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/VR5DLottery1-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-5d-lottery-3",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/VR5DLottery3-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-5d-lottery-5",
          code: "",
          casino: "Mac88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/VR5DLottery5-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-5d-lottery-10",
          code: "",
          casino: "Mac88 Gaming Virtual",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/VR5DLottery10-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-k3-lottery-1",
          code: "",
          casino: "Mac88 Gaming Virtual",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/K3Lottery1-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-k3-lottery-3",
          code: "",
          casino: "Mac88 Gaming Virtual",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/K3Lottery3-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-k3-lottery-5",
          code: "",
          casino: "Mac88 Gaming Virtual",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/K3Lottery5-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
          code: "",
          casino: "Mac88 Gaming Virtual",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/K3Lottery10-Mac88.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
  {
          href: "/casino/aggapplaytechlive-mega-fire-blaze-lucky-ball-brasileiro",
          code: "",
          casino: "Playtech Live",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/lottery/MegaFireBlazeLBB-Playtech.webp",
          alt: "Lottery",
          name: "Lottery",
          providerName: "lottery",
        },
      ],
    }
  },
  tablegames: {
    tablegames: {
      pascalgames: [
        {
          href: "/casino/aggappascalgaming-hi-lo",
          code: "",
          casino: "pascal",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/hilo.webp",
          alt: "HiLo",
          name: "HiLo",
          providerName: "pascalgames",
        },
        {
          href: "/casino/aggappascal-non-stop-match-u9059",
          code: "",
          casino: "pascal gaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/psc_non-stopmatch.webp",
          alt: "Non-Stop Match",
          name: "Non-Stop Match",
          providerName: "pascalgames",
        },
      ],
      onetouch: [
        {
          href: "/casino/aggaponetouch-royal-riches-roulette",
          code: "",
          casino: "onetouch",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/ont_royalrichesroulette.webp",
          alt: "Royal Riches Roulette",
          name: "Royal Riches Roulette",
          providerName: "onetouch",
        },
        {
          href: "/casino/aggaponetouch-mini-lootbox",
          code: "",
          casino: "onetouch",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/ont_minilootbox.webp",
          alt: "Mini Lootbox",
          name: "Mini Lootbox",
          providerName: "onetouch",
        },
        {
          href: "/casino/aggaponetouch-mini-dice",
          code: "",
          casino: "onetouch",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/ont_minidice.webp",
          alt: "Mini Dice",
          name: "Mini Dice",
          providerName: "onetouch",
        },
        {
          href: "/casino/aggaponetouch-teen-patti-20-20",
          code: "",
          casino: "onetouch",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/ont_teenpatti20-20.webp",
          alt: "Teen Patti 20-20",
          name: "Teen Patti 20-20",
          providerName: "onetouch",
        },


      ],
      live88: [
        {
          href: "/casino/aggaplive88-mini-roulette",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_miniroulette.webp",
          alt: "Mini Roulette",
          name: "Mini Roulette",
          providerName: "live88",
        },
        {
          href: "/casino/aggaplive88-mini-plinko",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_miniplinko.webp",
          alt: "Mini Plinko",
          name: "Mini Plinko",
          providerName: "live88",
        },
        {
          href: "/casino/aggaplive88-mini-hilo",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_minihilo.webp",
          alt: "Mini HiLo",
          name: "Mini HiLo",
          providerName: "live88",
        },
        {
          href: "/casino/aggaplive88-mini-dice",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_minidice.webp",
          alt: "Mini Dice",
          name: "Mini Dice",
          providerName: "live88",
        },
        {
          href: "/casino/aggaplive88-mini-blackjack",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_miniblackjack.webp",
          alt: "Mini Blackjack",
          name: "Mini Blackjack",
          providerName: "live88",
        },
        {
          href: "/casino/aggaplive88-mini-baccarat",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_minibaccarat.webp",
          alt: "Mini Baccarat",
          name: "Mini Baccarat",
          providerName: "live88",
        },
        {
          href: "/casino/aggaplive88-loot-box",
          code: "",
          casino: "live88",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bbl_lootbox.webp",
          alt: "Loot Box",
          name: "Loot Box",
          providerName: "live88",
        },
      ],
      truelabs: [
        {
          href: "/casino/aggaptruelabs-hi-lo",
          code: "",
          casino: "truelabs",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/trf_hi-lo.webp",
          alt: "Hi-Lo",
          name: "Hi-Lo",
          providerName: "truelabs",
        },
      ],
      hacksaw: [
        {
          href: "/casino/aggaphacksawgaming-coins-dare2win-u7524",
          code: "",
          casino: "hacksaw",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/hsg_coinsdare2win92.webp",
          alt: "Coins Dare2Win",
          name: "Coins Dare2Win",
          providerName: "hacksaw",
        },
      ],
      habenero: [
        {
          href: "/casino/aggaphabanero-war",
          code: "",
          casino: "habenero",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/hbo_war.webp",
          alt: "War",
          name: "War",
          providerName: "habenero",
        },
        {
          href: "/casino/aggaphabanero-sic-bo",
          code: "",
          casino: "habenero",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/sicbo.png",
          alt: "Sic Bo",
          name: "Sic Bo",
          providerName: "habenero",
        },
        {
          href: "/casino/aggaphabanero-dragon-tiger",
          code: "",
          casino: "habenero",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/dragontiger.png",
          alt: "Dragon Tiger",
          name: "Dragon Tiger",
          providerName: "habenero",
        },
      ],
      galaxsys: [
        {
          href: "/casino/aggapgalaxsys-sicbo",
          code: "",
          casino: "galaxsys",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/glxsy_sicbo.webp",
          alt: "SicBo",
          name: "SicBo",
          providerName: "galaxsys",
        },
        {
          href: "/casino/aggapgalaxsys-hilo",
          code: "",
          casino: "galaxsys",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/glxsy_hilo.webp",
          alt: "HiLo",
          name: "HiLo",
          providerName: "galaxsys",
        },
      ],
      microgaming: [
        {
          href: "/casino/aggapmicrogaming-andar-bahar-royale",
          code: "",
          casino: "microgaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/mg_slots_andarbaharroyale.webp",
          alt: "Andar Bahar Royale",
          name: "Andar Bahar Royale",
          providerName: "microgaming",
        },
        
      ],
      BGaming: [
        {
          href: "/casino/aggapbgaming-multihand-blackjack-pro-2-u4435",
          code: "",
          casino: "BGaming",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/bgm_multihand_blackjack_pro_2.webp",
          alt: "Multihand Blackjack Pro 2",
          name: "Multihand Blackjack Pro 2",
          providerName: "BGaming",
        },
      ],
      others: [
        {
          href: "/casino/aggaptristar-andar-bahar-2",
          code: "",
          casino: "others",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/tri_andarbahar2.webp",
          alt: "Andar Bahar 2",
          name: "Andar Bahar 2",
          providerName: "others",
        },
        {
          href: "/casino/aggapwinfast-dragons-pot",
          code: "",
          casino: "others",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/wft_dragonspot.webp",
          alt: "Dragon's Pot",
          name: "Dragon's Pot",
          providerName: "others",
        },
        {
          href: "/casino/aggapevolutiongaming-red-baron-a",
          code: "",
          casino: "others",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/evo_red_baron_a.webp",
          alt: "Red Baron A",
          name: "Red Baron A",
          providerName: "others",
        },
        {
          href: "/casino/aggapwinfinity-andar-bahar-x5000",
          code: "",
          casino: "others",
          provider: "ALT_GAMING_GAP",
          category: "lottery",
          homeUrl: "http://localhost:3000/Casino",
          imgUrl: "/images/casino/tablegames/win_andar_bahar_x5000.webp",
          alt: "Andar Bahar x5000",
          name: "Andar Bahar x5000",
          providerName: "others",
        },      
      ],
    },
  },
  slotsgames: {
    netent: {
      netent: [
        {
          redirectUrl: "/casino/ezgne-asgardian-stones",
          code: "1100096",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/AsgardianStones.webp",
          alt: "Asgardian Stones",
          name: "Asgardian Stones",
        },
        {
          redirectUrl: "/casino/ezgne-secrets-of-atlantis",
          code: "1100106",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/SecretsOfAtlantis.webp",
          alt: "Secrets of Atlantis",
          name: "Secrets of Atlantis",
        },
        {
          redirectUrl: "/casino/ezgne-steam-tower",
          code: "1100043",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/SteamTower.webp",
          alt: "Steam Tower",
          name: "Steam Tower",
        },
        {
          redirectUrl: "/casino/ezgne-divine-fortune-megaways",
          code: "1100089",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/DivineFortuneMegaways.webp",
          alt: "Divine Fortune Megaways",
          name: "Divine Fortune Megaways",
        },
        {
          redirectUrl: "/casino/ezgne-fruit-shop-megaways",
          code: "1100094",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/FruitShopMegaways.webp",
          alt: "Fruit Shop Megaways",
          name: "Fruit Shop Megaways",
        },
        {
          redirectUrl: "/casino/ezgne-gorilla-kingdom",
          code: "1100088",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/GorillaKingdom.webp",
          alt: "Gorilla Kingdom",
          name: "Gorilla Kingdom",
        },
        {
          redirectUrl: "/casino/ezgne-aloha-christmas",
          code: "1100032",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/AlohaChristmas.webp",
          alt: "Aloha! Christmas",
          name: "Aloha! Christmas",
        },
        {
          redirectUrl: "/casino/ezgne-aloha-cluster-pays",
          code: "1100033",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/AlohaClusterPays.webp",
          alt: "Aloha! Cluster Pays",
          name: "Aloha! Cluster Pays",
        },
        {
          redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
          code: "1100038",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/WildWildWestTheGreatTrainHeist.webp",
          alt: "Wild Wild West: The Great Train Heist",
          name: "Wild Wild West: The Great Train Heist",
        },
        {
          redirectUrl: "/casino/ezgne-twin-spin-megaways",
          code: "1100039",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/TwinSpinMegaways.webp",
          alt: "Twin Spin Megaways",
          name: "Twin Spin Megaways",
        },
        {
          redirectUrl: "/casino/ezgne-turn-your-fortune",
          code: "1100041",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/TurnYourFortune.webp",
          alt: "Turn Your Fortune",
          name: "Turn Your Fortune",
        },
        {
          redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
          code: "1100078",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/PyramidQuestForImmortality.webp",
          alt: "Pyramid: Quest for Immortality",
          name: "Pyramid: Quest for Immortality",
        },
        {
          redirectUrl: "/casino/ezgne-piggy-riches",
          code: "1100080",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/PiggyRiches.webp",
          alt: "Piggy Riches",
          name: "Piggy Riches",
        },
        {
          redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
          code: "1100081",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/DarkKingForbiddenRiches.webp",
          alt: "Dark King: Forbidden Riches",
          name: "Dark King: Forbidden Riches",
        },
        {
          redirectUrl: "/casino/ezgne-jingle-spin",
          code: "1100082",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/JingleSpin.webp",
          alt: "Jingle Spin",
          name: "Jingle Spin",
        },
        {
          redirectUrl: "/casino/ezgne-jack-hammer",
          code: "1100084",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/JackHammer.webp",
          alt: "Jack Hammer",
          name: "Jack Hammer",
        },
        {
          redirectUrl: "/casino/ezgne-dead-or-alive",
          code: "1100085",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/DeadOrAlive.webp",
          alt: "Dead or Alive",
          name: "Dead or Alive",
        },
        {
          redirectUrl: "/casino/ezgne-dead-or-alive-2",
          code: "1100087",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/DeadOrAlive2.webp",
          alt: "Dead or Alive 2",
          name: "Dead or Alive 2",
        },
        {
          redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
          code: "1100086",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/JackAndTheBeanstalk.webp",
          alt: "Jack and the Beanstalk",
          name: "Jack and the Beanstalk",
        },
        {
          redirectUrl: "/casino/ezgne-elements-the-awakening",
          code: "1100091",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/ElementsTheAwakening.webp",
          alt: "Elements: The Awakening",
          name: "Elements: The Awakening",
        },
        {
          redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
          code: "1100093",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/FinnAndTheSwirlySpin.webp",
          alt: "Finn and the Swirly Spin",
          name: "Finn and the Swirly Spin",
        },
        {
          redirectUrl: "/casino/ezgne-fruit-shop",
          code: "1100095",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/FruitShop.webp",
          alt: "Fruit Shop",
          name: "Fruit Shop",
        },
        {
          redirectUrl: "/casino/ezgne-dead-or-alive-2-feature-buy",
          code: "1100100",
          casino: "ezugi",
          provider: "NetEnt",
          category: "netent",
          homeUrl: "/Slots",
          imgUrl: "/images/casino/netent/DeadOrAlive2FeatureBuy.webp",
          alt: "Dead or Alive 2 Feature Buy",
          name: "Dead or Alive 2 Feature Buy",
        }
      ]
    },
    redtiger: {
      redtiger: [
        {
          redirectUrl: "/casino/ezgrt-dragons-luck",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DragonsLuck.webp",
          alt: "Dragon's Luck",
          name: "Dragon's Luck",
        },
        {
          redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DragonsLuckPowerReels.webp",
          alt: "Dragon's Luck Power Reels",
          name: "Dragon's Luck Power Reels",
        },
        {
          redirectUrl: "/casino/ezgrt-10001-nights",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/10001Nights.webp",
          alt: "10,001 Nights",
          name: "10,001 Nights",
        },
        {
          redirectUrl: "/casino/ezgrt-god-of-wealth",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GodOfWealth.webp",
          alt: "God Of Wealth",
          name: "God Of Wealth",
        },
        {
          redirectUrl: "/casino/ezgrt-pirates-plenty-battle-for-gold",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/PiratesPlentyBattleforGold.webp",
          alt: "Pirates' Plenty Battle for Gold",
          name: "Pirates' Plenty Battle for Gold",
        },
        {
          redirectUrl: "/casino/ezgrt-chinese-treasures",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/ChineseTreasures.webp",
          alt: "Chinese Treasures",
          name: "Chinese Treasures",
        },
        {
          redirectUrl: "/casino/ezgrt-fortune-house",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/FortuneHouse.webp",
          alt: "Fortune House",
          name: "Fortune House",
        },
        {
          redirectUrl: "/casino/ezgrt-dragons-fire",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DragonsFire.webp",
          alt: "Dragon's Fire",
          name: "Dragon's Fire",
        },
        {
          redirectUrl: "/casino/ezgrt-magic-gate",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MagicGate.webp",
          alt: "Magic Gate",
          name: "Magic Gate",
        },
        {
          redirectUrl: "/casino/ezgrt-lucky-fortune-cat",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/LuckyFortuneCat.webp",
          alt: "Lucky Fortune Cat",
          name: "Lucky Fortune Cat",
        },
        {
          redirectUrl: "/casino/ezgrt-dragons-luck-deluxe",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DragonsLuckDeluxe.webp",
          alt: "Dragon's Luck Deluxe",
          name: "Dragon's Luck Deluxe",
        },
        {
          redirectUrl: "/casino/ezgrt-epic-journey",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/EpicJourney.webp",
          alt: "Epic Journey",
          name: "Epic Journey",
        },
        {
          redirectUrl: "/casino/ezgrt-phoenix-fire-power-reels",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/PhoenixFirePowerReels.webp",
          alt: "Phoenix Fire Power Reels",
          name: "Phoenix Fire Power Reels",
        },
        {
          redirectUrl: "/casino/ezgrt-golden-temple",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GoldenTemple.webp",
          alt: "Golden Temple",
          name: "Golden Temple",
        },
        {
          redirectUrl: "/casino/ezgrt-pirates-plenty",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/PiratesPlenty.webp",
          alt: "Pirates' Plenty",
          name: "Pirates' Plenty",
        },

        // continue same pattern for all remaining games...

        {
          redirectUrl: "/casino/ezgrt-atlantis",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/Atlantis.webp",
          alt: "Atlantis",
          name: "Atlantis",
        },
        {
          redirectUrl: "/casino/ezgrt-aztec-spins",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/AztecSpins.webp",
          alt: "Aztec Spins",
          name: "Aztec Spins",
        },
        {
          redirectUrl: "/casino/ezgrt-clash-of-the-beasts",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/ClashoftheBeasts.webp",
          alt: "Clash of the Beasts",
          name: "Clash of the Beasts",
        },
        {
          redirectUrl: "/casino/ezgrt-cirque-de-la-fortune",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/CirquedelaFortune.webp",
          alt: "Cirque de la Fortune",
          name: "Cirque de la Fortune",
        },
        {
          redirectUrl: "/casino/ezgrt-crazy-genie",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/CrazyGenie.webp",
          alt: "Crazy Genie",
          name: "Crazy Genie",
        },
        {
          redirectUrl: "/casino/ezgrt-crystal-mirror",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/CrystalMirror.webp",
          alt: "Crystal Mirror",
          name: "Crystal Mirror",
        },
        {
          redirectUrl: "/casino/ezgrt-devils-number",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DevilsNumber.webp",
          alt: "Devil`s Number",
          name: "Devil`s Number",
        },
        {
          redirectUrl: "/casino/ezgrt-da-vincis-mystery",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DaVincisMystery.webp",
          alt: "Da Vinci`s Mystery",
          name: "Da Vinci`s Mystery",
        },
        {
          redirectUrl: "/casino/ezgrt-dice-dice-dice",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/DiceDiceDice.webp",
          alt: "Dice Dice Dice",
          name: "Dice Dice Dice",
        },
        {
          redirectUrl: "/casino/ezgrt-five-stars-power-reels",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/FiveStarsPowerReels.webp",
          alt: "Five Stars Power Reels",
          name: "Five Stars Power Reels",
        },
        {
          redirectUrl: "/casino/ezgrt-gems-gone-wild",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GemsGoneWild.webp",
          alt: "Gems Gone Wild",
          name: "Gems Gone Wild",
        },
        {
          redirectUrl: "/casino/ezgrt-gems-gone-wild-power-reels",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GemsGoneWildPowerReels.webp",
          alt: "Gems Gone Wild Power Reels",
          name: "Gems Gone Wild Power Reels",
        },
        {
          redirectUrl: "/casino/ezgrt-golden-cryptex",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GoldenCryptex.webp",
          alt: "Golden Cryptex",
          name: "Golden Cryptex",
        },
        {
          redirectUrl: "/casino/ezgrt-golden-leprechaun-megaways",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GoldenLeprechaunMegaways.webp",
          alt: "Golden Leprechaun Megaways",
          name: "Golden Leprechaun Megaways",
        },
        {
          redirectUrl: "/casino/ezgrt-grand-wheel",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GrandWheel.webp",
          alt: "Grand Wheel",
          name: "Grand Wheel",
        },
        {
          redirectUrl: "/casino/ezgrt-golden-tsar",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/GoldenTsar.webp",
          alt: "Golden Tsar",
          name: "Golden Tsar",
        },
        {
          redirectUrl: "/casino/ezgrt-hoard-of-poseidon",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/HoardofPoseidon.webp",
          alt: "Hoard of Poseidon",
          name: "Hoard of Poseidon",
        },
        {
          redirectUrl: "/casino/ezgrt-jewel-scarabs",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/JewelScarabs.webp",
          alt: "Jewel Scarabs",
          name: "Jewel Scarabs",
        },
        {
          redirectUrl: "/casino/ezgrt-legend-of-athena",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/LegendofAthena.webp",
          alt: "Legend of Athena",
          name: "Legend of Athena",
        },
        {
          redirectUrl: "/casino/ezgrt-jingle-bells-power-reels",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/JingleBellsPowerReels.webp",
          alt: "Jingle Bells Power Reels",
          name: "Jingle Bells Power Reels",
        },
        {
          redirectUrl: "/casino/ezgrt-lucky-halloween",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/LuckyHalloween.webp",
          alt: "Lucky Halloween",
          name: "Lucky Halloween",
        },
        {
          redirectUrl: "/casino/ezgrt-lucky-little-devil",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/LuckyLittleDevil.webp",
          alt: "Lucky Little Devil",
          name: "Lucky Little Devil",
        },
        {
          redirectUrl: "/casino/ezgrt-lucky-valentine",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/LuckyValentine.webp",
          alt: "Lucky Valentine",
          name: "Lucky Valentine",
        },
        {
          redirectUrl: "/casino/ezgrt-lucky-wizard",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/LuckyWizard.webp",
          alt: "Lucky Wizard",
          name: "Lucky Wizard",
        },
        {
          redirectUrl: "/casino/ezgrt-masquerade",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/Masquerade.webp",
          alt: "Masquerade",
          name: "Masquerade",
        },
        {
          redirectUrl: "/casino/ezgrt-mayan-gods",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MayanGods.webp",
          alt: "Mayan Gods",
          name: "Mayan Gods",
        },
        {
          redirectUrl: "/casino/ezgrt-mega-dragon",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MegaDragon.webp",
          alt: "Mega Dragon",
          name: "Mega Dragon",
        },
        {
          redirectUrl: "/casino/ezgrt-mega-jade",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MegaJade.webp",
          alt: "Mega Jade",
          name: "Mega Jade",
        },
        {
          redirectUrl: "/casino/ezgrt-mega-rise",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MegaRise.webp",
          alt: "Mega Rise",
          name: "Mega Rise",
        },
        {
          redirectUrl: "/casino/ezgrt-multiplier-riches",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MultiplierRiches.webp",
          alt: "Multiplier Riches",
          name: "Multiplier Riches",
        },
        {
          redirectUrl: "/casino/ezgrt-mystery-reels-megaways",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/MysteryReelsMegaways.webp",
          alt: "Mystery Reels Megaways",
          name: "Mystery Reels Megaways",
        },
        {
          redirectUrl: "/casino/ezgrt-ninja-ways",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/NinjaWays.webp",
          alt: "Ninja Ways",
          name: "Ninja Ways",
        },
        {
          redirectUrl: "/casino/ezgrt-path-of-destiny",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/PathofDestiny.webp",
          alt: "Path of Destiny",
          name: "Path of Destiny",
        },
        {
          redirectUrl: "/casino/ezgrt-persian-fortune",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/PersianFortune.webp",
          alt: "Persian Fortune",
          name: "Persian Fortune",
        },
        {
          redirectUrl: "/casino/ezgrt-reel-heist",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/ReelHeist.webp",
          alt: "Reel Heist",
          name: "Reel Heist",
        },
        {
          redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/RobinHoodsWildForest.webp",
          alt: "Robin Hood`s Wild Forest",
          name: "Robin Hood`s Wild Forest",
        },
        {
          redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/SnowWildAndThe7Features.webp",
          alt: "Snow Wild And The 7 Features",
          name: "Snow Wild And The 7 Features",
        },
        {
          redirectUrl: "/casino/ezgrt-sylvan-spirits",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/SylvanSpirits.webp",
          alt: "Sylvan Spirits",
          name: "Sylvan Spirits",
        },
        {
          redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/TheGreatestTrainRobbery.webp",
          alt: "The Greatest Train Robbery",
          name: "The Greatest Train Robbery",
        },
        {
          redirectUrl: "/casino/ezgrt-the-wild-hatter",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/TheWildHatter.webp",
          alt: "The Wild Hatter",
          name: "The Wild Hatter",
        },
        {
          redirectUrl: "/casino/ezgrt-thors-lightning",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/ThorsLightning.webp",
          alt: "Thor`s Lightning",
          name: "Thor`s Lightning",
        },
        {
          redirectUrl: "/casino/ezgrt-tiki-fruits",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/TikiFruits.webp",
          alt: "Tiki Fruits",
          name: "Tiki Fruits",
        },
        {
          redirectUrl: "/casino/ezgrt-vault-cracker",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/VaultCracker.webp",
          alt: "Vault Cracker",
          name: "Vault Cracker",
        },
        {
          redirectUrl: "/casino/ezgrt-totem-lightning",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/TotemLightning.webp",
          alt: "Totem Lightning",
          name: "Totem Lightning",
        },
        {
          redirectUrl: "/casino/ezgrt-well-of-wishes",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/WellofWishes.webp",
          alt: "Well of Wishes",
          name: "Well of Wishes",
        },
        {
          redirectUrl: "/casino/ezgrt-vault-of-anubis",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/VaultofAnubis.webp",
          alt: "Vault of Anubis",
          name: "Vault of Anubis",
        },
        {
          redirectUrl: "/casino/ezgrt-wild-oclock",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/WildOClock.webp",
          alt: "Wild O`Clock",
          name: "Wild O`Clock",
        },
        {
          redirectUrl: "/casino/ezgrt-wild-cats-multiline",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/WildCatsMultiline.webp",
          alt: "Wild Cats Multiline",
          name: "Wild Cats Multiline",
        },
        {
          redirectUrl: "/casino/ezgrt-yucatans-mystery",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/YucatansMystery.webp",
          alt: "Yucatan`s Mystery",
          name: "Yucatan`s Mystery",
        },
        {
          redirectUrl: "/casino/ezgrt-wild-wild-chest",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/WildWildChest.webp",
          alt: "Wild Wild Chest",
          name: "Wild Wild Chest",
        },
        {
          redirectUrl: "/casino/ezgrt-win-escalator",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "redtiger",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/WinEscalator.webp",
          alt: "Win Escalator",
          name: "Win Escalator",
        },
      ],
      mines: [
        {
          href: "/casino/ezgrt-treasure-mine",
          code: "",
          casino: "ezugi",
          provider: "RedTiger",
          category: "mines",
          homeUrl: "/slots-games",
          imgUrl: "/images/casino/redtiger/TreasureMine.webp",
          alt: "Treasure Mine",
          name: "Treasure Mine",
        },
      ],
    },
  }
};
